<template lang='pug'>
    #GPT.DocumentAgent.main-page.page-noScroll.pb-0.position-relative(:class="user_mode ? 'upportal-color' : 'GPT-color'" style='height: 100vh;')
        record-review-page(ref="recordReviewPage" v-if="recordReviewPageOpen" v-model="recordReviewPageOpen" :agentId="documentAgentDetail.id" :recordId="recordReviewRow && recordReviewRow.object_id" :initialField="recordReviewField" :records="tableData" :breadcrumb-items="breadcrumbs" :columns="currentHeader" :row-data="recordReviewRow" @navigate="onRecordReviewNavigate" @breadcrumb-click="onRecordReviewBreadcrumbClick" @open-file="onRecordReviewOpenFile" @table-down="onRecordReviewTableDown")
            template
                record-data-pane(
                    :rowObjectId="recordReviewRow && recordReviewRow.object_id"
                    :columnDefs="currentHeader"
                    :breadcrumb="breadcrumbs"
                    @on-citation-click="onCitationClick"
                )
            template(v-slot:field-data)
                record-field-list(:column-defs="visibleHeaders" :row-object-id="recordReviewRow && String(recordReviewRow.object_id)" :reference-data="getRowReferenceData(recordReviewRow)" @on-citation-click="onCitationClick")
        portalLoadingSkeleton(v-if='loading')
        div.px-0.pb-0.px-md-2.mt-sm-0.d-flex.flex-column(v-else style="min-height:0; align-items: stretch;")
            licenseWarningBanner
            v-row.d-flex.flex-nowrap.align-center.justify-space-between.pt-5(style="flex: 0 0 auto;")
                .d-flex.align-center
                    v-btn(depressed icon @click="showAgentIconEditDialog" style="max-width: 36; background-color: #FCFBF7;")
                        v-img(:src="select_icon_obj.path" max-width="36")
                    div.d-flex.align-center.flex-grow-1.agent-title-wrap(style="min-height:50px; max-width:800px; min-width:0;")
                        div.px-2.d-flex.align-center.flex-grow-1(v-if="!isEdit" style="min-width:0;")
                            div.agent-title-text(:title="documentAgentDetail.agent_name" style='font-weight:700; font-size:28px; letter-spacing:0.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex:0 1 auto; min-width:0;') {{ documentAgentDetail.agent_name }}
                            span.agent-title-tools.d-flex.align-center
                                v-tooltip(v-if="!isOwner" bottom)
                                    template(v-slot:activator="{ on, attrs }")
                                        v-icon.ml-2(size='20' v-bind="attrs" v-on="on" style="opacity:0.4; cursor:not-allowed;") icon-edit
                                    span {{ $t('WORK_AGENT.NO_EDIT_PERMISSION') }}
                                v-icon.ml-2(v-else-if='!btn_loading' size='20' v-hide-element @click='onEdit()') icon-edit
                            span.agent-title-tools.d-flex.align-center
                                v-progress-circular.ml-2(v-if="documentAgentDetail.status === 'PROCESSING'" indeterminate size="18" width="2" color="#18bedf")
                                v-img.agent-status-icon.ml-2(v-else :src="agentStatusIcon" width="18" height="18" contain)
                        div.px-3.d-flex.align-center.flex-grow-1(v-else style="min-width:0;")
                            v-text-field.agent_title_text_field.v-text-field_low_z-index.pt-0(solo flat dense v-model="documentAgentDetail.agent_name" :rules="nameRules" hide-details ref="firstTextField" style='font-weight:700; font-size:28px; letter-spacing:0.5px; flex:0 1 auto; min-width:0;')
                            span.agent-title-actions.ml-2.d-flex
                                v-icon.mr-1(size='18' color="green" v-if='!btn_loading' @click='onConfirm()') icon-check
                                v-icon(size='18' color="red" v-if='!btn_loading' @click='onCancel()') mdi-window-close
                                v-progress-circular(size='18' v-if='btn_loading' indeterminate color='#18bedf')
                //- Export Action
                v-col(cols="auto" class="d-flex justify-end align-center")
                    v-menu(v-if="isRootTable" v-model="runAgentMenu" offset-y :close-on-content-click="true" content-class="da-run-menu" :z-index="9999" )
                        template(v-slot:activator="{ on, attrs }")
                            .da-run-wrap.mx-1.mt-1(v-bind="attrs")
                                v-btn.da-run-split.white--text( height="30" :ripple="false" color="#14C6DE" depressed :disabled="addBtn_loading || run_agent_loading || !canRunAgent || isUploading || isLicenseBlocking" @click="runAgent({ type: 'default' })" )
                                    span.da-run-left.d-flex.align-center
                                        img.da-run-icon.mr-2(:src="runIcon" :class="{ 'da-run-icon--disabled': addBtn_loading || run_agent_loading || !canRunAgent || isUploading || isLicenseBlocking }" width="16" height="16" alt="run")
                                        span {{$t('DOCUMENT_AGENT.RUN_AGENT')}}
                                    span.da-run-caret(:class="{ 'da-run-caret--active': runAgentMenu }" v-on="on" @click.stop="")
                                        img.da-run-icon(:src="arrowDownWhiteIcon" :class="{ 'da-run-icon--disabled': addBtn_loading || run_agent_loading || !canRunAgent || isUploading || isLicenseBlocking }" width="24" height="24" alt="run")
                        v-list.dense.da-run-menu-list
                            v-list-item(:disabled="isLicenseBlocking" @click="runAgent({ type: 'all' })")
                                img.da-runall-icon(:src="runAllIcon" width="16" height="16" alt="runall")
                                span.da-run-all {{$t('DOCUMENT_AGENT.RUN_ALL')}}
                    v-btn.defaultFontBtn.px-2.my-auto.ml-4(outlined dense height="30" :disabled="!canUsePostRunButtons" @click="exportExcel")
                        v-progress-circular(v-if="addBtn_loading" indeterminate size='20' color='#18bedf' class="m-auto")
                        template(v-else)
                            img(:src="exportXlsIcon" width="20" height="20" alt="xls" :style="{ opacity: canUsePostRunButtons ? 1 : 0.3 }")
                            span.pl-1() {{$t('IMPORT_EXPORT.EXPORT')}} Excel
                    //v-for="(btn, idx) in customizationButtons" 依config內容動態產生多顆按鈕，同時給btn ID當key，避免重複
                    v-btn.defaultFontBtn.px-2.my-auto.ml-4(v-for="(btn, idx) in customizationButtons" :key="(btn?.dialog_path || 'btn') + '-' + idx" outlined dense height="30" :disabled="!canUsePostRunButtons || omsUploading" :loading="btn?.dialog_path === 'omsUploadInvoice' && omsUploading" @click="onCustomizationClick(btn)")
                        documentAgentIcon(name="export-doc-icon" size="20" color="#666" :disabled="!canUsePostRunButtons")
                        span {{ btn.button_name }}
                    v-btn.defaultFontBtn.px-2.my-auto.ml-4(outlined dense height="30" :disabled="run_agent_loading || isUploading" @click="saveAsTemplate")
                        img(:src="saveAsIcon" width="20" height="20" alt="save-as" :style="{ opacity: (run_agent_loading || isUploading) ? 0.3 : 1 }")
                        span.pl-1 {{$t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE')}}
                    v-tooltip(bottom :disabled="isOwner")
                        template(v-slot:activator="{ on, attrs }")
                            span(v-bind="attrs" v-on="on")
                                v-btn.defaultFontBtn.px-2.my-auto.ml-4(outlined dense height="30" :disabled="!isOwner" @click="openAccessDialog")
                                    v-icon.mr-1(size="16") mdi-share-variant
                                    span.pl-1 {{ $t('WORK_AGENT.SHARE_BTN') }}
                        span {{ $t('WORK_AGENT.NO_MANAGE_ACCESS_PERMISSION') }}
            template(v-if="cloudDriveEnabled")
                v-row.d-flex.flex-nowrap.da-cloud-row(style="flex: 0 0 auto;")
                    v-col.d-flex.align-center.pt-0.da-cloud-row(v-if='!o365AccountData')
                        label.ellipsis.pt-1(class='font-weight-bold'  :title='$t("GPT_CLOUD.CONNECT_CLOUD")') {{$t('GPT_CLOUD.CONNECT_CLOUD')}} :
                        //- label.ellipsis.pt-1.pl-3 OneDrive
                        //- [VIEWER_ONEDRIVE_TAKEOVER] 原本連結雲端帳號限 owner（各處含 || !isOwner）。改為任何被分享者皆可連結/重新綁定自己的 OneDrive（接管模式）。還原時於下列三處加回 || !isOwner。
                        v-select.pl-2.ellipsis(flat dense outlined v-model='cloudType' :items='typeList'  item-value="key" item-text="name"  :menu-props='{closeOnClick:true}' style='max-width:150px;width:auto;' :disabled="!cloudDriveEnabled")
                        v-btn.pb-0.btn-add-connection(:disabled="!cloudDriveEnabled" icon @click='showConnectCloudStorageDialog' height='25' width='25' depressed)
                            v-icon(size='16' :color="(!cloudDriveEnabled) ? 'rgba(153,153,153,0.50)' : 'rgba(102,102,102,1)'") icon-add
                    v-col.d-flex.align-center.pt-0.da-cloud-row(cols="auto" v-else)
                        label.ellipsis.pt-1(class='font-weight-bold') {{$t('DOCUMENT_AGENT.LINK_ACCOUNT')}}:
                        span.mt-1.pl-1  {{ o365AccountData.display_name }} ({{ o365AccountData.o365_user_principal_name }})
                        //- [VIEWER_ONEDRIVE_TAKEOVER] 原本解除綁定(X)限 owner：!isOwner 時顯示 disabled + NO_EDIT_PERMISSION tooltip，owner 才有可按的 X。
                        //- 改為任何被分享者皆可按 X 解除目前綁定（連帶清除已同步資料），以便重新綁定自己的 OneDrive（接管）。
                        //- 還原時請改回：span 加 :class="{ 'text--disabled': !isOwner }"；並恢復 v-tooltip(v-if="!isOwner") 的 disabled 分支 + 將下方按鈕改回 v-btn(v-else ...)。
                        v-btn(icon @click='onDeleteO365Account()')
                            v-icon(size='18') icon-remove
                v-row.d-flex.flex-nowrap.mt-0.da-cloud-row
                    //- 讀取資料夾
                    v-col.d-flex.align-center.py-0.da-cloud-row(cols="auto")
                        label.ellipsis(class='font-weight-bold') {{$t('DOCUMENT_AGENT.ACCESS_FOLDER')}}:
                        //- [VIEWER_ONEDRIVE_TAKEOVER] 資料夾區原以 !isOwner 把關。改為 !isBindingMine：只有「目前這組綁定是我自己連結的」才可瀏覽/選/刪資料夾；
                        //- 檢視他人(owner 或其他 viewer)的綁定時維持 disabled（避免看他人 OneDrive 目錄）。viewer 接管重綁後，binding 變成自己的→自動開放選資料夾。
                        //- 還原時將本區 4 處 !isBindingMine 改回 !isOwner（並移除 isBindingMine computed）。
                        span.d-flex.align-center.pl-1(v-if="Object.keys(selectedItems).length > 0")
                            span(:class="{ 'text--disabled': !isBindingMine }") {{selectedItems.full_path}}
                            v-btn.px-0(icon @click='deleteFile' min-width='20' height='20'  depressed :disabled="!o365AccountData || run_agent_loading || isUploading || !isBindingMine")
                                v-icon.mr-1(size='20') mdi-close
                        v-tooltip(v-if="!isBindingMine && Object.keys(selectedItems).length === 0" bottom)
                            template(v-slot:activator="{ on, attrs }")
                                span(v-bind="attrs" v-on="on")
                                    v-btn.defaultFontBtn.px-2.my-auto.ml-4(outlined dense height="30" :disabled="true")
                                        documentAgentIcon.mt-1(name="upload-icon" size="25" color="#666" :disabled="true")
                                        span() {{$t('DOCUMENT_AGENT.ACCESS_FOLDER')}}
                            span {{ $t('WORK_AGENT.NO_EDIT_PERMISSION') }}
                        v-btn.defaultFontBtn.px-2.my-auto.ml-4(v-else-if="Object.keys(selectedItems).length === 0" outlined dense height="30" @click="addFile" :disabled="!o365AccountData || run_agent_loading || isUploading")
                            documentAgentIcon.mt-1(name="upload-icon" size="25" color="#666" :disabled="(!o365AccountData || run_agent_loading || isUploading) ? true : false")
                            span() {{$t('DOCUMENT_AGENT.ACCESS_FOLDER')}}
                        //- [VIEWER_ONEDRIVE_TAKEOVER] 自動同步勾選原以 !isOwner 把關，改為 !isBindingMine（同上：僅自己綁的可設定）。還原時改回 !isOwner。
                        v-checkbox.sync-checkbox.pt-0.ml-2(:label=`$t('DOCUMENT_AGENT.SYNC_UPDATE')` v-model="autoSync" :disabled="!isBindingMine || !o365AccountData || (o365AccountData&& tableData.length==0) || run_agent_loading || addBtn_loading ||isUploading" @change="changeAutoSync" color='#18bedf')
            //- Task 4-1: 排序/篩選狀態列（置於麵包屑上方）
            div.da-sort-filter-bar.d-flex.align-center(v-if="sortList.length > 0 || filterList.length > 0")
                //- 排序區
                div.da-bar-section.d-flex.align-center(v-if="sortList.length > 0")
                    div.da-bar-label.d-flex.align-center
                        img.da-bar-icon(:src="daIcons.sortDefault_Select" width="20" height="20")
                        span.da-bar-label-text.ml-1 {{ $t('DOCUMENT_AGENT.MENU_SORT') }}：
                    v-chip.da-status-chip(
                        v-for="s in sortList"
                        :key="'sort-' + s.flexfield_column"
                        small close close-icon="mdi-close"
                        @click:close="removeSort(s.flexfield_column)"
                    )
                        span {{ getSortChipColumnName(s) }}
                        img.da-chip-dir-icon.ml-1(:src="s.direction === 'asc' ? daIcons.sortUp : daIcons.sortDown" width="20" height="20")
                    v-btn.da-bar-clear-btn(depressed @click="clearAllSorts")
                        img.da-bar-clear-icon(:src="daIcons.clearIcon" width="20" height="20")
                        span {{ $t('DOCUMENT_AGENT.FILTER_CLEAR') }}
                //- 分隔線
                div.da-bar-separator(v-if="sortList.length > 0 && filterList.length > 0")
                //- 篩選區
                div.da-bar-section.d-flex.align-center(v-if="filterList.length > 0")
                    div.da-bar-label.d-flex.align-center
                        img.da-bar-icon(:src="daIcons.filterLabel" width="20" height="20")
                        span.da-bar-label-text.ml-1 {{ $t('DOCUMENT_AGENT.MENU_FILTER') }}：
                    v-chip.da-status-chip(
                        v-for="(f, fi) in filterList"
                        :key="'filter-' + fi"
                        small close close-icon="mdi-close"
                        @click:close="removeFilterByIndex(fi)"
                    )
                        span {{ getFilterChipLabel(f) }}
                    v-btn.da-bar-clear-btn(depressed @click="clearAllFilters")
                        img.da-bar-clear-icon(:src="daIcons.clearIcon" width="20" height="20")
                        span {{ $t('DOCUMENT_AGENT.FILTER_CLEAR') }}
            //- breadcrumbs（置於排序/篩選狀態列下方）
            v-row.justify-space-between.pb-1(style="flex: 0 0 auto;")
                v-breadcrumbs(:items="breadcrumbs")
                    template(v-slot:item="{ item, index }")
                        v-breadcrumbs-item(
                            :href="item.href"
                            :disabled="item.disabled"
                            @click.prevent="onBreadcrumbClick(item)"
                            :class="[{ 'da-bc-active': index === breadcrumbs.length - 1, 'da-bc-normal': index !== breadcrumbs.length - 1 }]"
                            :style="{ color: (index === breadcrumbs.length - 1) ? '#666666' : '#999999' }"
                        ) {{ item.text}}
                div.da-selected-toolbar.d-flex.align-center.pa-2.mt-0.mr-4(v-if="selectedFlexfieldData.length > 0")
                    v-btn.da-record-review-btn.defaultFontBtn.mr-2(v-if="selectedFlexfieldData.length === 1" outlined dense height="30" @click="openRecordReviewFromToolbar")
                        img.da-record-review-icon(:src="recordReviewIcon" width="20" height="20" alt="record review")
                        span.da-record-review-text {{ $t('DOCUMENT_AGENT.RECORD_REVIEW') }}
                    v-btn.da-delete-btn.defaultFontBtn(v-if="isOwner" outlined dense height="30" :disabled="run_agent_loading || bulkDeleteLoading" @click="onClickBulkDelete")
                        v-icon(left size="18" style="color:#666;") icon-remove
                        span(class="da-delete-text") {{$t('GENERAL.DELETE')}}
                div(v-else)
                    v-checkbox.sync-checkbox.pa-2.mt-0.mr-4(v-if="showAllParentCheckBox" :label=`$t('DOCUMENT_AGENT.SHOWALL')` v-model="showAllParent" @change="changeAllParent" color='#18bedf')
            //新增row按鈕
            div.da-table-wrap.position-relative(ref="tableWrap")
                div.da-col-toolbar( ref="colToolbar" @mousemove="onColToolbarMouseMove" @mouseleave="onColToolbarMouseLeave" )
                    div.da-col-toolbar-fixed(:style="{ width: toolbarFixedLeftWidth + 'px' }")
                    div.da-col-toolbar-scroll(ref="colToolbarScroll")
                        div.da-col-toolbar-spacer(:style="{ width: toolbarTableWidth + 'px' }")
                div.da-col-insert-overlay(v-show="canShowColInsertOverlay")
                    div.da-col-highlight-line(:class="{ 'da-col-highlight-line--fileupload': manualUploadMode }" :style="{ left: (colInsertLeftPx) + 'px' }")
                    v-btn.da-insert-col-btn( icon depressed @click.stop="onClickInsertCol(colInsertHover.index)" :style="{ left: (colInsertLeftPx + 1) + 'px' }" )
                        v-icon(size="10") mdi-plus
                v-row.document-agent-table(no-gutters)
                    div.da-ve-table-wrap(:class="{ 'da-ve-table-wrap--empty': showEmpty }")
                        ve-table.da-ve-table(id="loading-container" :columns="columns" :table-data="tableData" :border-around="true" :border-x="true" :border-y="true" :max-height="tableMaxHeight" :column-width-resize-option="columnWidthResizeOption" style="width:100%;" :scroll-width="tableScrollWidth")
                        div.da-empty-absolute-overlay(v-if="showEmpty")
                            span {{ filterList.length > 0 ? $t('DOCUMENT_AGENT.NO_FILTER_RESULT') : $t('DOCUMENT_AGENT.NO_DATA') }}
                            v-btn.da-empty-clear-btn.mt-2(v-if="filterList.length > 0" depressed @click="clearAllFilters")
                                img.da-bar-clear-icon(:src="daIcons.clearIcon" width="20" height="20")
                                span.ml-1 {{ $t('DOCUMENT_AGENT.FILTER_CLEAR_ALL') }}
                    input(:key="fileInputKey" ref="filePicker" type="file" style="display:none" :accept="supportedFileAccept" @change="onFilePicked" )
                    div.da-add-row-area(v-if="canShowCreateRowBtn")
                        v-btn.da-add-btn(tile depressed :disabled="run_agent_loading || addBtn_loading || isUploading" @click="createFlexfieldDataRow" )
                            v-icon(color="#999" size="20") mdi-plus
                    v-menu(v-model="headerMenu.show" :position-x="headerMenu.x" :position-y="headerMenu.y" absolute offset-y :close-on-content-click="false" z-index="200" content-class="da-header-menu")
                        v-list(dense)
                            template(v-for="item in headerActions")
                                v-divider(v-if="item.key.startsWith('__divider')" :key="item.key" style="margin: 4px 0;")
                                //- 排序列：左側「排序」標籤，右側 ↑↓ 按鈕
                                v-list-item.da-sort-menu-row(v-else-if="item.type === 'sort-row'" :key="item.key" style="min-height: 38px; padding-right: 4px;")
                                    v-icon.mr-2(size="18" color="#666" style="flex: none;") {{ item.mdiIcon }}
                                    v-list-item-title(style="font-size: 14px; color: #333; flex: 1;") {{ item.text }}
                                    v-btn.da-sort-dir-btn(icon x-small :title="$t('DOCUMENT_AGENT.SORT_ASC')" @click="onSortMenuClick('asc')")
                                        img(:src="currentHeaderSortDir === 'asc' ? daIcons.sortUp : daIcons.sortDefault" width="20" height="20")
                                    v-btn.da-sort-dir-btn.ml-1(icon x-small :title="$t('DOCUMENT_AGENT.SORT_DESC')" @click="onSortMenuClick('desc')")
                                        img(:src="currentHeaderSortDir === 'desc' ? daIcons.sortDown : daIcons.sortDefault" width="20" height="20")
                                //- 一般列
                                v-list-item(v-else :key="item.key" :disabled="item.key === 'regenerate' && isLicenseBlocking" @click="onClickMenuAction(item.key)" style="min-height: 38px;")
                                    v-icon.mr-2(v-if="item.mdiIcon" size="18" color="#666" style="flex: none;") {{ item.mdiIcon }}
                                    v-img.mr-2(v-else :src="item.icon" width="18" height="18" contain style="flex: none;")
                                    v-list-item-title(style="font-size: 14px; color: #333;") {{item.text}}
            //- Task 3-1: 篩選面板遮罩（點外部關閉）
            div.da-filter-overlay(v-if="filterPanelField !== null" @click="closeFilterPanel")
            //- Task 3-1: 篩選面板（重新設計）
            div.da-filter-panel(v-if="filterPanelField !== null" :style="{ top: filterPanelPos.top + 'px', left: filterPanelPos.left + 'px' }" @click.stop="")
                //- 標題列：篩選標題（每欄僅支援單一條件）
                div.da-filter-panel-header.d-flex.align-center
                    div.d-flex.align-center
                        img.da-bar-icon(:src="daIcons.filterLabel" width="20" height="20")
                        span.da-filter-title.ml-1 {{ $t('DOCUMENT_AGENT.MENU_FILTER') }}
                //- 篩選條件列（單一條件）
                template(v-for="(cond, idx) in filterPanelDraftConditions")
                    div.da-filter-condition-row.d-flex.align-center.mt-2(:key="'cond-' + idx")
                        v-select.da-filter-op-select(
                            v-model="cond.operator"
                            :items="filterPanelOperators"
                            item-text="label"
                            item-value="value"
                            dense outlined hide-details
                            :menu-props="{ offsetY: true, zIndex: 9999 }"
                        )
                        v-text-field.da-filter-value-input.ml-2(
                            v-if="!['is_empty','is_not_empty'].includes(cond.operator)"
                            v-model="cond.value"
                            dense outlined hide-details clearable
                            :type="filterPanelIsNumber ? 'number' : 'text'"
                            @keydown.enter.prevent="submitFilterPanel"
                        )
                    div.da-filter-condition-row.d-flex.align-center.mt-1(v-if="cond.operator === 'between'" :key="'between-' + idx")
                        div.da-filter-op-spacer
                        v-text-field.da-filter-value-input.ml-2(
                            v-model="cond.value2"
                            dense outlined hide-details clearable
                            type="number"
                            @keydown.enter.prevent="submitFilterPanel"
                        )
                //- 動作按鈕
                div.d-flex.justify-space-between.mt-3
                    v-btn.da-filter-clear-btn(depressed @click="clearColumnFilter(filterPanelField)") {{ $t('DOCUMENT_AGENT.FILTER_CLEAR') }}
                    v-btn.da-filter-apply-btn(depressed @click="submitFilterPanel") {{ $t('DOCUMENT_AGENT.FILTER_APPLY') }}
            v-row.align-center.no-gutters.da-footer-row
                v-col(cols="4")
                v-col(cols="4" class="text-center")
                    div.da-ai-disclaimer {{ $t('DOCUMENT_AGENT.AI_DISCLAIMER') }}
                v-col(cols="4" class="d-flex justify-end")
                    .d-flex.align-center.da-pagination-wrap
                        span.da-total-label(style="font-size: 12px;") {{$t('DOCUMENT_AGENT.TOTAL')}}
                        span.da-total-count.ml-1.mr-1(style="font-size: 12px;") {{ totalCount }}
                        v-pagination.DocumentAgentPage( v-model="page" :length="totalPages" :total-visible="5" circle prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right" @input="handlePageChange" )
                        v-select.ml-1.da-page-size-select( :items="[10,20,50]" v-model="itemPerPage" dense outlined hide-details style="max-width: 70px; font-size: 12px;" :menu-props='{ attach: "body", top: true, offsetY: true, nudgeTop: 8, contentClass: "da-page-size-menu", zIndex: 9999 }' @change="handlePageSizeChange" )
                            template(v-slot:selection="{ item }")
                                span {{ item }}
        v-dialog(v-model='saveAsTemplateDialogVisible' width='480' content-class='statusDialog' @keydown.esc='onEmitSaveAsTemplateCancel')
            save-as-template-dialog(
                ref='saveAsTemplateDialog'
                :docAgentId='documentAgentDetail.id || ""'
                :isAdmin='isAdmin'
                @emitSaveAsTemplateSuccess='onEmitSaveAsTemplateSuccess'
                @emitSaveAsTemplateCancel='onEmitSaveAsTemplateCancel'
                @emitSaveAsTemplateError='onEmitSaveAsTemplateError'
            )
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        //- 權限被撤銷後再次進入此 Instance：顯示提示並引導重新整理頁面（persistent，避免使用者點外面關掉後仍卡在無資料畫面）
        v-dialog(v-model='accessRevokedDialog' width='400' persistent content-class='statusDialog')
            v-card
                v-card-title.d-flex.align-center.flex-column.justify-center.py-8
                    v-icon(size='70' color='orange') icon-chat
                v-card-text.pt-0.px-5.pb-6.text-center
                    div.font_arial(style='font-size:16px; font-weight:700; margin-bottom:8px;') {{ $t('WORK_AGENT.ACCESS_REVOKED_TITLE') }}
                    div.font_arial {{ $t('WORK_AGENT.ACCESS_REVOKED_MESSAGE') }}
                v-card-actions.px-2.pb-5
                    v-row
                        v-col.px-2(cols='12')
                            v-btn(:ripple='false' @click='reloadPage' width='100%' height='40' color='#14c6de' depressed dark) {{ $t('WORK_AGENT.REFRESH_PAGE') }}
        v-dialog(v-model='omsDoneDialog' width='400' persistent content-class='statusDialog')
            v-card
                v-card-title.d-flex.align-center.flex-column.justify-center.pt-8
                    v-icon(size='70' color='success') icon-success
                v-card-text.pt-0.px-5.pb-6.text-center
                    div.font_arial {{ omsDoneMessage }}
                v-card-actions.px-2.pb-5
                    v-row
                        v-col.px-2(cols='12')
                            v-btn(:ripple='false' @click='reloadPage' width='100%' height='40' color='success' depressed dark) {{ $t('GENERAL.CONFIRM') }}
        v-dialog(v-model='unsupportedFilesDialog' width='480' content-class='unsupported-files-dialog' @keydown.esc='unsupportedFilesDialog = false')
            unsupported-file-format-dialog(
                :successCount='unsupportedFilesResult.successCount'
                :failCount='unsupportedFilesResult.failCount'
                @confirm='unsupportedFilesDialog = false'
            )
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='selectagenticondialog' max-width="300" max-height="400")
            select-agent-icon-dialog(@emitSelectAgentIconDialog='onEmitSelectAgentIconDialog' :currentIconPath='documentAgentDetail.icon_path' :showAction="true")
        v-dialog(v-model='deleteColumnDialog' width='480' content-class='statusDialog' v-if='deleteColumnDialog')
            delete-column-dialog(
                :columnName='deleteColumnTarget?.label || ""'
                @cancel='onCancelDeleteColumn'
                @confirm='onConfirmDeleteColumn'
            )
        v-dialog(v-model='confirmOneDriveDialog.open' width='480' content-class='statusDialog')
            confirm-update-to-one-drive-dialog(
                @cancel='onCancelConfirmOneDriveDialog'
                @confirm='onConfirmUpdateToOneDriveDialog'
            )
        v-dialog(v-model='columnDialog.open' :key='columnDialog.key' max-width="480" :retain-focus="false" @click:outside="closeColumnDialog" @keydown.esc="closeColumnDialog")
            column-property-dialog(
                ref="columnDialogRef"
                :mode="columnDialog.mode"
                :value="columnDialog.model"
                :insertIndex="columnDialog.insertIndex"
                :originalData="original_data"
                :addBtn_loading="addBtn_loading"
                :userInputList="userInputList"
                :readDocumentsList="readDocumentsList"
                :readDocumentsLoading="readDocumentsLoading"
                :readDocumentsHasMore="readDocuments.hasMore"
                :isRootTable="String(currentTableId) === String(rootTableId)"
                :oneDriveCount="currentOneDriveCount"
                :existingColumns="currentLevelColumns"
                :collectionChildColumns="columnDialog.childCollectionColumns"
                :agentId="documentAgentDetail.id || ''"
                :disabledAll="!isOwner || (columnDialog.mode === 'edit' ? isEditColumnLinkedInput : false)"
                :canRunAgent="canRunAgent"
                @cancel="closeColumnDialog"
                @confirm="onColumnDialogConfirm"
                @searchReadDocuments="searchReadDocuments"
                @loadMoreReadDocuments="loadMoreReadDocuments"
                @resetReadDocuments="resetReadDocuments"
            )
        v-dialog(v-model='connectCloudStorageDialog' max-width='500' content-class='setting-dialog')
            v-card
                v-card-title.d-flex.justify-center.mb-4 {{$t('EMAILSYNC.DIALOG')}}
                v-card-text
                    v-form( ref='form')
                        v-row(no-gutters)
                            v-col.pr-2(cols='12')
                                p {{$t('EMAILSYNC.DIALOG_2')}}
                v-card-actions.pb-4
                    v-row(no-gutters)
                        v-col.pr-2(cols='6')
                            v-btn(:ripple='false' @click='connectCloudStorageDialog = false' width='100%' height='40' color='cancel' depressed dark) {{$t('GENERAL.CANCEL')}}
                        v-col.pl-2(cols='6')
                            v-btn(:ripple='false' @click='onCloudStorageAdd' width='100%' height='40' color='#18bedf' depressed dark) {{$t('GENERAL.ADD')}}
        v-dialog(v-if='selectFileDialog' v-model='selectFileDialog' max-width='900' content-class='statusDialog')
            //- #page-inner.scroll-x.pb-0.height_100vh
            #DocumentAgentSelect
                .upload_page_height.px-3()
                    v-container
                        v-row.mt-2.mb-3.elevation-0(style='font-weight: 700; font-size: 20px; letter-spacing:0.5px; ') {{$t('DOCUMENT_AGENT_SELECT.SELECT_FOLDER')}}
                        //- 連結帳號
                        v-row.mt-2.elevation-0 {{$t('DOCUMENT_AGENT_SELECT.LINK_ACCOUNT')}}: {{ o365AccountData.display_name }} ({{ o365AccountData.o365_user_principal_name }})
                        v-row
                            v-tabs#tab-bg.main-tabs(v-model='cloudTab' background-color='transparent' show-arrows)
                                v-tab(v-for='item in cloudTabs' :key='item.key' :href='`#cloudTab-${item.id}`')
                                    span.spna {{ item.name }}
                        //- my drive
                        v-row
                            v-col.mb-9()
                                v-container.select-file-container(fluid v-if='cloudTab==="cloudTab-1"')
                                    v-row(v-if='files_sync_loading' justify="center" align="center" class="fill-height")
                                        v-progress-circular(indeterminate size='40' color='#18bedf' class="m-auto")
                                    treeselect.mt-1.pl-7(v-model='selectedItems' 
                                        v-if='!cloud_files_loading && !files_sync_loading'
                                        alwaysOpen,
                                        :options="myDrivetreeItems",
                                        :load-options="loadOptions"
                                        :disable-branch-nodes="false"
                                        placeholder=''
                                        noResultsText='No data available'
                                        valueFormat='object',
                                        :matchKeys='match_keys'
                                        :disableFuzzyMatching='true'
                                    )
                                        div(slot="option-label" slot-scope="{ node }" :title='node.label' class="ts-option-label")
                                            img.ts-folder-icon(:src="folderSvg" alt="folder")
                                            span {{ node.label }}
                                        div(slot="value-label" slot-scope="{ node }" class="ts-value-label")
                                            img.ts-folder-icon(:src="folderSvg" alt="folder")
                                            span {{ node.label }}
                        //- //- share with me
                        //- v-row
                        //-     v-col.mb-9()
                        //-         v-container.select-file-container(fluid v-if='cloudTab==="cloudTab-2"')
                        //-             v-row(v-if='files_sync_loading' justify="center" align="center" class="fill-height")
                        //-                 v-progress-circular(indeterminate size='40' color='#18bedf' class="m-auto")
                        //- //- sharepoint
                        //- v-row
                        //-     v-col.mb-9()
                        //-         v-container.select-file-container(fluid v-if='cloudTab==="cloudTab-3"')
                        //-             v-row(v-if='files_sync_loading' justify="center" align="center" class="fill-height")
                        //-                 v-progress-circular(indeterminate size='40' color='#18bedf' class="m-auto")
                div.d-flex.align-center(style='background-color: #f4f4f4; height:60px; padding-right:24px;')
                    v-spacer
                    v-btn.ml-4(
                        :ripple="false" 
                        width="80" 
                        color="cancel" 
                        depressed 
                        outlined 
                        style='font-weight: 700;'  
                        @click="onCancelSelectFileDialog") {{$t('GENERAL.CANCEL')}}
                    v-btn.ml-4(
                        :ripple="false" 
                        width="80" 
                        color='#14C6DE' 
                        depressed 
                        dark 
                        @click="onConfirmSelectFileDialog")
                        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
                        .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.CONFIRM')}}
        v-dialog(v-model='exportDialog' width='480' content-class='statusDialog' v-if='exportDialog')
            exportDoc-dialog()  
        v-dialog(v-model="deleteRowsDialogOpen" max-width="480" content-class="statusDialog")
            delete-rows-dialog(:count="selectedFlexfieldData.length" :tableName="currentTableShortName" @cancel="deleteRowsDialogOpen = false" @confirm="bulkDeleteSelectedRows")
        // ===================== Reference Modal (Updated) =====================
        v-dialog(
            v-model="refPopup.open"
            width="80%"
            content-class="ref-modal-custom"
            transition="scale-transition"
            scrollable
            @click:outside="closeRefPopup"
        )
            v-card.ref-card-container
                v-card-text.pa-0.ref-body-container
                    .ref-two-pane.d-flex.fill-height
                        // Left Pane (Content)
                        .ref-pane.ref-content-left.d-flex.flex-column
                            .ref-pane-header.ref-left-header.px-4.border-none
                                .ref-pane-header__left
                                .ref-pane-header__center
                                    .ref-mode-btns
                                        button.ref-mode-btn(
                                            type="button"
                                            :class="{ 'ref-mode-btn--active': refViewMode === 'text' }"
                                            @click="setRefViewMode('text')"
                                        )
                                            img(:src="require('@/assets/images/type_text_icon.svg')" width="20" height="20")
                                            span {{ $t('DOCUMENT_AGENT.REF_MODE_TEXT') }}
                                        button.ref-mode-btn(
                                            v-if="showRefViewToggle"
                                            type="button"
                                            :class="{ 'ref-mode-btn--active': refViewMode === 'preview' }"
                                            @click="setRefViewMode('preview')"
                                            :disabled="refPdfPreviewLoading"
                                        )
                                            img(:src="require('@/assets/images/only_pdf_icon.svg')" width="20" height="20")
                                            span {{ $t('DOCUMENT_AGENT.REF_MODE_PDF') }}
                                        button.ref-mode-btn(
                                            type="button"
                                            :class="{ 'ref-mode-btn--active': refViewMode === 'web' }"
                                            @click="setRefViewMode('web')"
                                        )
                                            img(:src="require('@/assets/images/search_web.svg')" width="20" height="20")
                                            span {{ $t('DOCUMENT_AGENT.REF_MODE_WEB') }}
                                .ref-pane-header__right
                                    v-btn.ref-action-btn.ref-action-btn--header(
                                        v-if="refViewMode !== 'web' && refPopup.fileUrl"
                                        :ripple="false"
                                        depressed
                                        min-width="0"
                                        height="40"
                                        @click="openRefInNewTab"
                                    )
                                        v-icon.ref-action-btn__icon.mr-1(size="20") mdi-open-in-new
                                        span.ref-action-btn__label Open
                            // Left Body
                            .ref-pane-body.ref-left-body.flex-grow-1
                                .ref-left-scroll.pa-6(v-if="refViewMode === 'text'")
                                    .ref-text-content.ref-md-content(v-if="displayRefContent" v-html="refRenderedHtml")
                                    .ref-empty-state(v-else)
                                        | {{ $t('DOCUMENT_AGENT.NO_REFERENCE_USED') }}
                                .ref-pdf-preview-container(v-else-if="refViewMode === 'preview'")
                                    .ref-pdf-loading(v-if="refPdfPreviewLoading")
                                        v-progress-circular(indeterminate color="#18bedf")
                                    template(v-else-if="refPdfFetchError")
                                        .ref-pdf-error {{ $t('DOCUMENT_AGENT.PDF_PREVIEW_FETCH_ERROR') }}
                                    .ref-left-scroll.pa-6(v-else-if="!refPopup.refs.length")
                                        .ref-empty-state {{ $t('DOCUMENT_AGENT.NO_REFERENCE_USED') }}
                                    template(v-else)
                                        iframe.ref-pdf-iframe(
                                            v-if="refPdfPreviewUrl"
                                            :src="refPdfPreviewUrl"
                                            @error="onRefPdfIframeError"
                                        )
                                        .ref-pdf-error(v-if="refPdfPreviewError") {{ $t('DOCUMENT_AGENT.PDF_PREVIEW_LOAD_ERROR') }}
                                .ref-left-scroll.pa-6(v-else-if="refViewMode === 'web'")
                                    .d-flex.justify-center.align-center.py-8(v-if="refWebSearchLoading")
                                        v-progress-circular(indeterminate color="#18bedf")
                                    template(v-else-if="webCardItems.length")
                                        .ref-search-card-list
                                            .ref-search-card(
                                                v-for="(item, idx) in webCardItems"
                                                :key="`${item.context_id || idx}-${idx}`"
                                            )
                                                .ref-search-card__title-row
                                                    .ref-search-card__index {{ idx + 1 }}
                                                    a.ref-search-card__title(
                                                        v-if="item.url"
                                                        :href="item.url"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    ) {{ item.title || $t('DOCUMENT_AGENT.UNTITLED_REFERENCE') }}
                                                    .ref-search-card__title(v-else) {{ item.title || $t('DOCUMENT_AGENT.UNTITLED_REFERENCE') }}
                                                .ref-search-card__content(v-if="item.content")
                                                    | {{ item.content }}
                                                .ref-search-card__footer(v-if="item.url")
                                                    .ref-search-card__site {{ getRefDomain(item.url) }}
                                    .ref-empty-state(v-else)
                                        | {{ $t('DOCUMENT_AGENT.WEB_SEARCH_EMPTY') }}
                                    template(v-else)
                                        .ref-web-result-item(
                                            v-for="(item, idx) in refWebSearchResults"
                                            :key="item.context_id || idx"
                                        )
                                            .ref-web-result-header.d-flex.align-center.mb-1
                                                img.mr-2(:src="require('@/assets/images/search_web.svg')" width="16" height="16")
                                                span.ref-web-result-title {{ item.title }}
                                            a.ref-web-result-url(
                                                :href="item.url"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            ) {{ item.url }}
                                            .ref-web-result-content.mt-1
                                                span(v-if="refWebExpanded[idx] || item.content.length <= 200") {{ item.content }}
                                                template(v-else)
                                                    span {{ item.content.slice(0, 200) }}...
                                                    span.ref-web-expand-btn(@click="$set(refWebExpanded, idx, true)") {{ $t('DOCUMENT_AGENT.EXPAND') }}
                        // Right Pane
                        .ref-pane.ref-sidebar-right.d-flex.flex-column
                            .ref-pane-header.ref-right-header.d-flex.align-center.pl-4.pr-2.border-none
                                v-icon.mr-2(size="20" color="#444") mdi-format-list-bulleted
                                // 顯示該欄位的名稱 (例如：地號 / 公告土地現值)
                                span.font-weight-bold {{ refPopup.colLabel }}
                                // 不只一個 reference時顯示 1, 2, 3
                                v-spacer
                                v-btn.ref-action-btn.mr-2( :ripple='false' min-width="0" height='40' text @click='copyCell(refPopup.title)')
                                    v-img.ref-action-btn__img(v-if='!copied' src='@/assets/images/copy.svg' max-width='15px' width='15px' contain)
                                    v-img.ref-action-btn__img(v-else src='@/assets/images/copied.svg' max-width='15px' width='15px' contain)
                                    span.ref-action-btn__label.pl-1(v-if='!copied') Copy
                                    span.ref-action-btn__label.pl-1(v-else) Copied
                                v-btn.m-3(icon @click="closeRefPopup" small)
                                    v-icon(size="24") mdi-close
                            // Right body
                            .ref-pane-body.ref-right-body.pa-4.flex-grow-1
                                .sidebar-title-block.mb-4
                                    div.sidebar-value-text(v-html="refTitleRenderedHtml")
                                .ref-index-group.d-flex.flex-wrap
                                    v-btn(
                                        v-for="(cid, idx) in refPopup.refs"
                                        :key="cid"
                                        :ripple="false"
                                        depressed
                                        small
                                        @click="onSelectRefContext(cid, idx, true)"
                                        :class="['mr-2', 'mb-2', 'ref-nav-btn', { 'ref-nav-btn-active': refPopup.activeIndex === idx }]"
                                    ) {{ idx + 1 }}
        v-dialog(
            v-model="consentDialog"
            max-width="480"
            content-class="consent-dialog"
            :persistent="consentSubmitting"
        )
            v-card.consent-card
                v-card-title.consent-title 匯出同意書
                v-card-text.consent-body
                    v-row(v-if="consentLoading" justify="center" align="center" style="min-height: 200px;")
                        v-progress-circular(indeterminate size="40" color="#18bedf")
                    v-row(v-else-if="consentSubmitting" justify="center" align="center" style="min-height: 200px;" class="flex-column")
                        v-progress-circular(indeterminate size="40" color="#18bedf")
                        span.mt-4(style="color: var(--Text-Header-700, #555); text-align: center; font-family: 'Noto Sans TC'; font-size: 18px; font-style: normal; font-weight: 500; line-height: 150%; letter-spacing: 0.09px;") 檔案生成中，所需時間較長，請耐心等候。
                    v-container(v-else fluid class="pa-0")
                        v-row.no-gutters.mb-4(align="center")
                            v-col(cols="3")
                                label.consent-label 專案名稱
                            v-col(cols="9")
                                v-text-field(
                                    v-model="consentForm.project_name"
                                    outlined dense hide-details
                                    class="consent-field"
                                )
                        v-row.no-gutters.mb-4(align="center")
                            v-col(cols="3")
                                label.consent-label 土地清冊
                            v-col(cols="9")
                                v-select(
                                    v-model="consentForm.land_agent_id"
                                    :items="consentOptions.land_agents"
                                    item-text="name"
                                    item-value="id"
                                    outlined dense hide-details
                                    class="consent-field"
                                )
                        v-row.no-gutters(align="start")
                            v-col(cols="3")
                                label.consent-label 建號清冊
                            v-col(cols="9")
                                v-select(
                                    v-model="consentForm.construction_agent_id"
                                    :items="consentOptions.construction_agents"
                                    item-text="name"
                                    item-value="id"
                                    outlined dense hide-details
                                    class="consent-field"
                                )
                v-card-actions.consent-actions
                    v-spacer
                    v-btn.consent-btn.consent-btn-cancel(
                        depressed
                        width="110"
                        :disabled="consentSubmitting"
                        @click="closeConsentDialog"
                    ) 取消
                    v-btn.consent-btn.consent-btn-submit.ml-4(
                        depressed
                        width="110"
                        :disabled="consentLoading || consentSubmitting"
                        @click="submitConsentForm"
                    ) 匯出
        work-agent-access-dialog(v-model="accessDialogOpen" entity-type="INSTANCE" :entity-id="String(documentAgentDetail.id || '')" :entity-name="documentAgentDetail.agent_name || ''")
</template>

<script>
import i18n from '/common/plugins/vue-i18n.js';
import UpGPTDataintegrationService from "@/services/UpGPTDataintegrationService";
import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices"
import O365Service from "@/services/O365Service";
import { fetchExcelDownload } from '@/services/api/fetchExcelDownload';
import loadingOverlay from "@/components/Common/loadingOverlay";
import portalLoadingSkeleton from "@/components/Portal/skeleton/portalLoadingSkeleton.vue";
import licenseWarningBanner from "@/components/Common/licenseWarningBanner.vue";
import selectAgentIconDialog from "@/components/GPT_Dialog/Agent/selectAgentIconDialog";
import documentAgentIcon from "@/components/DocumentAgent/documentAgentIcon";
import exportDocDialog from "@/components/DocumentAgent/exportDocDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import saveAsTemplateDialog from "@/components/DocumentAgent/saveAsTemplateDialog";
import messageDialog from '@/components/Dialog/messageDialog';
import successDialog from "@/components/Dialog/successDialog";
import deleteColumnDialog from "@/components/DocumentAgent/deleteColumnDialog";
import Treeselect from '@riophae/vue-treeselect';
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';
import MarkdownIt from "markdown-it";
import { VProgressCircular, VTooltip, VIcon } from 'vuetify/lib';

// ── 表頭 icon SVG（inline，不依賴外部檔案）
const _enc = (s) => 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s);
const DA_SORT_SVG = (upColor, downColor) => _enc(
  `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">` +
  `<path d="M3.5 11V3M1.5 5l2-2 2 2" stroke="${upColor}" stroke-width="1.3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>` +
  `<path d="M10.5 3v8M8.5 9l2 2 2-2" stroke="${downColor}" stroke-width="1.3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>` +
  `</svg>`
);
const DA_FILTER_SVG = (color, filled) => _enc(
  `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">` +
  (filled
    ? `<path d="M1.5 2h11L8.5 7v4.5l-3-1.5V7z" fill="${color}"/>`
    : `<path d="M1.5 2h11L8.5 7v4.5l-3-1.5V7z" fill="none" stroke="${color}" stroke-width="1.2" stroke-linejoin="round"/>`) +
  `</svg>`
);
const ICONS = {
  sortDefault:    DA_SORT_SVG('#CCCCCC', '#CCCCCC'),   // hover 未排序：兩箭頭都淡
  sortDefault_Select:    DA_SORT_SVG('#444444', '#444444'),   // hover 未排序：兩箭頭都淡
  sortUp:         DA_SORT_SVG('#444444', '#CCCCCC'),   // 升序：上深下淡
  sortDown:       DA_SORT_SVG('#CCCCCC', '#444444'),   // 降序：上淡下深
  filterOff:      DA_FILTER_SVG('#CCCCCC', false),     // hover 無篩選：輪廓淡灰
  filterOn:       DA_FILTER_SVG('#666666', true),      // active 有篩選：填充深灰
  filterLabel:    DA_FILTER_SVG('#666666', false),     // 狀態列 label 用：深灰輪廓
};
const CLEAR_ICON = require('@/assets/images/clear.png');
import deleteRowsDialog from "@/components/DocumentAgent/deleteRowsDialog";
import WorkAgentAccessDialog from "@/components/DocumentAgent/workAgentAccessDialog";
import RecordReviewPage from "@/views-gpt/RecordReviewPage";
import RecordFieldList from "@/components/DocumentAgent/RecordFieldList";
import RecordDataPane from "@/components/DocumentAgent/RecordDataPane";
import ColumnPropertyDialog from "@/components/DocumentAgent/columnPropertyDialog";
import confirmUpdateToOneDriveDialog from "@/components/DocumentAgent/confirmUpdateToOneDriveDialog";
import unsupportedFileFormatDialog from "@/components/DocumentAgent/unsupportedFileFormatDialog";
import DocumentPreviewPane from "@/components/DocumentAgent/DocumentPreviewPane";

const SUPPORTED_FILE_EXTENSIONS = ['.pdf', '.docx', '.pptx', '.xlsx', '.png', '.jpg', '.jpeg', '.gif', '.webp'];
const WEB_SEARCH_ERROR_CODES = new Set([
    'WEB_SEARCH_ERROR_API',
    'WEB_SEARCH_ERROR_QUOTA',
    'WEB_SEARCH_ERROR_SAVE',
    'WEB_SEARCH_ERROR_TIMEOUT',
]);
const DOCUMENT_OUTPUT_ERROR_CODES = new Set([
    'DOCUMENT_OUTPUT_ERROR_SYNTAX',
    'DOCUMENT_OUTPUT_ERROR_MISMATCH',
    'DOCUMENT_OUTPUT_ERROR_RENDER',
]);
// 圖片相關錯誤：後端寫入 JSON 字串 {"code": "...", "params": {...}}，需與後端 document_agent_functions.py 的 IMAGE_ERROR_* 一致
const IMAGE_ERROR_CODES = new Set([
    'IMAGE_ERROR_PDF_PAGES_EXCEEDED',
    'IMAGE_ERROR_INPUT_IMAGES_EXCEEDED',
    'IMAGE_ERROR_MODEL_UNSUPPORTED',
    'INPUT_FILE_ERROR',
    'INPUT_PDF_NOT_READY',
]);
const SUPPORTED_FILE_MIME_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
];

export default {
    name: 'DocumentAgentDetail',
    props: {
        doc_agent_id: {
            type: String,
            require: true,
        },
        doc_agent_data: {
            type: Object
        },
        user_id: {
            type: [Number, String],
            default: null,
        },
    },
    components: {
        loadingOverlay,
        portalLoadingSkeleton,
        licenseWarningBanner,
        Treeselect,
        selectAgentIconDialog,
        documentAgentIcon,
        errorDialog,
        saveAsTemplateDialog,
        messageDialog,
        successDialog,
        exportDocDialog,
        ColumnPropertyDialog,
        deleteColumnDialog,
        deleteRowsDialog,
        confirmUpdateToOneDriveDialog,
        unsupportedFileFormatDialog,
        RecordReviewPage,
        RecordFieldList,
        DocumentPreviewPane,
        RecordDataPane,
        WorkAgentAccessDialog,
    },
    data(){
        return{
            user_mode: true,
            loading: false, //skelton load
            accessDialogOpen: false,
            addBtn_loading: false,
            run_agent_loading: false,
            isRunning: false,
            documentAgentDetail: {},
            originDocumentAgentDetail: {},
            select_icon_obj: { name: "default", path: require("@/assets/images/agent_icon/default.png") },
            isEdit:false,
            btn_loading: false,
            o365AccountData: null,
            typeList: [
                { key: "ONEDRIVE", name: 'OneDrive' },
            ],
            cloudType: "ONEDRIVE",
            can_cloud_drive:true,
            connectCloudStorageDialog: false,
            currentUrl: '',
            selectFileDialog: false,
            cloudTab: null,
            cloudTabs:[
                {
                    id: 1,
                    key: 'my_drive',
                    name: i18n.t('GPT_CLOUD.MY_DRIVE')
                },
                // TODO: #7421 隱藏尚未開發的功能:「已共用」和「Sharepoint」還沒有開發所以先把這兩個tab隱藏掉, 等有串接好之後再顯示回來
                // {
                //     id: 2,
                //     key: 'share_with_me',
                //     name: i18n.t('GPT_CLOUD.SHARE_WITH_ME')
                // },
                // {
                //     id: 3,
                //     key: 'sharepoint',
                //     name: i18n.t('GPT_CLOUD.SHAREPOINT')
                // },
            ],
            myDrivetreeItems: [],
            selectedItems: {},
            cloud_files_loading:false,
            files_sync_loading:false,
            // loadedPathSet: new Set(),
            driveCurrentPath: "/", 
            match_keys : ['file_path','id'],
            cloud_id:null,
            columns: [{ field: "index", key: "index", title: "", minWidth: 50, maxWidth: 50, align: "center" ,fixed: "left",
            renderBodyCell: ({ rowIndex }) => { return rowIndex+1 }, }],
            loadingInstance: null,  //放在DATA()，避免多次點擊多次loading殘留
            columnWidthResizeOption: {
                enable: true,
                minWidth: 180,
                sizeChange: ({column, differWidth, columnWidth}) => {
                    this.columnResizeInfo.column = column;
                    this.columnResizeInfo.differWidth = differWidth;
                    this.columnResizeInfo.columnWidth = columnWidth;
                    this.$nextTick(() => this.syncColToolbarWidths()); // 更新按鈕及藍線位置
                }
            },
            columnResizeInfo: {
                column: "",
                differWidth: "",
                columnWidth: "",
                tableWidth: "",
            },
            headerMenu: {
                show: false,
                col: null,
                x: 0,
                y: 0
            },
            page: 1,
            pageCount: 0,
            itemPerPage: 20,
            totalCount:0,           //計算總筆數
            totalPages:1,           //計算總頁數(會隨每頁觀看數調整)
            pageReqSeq: 0,          // 每次分頁請求
            pageReqInFlight: false, // 避免同時重疊
            sortList: [],           // 目前生效的排序清單 [{ flexfield_column, direction }]
            filterList: [],         // 目前生效的篩選清單 [{ flexfield_column, operator, value, value2 }]
            filterPanelField: null,  // 開啟中的篩選面板欄位 (null = 無)
            filterPanelPos: { top: 0, left: 0 }, // 篩選面板 viewport 定位
            filterPanelDraftConditions: [],  // [{ operator, value, value2 }]
            tableConfigurations: [],
            rootTableId: null,
            currentTableId: null,
            tableData: [],
            referenceMap: {},
            refPopup: {
                open: false,
                rowObjectId: null,
                col: null,
                refs: [],
                activeIndex: 0,
                activeContextId: null,
                loading: false,
                title: "",         // cell 顯示值（例：0055-0000 或 264000）
                colLabel: "",      // 欄位顯示名（例：地號、公告土地現值）
                content: "",
                pageNum: [],
                fileName: "",
                fileUrl: "",       // Open 用
                sectionTitle: "",
                contentType: "TEXT",   // "TEXT" | "IMAGE"
                imageUrl: null,        // IMAGE 類型的圖片 URL
                imageNum: null,        // IMAGE 類型的圖號
            },
            refViewMode: 'text',
            refWebSearchResults: [],
            refWebSearchLoading: false,
            refWebSearchLoaded: false,
            refWebExpanded: {},
            refPdfPreviewUrl: '',
            refPdfPreviewLoading: false,
            refPdfPreviewError: false,
            refPdfFetchError: false,
            refContentCache: {},
            refSasUrlCache: {},
            columnMetaMap: {}, // flexfield_column -> metadata(item)
            cellEdit: {
                key: null,          // `${rowPk}:${col}`
                rowPk: null,        // row.object_id or row.id
                col: null,          // flexfield_text01...
                value: "",
                saving: false,
                error: "",
                original: "",
            },
            editIcon: require("@/assets/images/edit.png"),
            referenceIcon: require("@/assets/images/reference-icon.svg"),
            rerunIcon: require("@/assets/images/rerun_icon.svg"),
            folderSvg: require("@/assets/images/folder.svg"),
            currentParentId: null,
            breadcrumbs: [],
            showEmpty: false,
            autoSync: false,
            showAllParent: false,
            showAllParentCheckBox: false,
            selectagenticondialog:false,
            deleteColumnDialog: false,
            columnDialog: {
                open: false,
                key: 0,
                mode: "edit",
                model: {},
                insertIndex: 0,
                childCollectionColumns: [],
            },
            deleteColumnTarget: null, // { name: 'COL-0101-001', field: 'flexfield_text01', label: '地號' }
            deleteColumnLoading: false,
            linkIcon: require('@/assets/images/link_icon.svg'),
            MoreIcon: require('@/assets/images/more_icon.svg'),
            processingIcon: require('@/assets/images/processing_icon.svg'),
            finishedIcon: require('@/assets/images/finished_icon.svg'),
            notStartedIcon: require('@/assets/images/not_started_icon.svg'),
            errorIcon: require('@/assets/images/error_icon.svg'),
            updatedIcon: require('@/assets/images/updated_icon.svg'),
            uploadIcon: require('@/assets/images/upload_icon.svg'),
            informationIcon: require('@/assets/images/information.svg'),
            unsupportedFileFormatIcon: require('@/assets/images/unsupported_file_format.svg'),
            runIcon: require('@/assets/images/run_icon.svg'),
            runAllIcon: require('@/assets/images/run_all_icon.svg'),
            recordReviewIcon: require('@/assets/images/record_review.svg'),
            arrowDownWhiteIcon: require('@/assets/images/arrow_down_white_icon.svg'),
            exportXlsIcon: require("@/assets/images/export_xls.svg"),
            saveAsIcon: require('@/assets/images/save_as.svg'),
            typeCollectionIcon: require('@/assets/images/type_collection_icon.svg'),
            typeDateIcon: require('@/assets/images/type_date_icon.svg'),
            typeOneDriveIcon: require("@/assets/images/type_onedrive_icon.svg"),
            typeDocumentOutputIcon: require('@/assets/images/type_document_output_icon.svg'),
            typeFileIcon: require('@/assets/images/type_file_icon.svg'),
            typeNumberIcon: require('@/assets/images/type_number_icon.svg'),
            typeSingleSelectIcon: require('@/assets/images/type_single_select_icon.svg'),
            typeTextIcon: require('@/assets/images/type_text_icon.svg'),
            errorDialog:false,
            omsUploading: false,
            omsDoneDialog: false,
            omsDoneMessage: "",
            accessRevokedDialog:false,   // 權限被擁有者撤銷後再次進入此 Instance（後端回 403/404）時顯示，引導重新整理頁面
            saveAsTemplateDialogVisible: false,
            errorMessage: "",
            unsupportedFileCells: {},
            unsupportedFilesDialog: false,
            unsupportedFilesResult: { successCount: 0, failCount: 0 },
            messageDialog:false,
            successDialog:false,
            message:"",
            messagetype:"",
            showReloadBtn: false,
            showTableAttribute: false,
            isUploading: false,
            nameRules: [
                (v) => !!v || i18n.t('RULE.RULE_R'),
                (v) => /^.{0,200}$/.test(v) || i18n.t('RULE.RULE_200'),
            ],
            exportDialog: false,
            currentHeader: [],
            editData: {},
            original_data:{},
            userInputList: [],
            readDocumentsList: [],
            readDocumentsLoading: false,
            readDocuments: {
                keyword: "",
                page: 1,
                pageSize: 10,
                hasMore: true,
                reqSeq: 0,
                inFlight: false,
            },
            statusMap: {},
            pollingTimer: null,
            pollingIntervalMs: 2000,
            autoPollingTimer: null,
            autoPollingIntervalMs: 30000,
            fetchInFlight: false,
            lastFetchAt: 0,
            minFetchGapMs: 800,
            consentDialog: false,
            consentLoading: false,
            consentSubmitting: false,
            consentOptions: { land_agents: [], construction_agents: [] },
            consentForm: {project_name: "",land_agent_id: null,construction_agent_id: null,},
            editingConfigTableName: "",
            currentFirstVisibleCol: null,
            isEditColumnLinkedInput: false,
            statusMapByTable: {},//  新增：每張表一份 status
            errorMsgMapByTable: {}, //  每張表一份 error message，格式 { tableId: { objectId: { column: msg } } }
            rootCollectionTableIds: [],//  新增：root 下面的 collection table ids（用來 run polling 一起抓）
            runStartedAt: 0,//  新增：run 開始時間（避免 collection table 初期 status 空就誤判停止）
            runDataTimer: null,
            runDataInFlight: false,
            runDataIntervalMs: 2000,
            runPollTimer: null,
            runPollIntervalMs: 2000,
            singleSelectColorCache: Object.create(null),
            refFetchInFlight: new Set(),   // 追蹤正在單筆請求中的 objectId，避免重複
            pdfIcon: require('@/assets/images/File-pdf.svg'),
            refMarkdownIt: null,   // markdown renderer
            file_type: null,        // 後端回 OneDrive / null
            filetypeloading: false, // 避免切換閃爍
            createRowLoading: false,    // 進行中狀態避免重複請求
            lastCreatedFlexfieldDataId: null,  // 定位最後一筆，方便跳到最後頁
            pendingUpload: null,  // { row, field }
            fileInputKey: 0,      // 讓同一檔案可重選也會觸發 change
            dragDrop: { overPk: null, overField: null, isMulti: false, isUnsupported: false }, //增加多檔判斷
            runAgentMenu: false,
            propertiesSettingIcon: require("@/assets/images/properties-setting.svg"),
            regenerateColumnIcon: require("@/assets/images/regenerate-column.svg"),
            runFinalRefreshed: false,     // 是否已做過 final refresh
            runFinishStableCount: 0,      // 連續完成確認次數（至少 2 次）
            tableMaxHeight: 650,
            tableRO: null,
            tableScrollWidth: 0,
            onWinResizeHandler: null,
            copied: false,
            selectedFlexfieldData: [],      // 記錄被勾選的row，實現跨page刪除
            indexHoverObjectId: null,       // hover 顯示 checkbox
            recordReviewPageOpen: false,    // RecordReviewPage 開啟狀態
            recordReviewRow: null,          // 觸發 RecordReview 的 row
            recordReviewField: null,        // 觸發 RecordReview 的欄位
            bulkDeleteLoading: false,       // 刪除進行中
            deleteRowsDialogOpen: false,    // 確認刪除彈窗
            toolbarColWidths: [],           // 存每個col寬度
            toolbarTableWidth: 0,           // toolbar整體寬度
            colInsertHover: { active: false, index: null}, // 正在hover哪條線
            tableScrollEl: null,            // 真正會水平捲動的元素
            toolbarFixedLeftWidth: 0,       // 預留序號col寬度
            tableScrollLeft: 0,             // 下方表格目前滾動位置
            confirmOneDriveDialog: {
                open: false,
                resolve: null,
            },
            tooltipPlacementByField: {},
            tooltipMaxWidthPx: 360,
        }
    },
    async created(){
        this._refPdfLinkCache = {};
        this.refMarkdownIt = new MarkdownIt({   // markdown 轉譯器：支援 markdown + HTML table + \n 換行
            html: true,
            breaks: true,
            linkify: true,
        });
        this.refMarkdownIt.enable(['table']);
        await this.getDocumentAgentDetail();
        await this.getDocUserAgentO365AccountData();
        await this.fetchDocumentAgentFileType();      //created時檢查file_type
    //   this.checkCurrentStatus();
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector("#loading-container"),
            name: "flow",
        });
        this.$nextTick(() => {                          // 畫面元素確實更新後再執行
            if (!this.loading) this.updateTableSize();  // 非loading觸發計算表格尺寸
            this.initTableResizeWatcher();              // 自動更新，觀察表格上下空間變化
            this.bindTableScrollSync();                 // 綁定下方表格水平滾動事件
            this.syncColToolbarWidths();                // 依col寬度同步按鈕位置
            window.addEventListener("resize", this.syncColToolbarWidths); // 瀏覽器視窗大小改變事件
        });
    },
    beforeDestroy() {                       // 刪除前
        this.cleanupTableSize();            // 移除事件監聽
        window.removeEventListener("resize", this.syncColToolbarWidths); // 移除事件監聽
        if (this.tableScrollEl) {           // 移除表格 scroll 監聽
            this.tableScrollEl.removeEventListener("scroll", this.onVeTableScroll);
            this.tableScrollEl = null;
        }
        if (this.loadingInstance && typeof this.loadingInstance.close === "function") {
            this.loadingInstance.close();   // 關閉遮罩
            this.loadingInstance = null;    // 清除值
        }
        if (this._refPdfBlobUrl) {
            URL.revokeObjectURL(this._refPdfBlobUrl);
            this._refPdfBlobUrl = null;
        }
    },
    destroyed() {
        this.stopStatusPolling();
        this.stopAutoPolling();
        this.loadingInstance?.destroy?.();
    },
    methods: {
        getDatadetailType(raw) {
            if (raw !== null && typeof raw === 'object') return raw.type ?? null;
            if (typeof raw === 'string') return raw;
            return null;
        },
        openAccessDialog() {
            this.accessDialogOpen = true;
        },
        onEdit(){
            this.isEdit = true;
            this.originDocumentAgentDetail = JSON.parse(JSON.stringify(this.documentAgentDetail));
        },
        onCancel(){
            this.isEdit = false;
            this.documentAgentDetail = this.originDocumentAgentDetail;
        },
        onConfirm(){
                let validated = this.$refs.firstTextField?.validate?.();
                if(!validated) return;

                this.btn_loading = true;
                let data = {
                    "agent_name": this.documentAgentDetail.agent_name,
                    "icon_path": this.documentAgentDetail.icon_path,
                    "instruction": this.documentAgentDetail.instruction
                }
                this.editDocumentAgent(data);
        },
        async editDocumentAgent(data){
            await UpGPTPortalDataServices.editDocumentAgent(this.documentAgentDetail.id, data).then((response)=>{
                this.documentAgentDetail = { ...this.documentAgentDetail, ...response.data };   // 複製原始資料，只更新修改的欄位，避免欄位被覆蓋為空值
                this.btn_loading = false;
                this.isEdit = false;
                this.$emit("emitDocumentDetail")
            })
        },
        async getDocumentAgentDetail() {
            this.loading = true;
            // let doc_agent_id = this.doc_agent_id;
            let requested_id = this.doc_agent_id;
            if(requested_id){
                await UpGPTPortalDataServices.getUserDocumentDetail(requested_id).then((response) => {
                    if(this.doc_agent_id != requested_id){
                        this.loading = false;
                        return;
                    }
                    let icon_name = response.data['icon_path'];
                    this.select_icon_obj = { name: icon_name, path: this.mapping_icon_path(icon_name) }
                    this.documentAgentDetail = response.data;
                    this.tableConfigurations = response.data["table_configurations"];
                    this.rootTableId = this.tableConfigurations[0]?.id;
                    this.selectedItems = response.data["attach_document"].folder_info ? response.data["attach_document"].folder_info : {};
                    const st = String(response.data?.upload_status || "").toLowerCase();
                    if (st === "processing" || st === "fail" || st === "failed") {
                        this.isUploading = true;
                    } else if (st === "completed") {
                        this.isUploading = false;
                    } else {
                        this.isUploading = false;
                    }
                    if(response.data.agent_config && 'schedule_update' in response.data.agent_config){
                        this.autoSync = response.data.agent_config.schedule_update;
                    }else{
                        this.autoSync = false;
                    }
                    this.loading = false;
                }).then(() => {
                    if(this.doc_agent_id !== requested_id) return;
                    if(!this.documentAgentDetail.table_configurations ||
                    this.documentAgentDetail.table_configurations.length == 0)
                    {
                        this.showErrorDialog("找不到表格設定（table_configurations），無法載入資料！");
                    }
                    let object_id = this.documentAgentDetail.table_configurations[0].id;
                    // 取得表格資料（return 讓 loadTable 的 reject 能傳到下方 .catch，例如權限被撤銷後表格 API 回 403）
                    return this.loadTable(object_id, {
                        pushBreadcrumbs: true
                    });
                }).catch(this.handleDetailAccessError);
            }
            this.getDocUserAgentO365AccountData();
        },
        showConnectCloudStorageDialog(){
            if(!this.cloudDriveEnabled) return;     //file_type 為 "OneDrive" 時，才啟用(OneDrive)相關 UI/按鈕
            this.connectCloudStorageDialog = true;
        },
        onDeleteO365Account(){
            this.showMessageDialog("delCloud",i18n.t('DOCUMENT_AGENT.DELETE_CHECK'));
        },
        showMessageDialog(type,message) {
            this.messageDialog = true;
            this.messagetype = type
            this.message = message;
        },
        onEmitMessageDialog(val) {
            this.messageDialog = false;
            if(this.messagetype == "delCloud"){
                if(val){
                    this.loading = true;
                    let doc_agent_id = this.doc_agent_id;
                    O365Service.deleteDocUserAgentO365Account(doc_agent_id)
                    .then(() => {
                        this.loading = false;
                        this.showSuccessDialog();
                        // var index = this.o365AccountData.map(x => { return x.Id; }).indexOf(id);
                        // this.o365AccountData.splice(index, 1);
                        this.o365AccountData = null
                        // 解除綁定後，後端 detach_folder_and_reset 已清空 folder_path/folder_info、
                        // 刪除資料列與 token。先即時清掉殘留的資料夾路徑顯示，再重新載入詳情，
                        // 同步前端狀態（selectedItems / 表格 / autoSync / o365 帳號）。
                        this.selectedItems = {};
                        this.getDocumentAgentDetail();
                    })
                    .catch(() => {
                        this.loading = false;
                        this.errorDialog = true;
                        this.errorMessage = i18n.t('GPT_CLOUD.CLOUDSYNC_ERROR');
                    });
                }
            }else if(this.messagetype == "delFile"){
                if(val){
                    this.loadingInstance.show();
                    UpGPTPortalDataServices.deleteFile(this.documentAgentDetail.id, this.selectedItems)
                    .then(()=>{
                        this.selectedItems = {};
                        this.$nextTick(() => this.updateTableSize()); // 顯示路徑/按鈕切換會改高度
                        let object_id = this.currentTableId;
                        // 取得表格資料
                        this.loadTable(object_id, {
                            parentid: null,
                            pushBreadcrumbs: false
                        });
                        this.loadingInstance.close();
                    })
                }
            }
            this.messagetype = '';
        },
        showSuccessDialog() {
            this.successDialog = true;
        },
        onEmitSuccessDialog() {
            this.successDialog = false;
        },
        async onCloudStorageAdd(){
            this.currentUrl = window.location.href;
            let doc_agent_id = this.doc_agent_id;
            let data = {
                "front_end_url": window.location.href,
            }
            if(doc_agent_id){
                await UpGPTPortalDataServices.addDocUserAgentO365Account(doc_agent_id, data).then(response => {
                    var url = response.data;
                    window.location.href = url;
                })
            }
        },
        async getDocUserAgentO365AccountData(){
            let requested_id = this.doc_agent_id;
            await O365Service.getDocUserAgentO365AccountData(requested_id).then(response => {
                if(this.doc_agent_id !== requested_id) return;
                this.o365AccountData = response.data;
            }).then(()=>{
                if(this.doc_agent_id !== requested_id) return;
                if(this.o365AccountData){
                    this.cloud_files_loading = true;
                    this.cloud_type = "onedrive";
                    this.cloud_id = this.o365AccountData.o365_user_principal_name;
                    this.$nextTick(() => this.updateTableSize()); // onedrive區域影響上方列高度
                }
                // this.getUserAgentSharepointData();
            })
        },
        toTreeNodes(items = [], opts = {}) {
            const { foldersOnly = false } = opts;
            const norm = (p) => {
                if (!p) return "/";
                let s = String(p).trim().replace(/\\/g, "/");
                if (!s.startsWith("/")) s = "/" + s;
                s = s.replace(/\/{2,}/g, "/");
                if (s.length > 1 && s.endsWith("/")) s = s.slice(0, -1);
                return s;
            };
            const src = (items || []);
            const filtered = foldersOnly ? src.filter(it => it.is_folder) : src;

            return filtered.map(it => {
                const isFolder = it.is_folder;
                const absPath = norm(it.full_path);        
                return {
                    id: absPath,                              
                    label: it.name,
                    name: it.name,
                    is_folder: isFolder,
                    full_path: absPath,                       
                    web_url: it.web_url || "",
                    children: isFolder ? null : undefined,   
                    isBranch: isFolder,
                    isDisabled: !isFolder,
                    raw: it,
                };
            });
        },
        async getUserAgentSharepointData(path = "/"){
            this.files_sync_loading = true;
            // let data;
            // data = {"knowledge_lib_id":'28129f5a-86f0-415c-b8a6-06ae105780c0','cloud_id':this.cloud_id,'cloud_type':this.cloud_type,}
            // // 知識庫的API
            // await UpGPTDataintegrationService.cloud_files_list(data).then((response)=>{
            //     // let row = response.data['my_drive']
            //     this.myDrivetreeItems = response.data['my_drive']
            //     console.log('DOCUMENT RESPONSE', this.myDrivetreeItems)
            // })
            // .finally(()=>{
            //     this.cloud_files_loading = false;
            //     this.files_sync_loading = false;
            // })
            
            // await UpGPTPortalDataServices.getUserAgentSharepointData(this.doc_agent_id).then(response => {
            //     this.myDrivetreeItems = response.data['items'];
            // })
            // .finally(()=>{
            //     this.cloud_files_loading = false;
            //     this.files_sync_loading = false;
            // })
            try {
                const res = await UpGPTPortalDataServices.getUserAgentSharepointData(this.doc_agent_id, path);
                const items = res?.data?.items || [];
                this.myDrivetreeItems = this.toTreeNodes(items, { foldersOnly: true });   
            } finally {
                this.cloud_files_loading = false;
                this.files_sync_loading = false;
            }
            },
        async loadOptions({ action, parentNode, callback }) {
            if (action !== LOAD_CHILDREN_OPTIONS) return callback();
            const folderPath = parentNode?.full_path || parentNode?.id;
            if (!folderPath) return callback();
            try {
                const res = await UpGPTPortalDataServices.getUserAgentSharepointData(this.doc_agent_id, folderPath);
                const items = res?.data?.items || [];
                parentNode.children = this.toTreeNodes(items, { foldersOnly: true });   
                callback();
            } catch (e) {
                parentNode.children = [];                        
                callback();
            }
        },
        // normalizePath(p) {
        //     if (!p) return "/";
        //     let s = String(p).trim();
        //     if (!s) return "/";
        //     s = s.replace(/\\/g, "/");
        //     if (!s.startsWith("/")) s = "/" + s;
        //     s = s.replace(/\/{2,}/g, "/");
        //     if (s.length > 1 && s.endsWith("/")) s = s.slice(0, -1);
        //     return s;
        // },
        // joinPath(base, name) {
        //     const b = this.normalizePath(base);
        //     const n = String(name || "").trim().replace(/^\/+/, "");
        //     if (!n) return b;
        //     return b === "/" ? `/${n}` : `${b}/${n}`;
        // },
        async getFolderFiles({ action, parentNode, callback })
        {
            if (action === "LOAD_CHILDREN_OPTIONS") {
                parentNode.cloud_id = this.cloud_id;
                parentNode.cloud_type = this.cloud_type;
                await UpGPTDataintegrationService.get_folder_files_list(parentNode).then((response)=>{
                    parentNode.children = response.data.folder;
                    if(response.data.meet_limit){
                        this.showErrorDialog(i18n.t("GPT_CLOUD.MAX_FILES"));
                    }
                }).finally(()=>{
                    callback()
                })
            }
        },
        addFile(){
            this.selectFileDialog = true;
            this.driveCurrentPath = "/";
            this.drivePathStack = ["/"];
            this.getUserAgentSharepointData("/");
        },
        async openDriveFolder(item) {
            if (!item || !item.is_folder) return;
            const nextPath = item.full_path;
            if (!nextPath) return;
            // push stack
            if (this.drivePathStack[this.drivePathStack.length - 1] !== nextPath) {
                this.drivePathStack.push(nextPath);
            }
            await this.getUserAgentSharepointData(nextPath);
        },
        async backDriveFolder() {          // 返回上一層
            if (!this.drivePathStack || this.drivePathStack.length <= 1) {                  // 已在 root
                this.drivePathStack = ["/"];
                await this.getUserAgentSharepointData("/");
                return;
            }
            this.drivePathStack.pop();            // pop current
            const prevPath = this.drivePathStack[this.drivePathStack.length - 1] || "/";
            await this.getUserAgentSharepointData(prevPath);
        },
        async jumpDriveFolder(path) {         // breadcrumb
            if (!path) path = "/";
            if (path === "/") {            // 重新建立 stack
                this.drivePathStack = ["/"];
            } else {
                const parts = path.split("/").filter(Boolean); // ["a","b","c"]
                const rebuilt = ["/"];
                let accumulator = "";
                for (const p of parts) {
                    accumulator += `/${p}`;
                    rebuilt.push(accumulator);
                }
                this.drivePathStack = rebuilt;
            }
            await this.getUserAgentSharepointData(path);
        },
        deleteFile(){
            this.showMessageDialog("delFile",i18n.t('DOCUMENT_AGENT.DELETE_FILE_CHECK'));
        },
        onCancelSelectFileDialog() {
            this.selectedItems = {};
            this.selectFileDialog = false;
        },
        async onConfirmSelectFileDialog(){
            // if(this.selectedItems){
            //     this.addBtn_loading = true;
            //     this.selectFileDialog = false;
            //     await UpGPTPortalDataServices.addFile(this.documentAgentDetail.id, this.selectedItems).then((response) => {
            //         this.tableData = response.data;
            //         this.addBtn_loading = false;
            //     }).catch(error => {
            //         this.isUploading = true;
            //         if(error == 'Error: timeout of 30000ms exceeded'){
            //             this.showErrorDialog(i18n.t('AGENT_FILE_ATTACHMENT.STILL_RUN'))
            //         }else{
            //             this.showErrorDialog(error.response.data.detail);
            //         }
            //     })
            // }
            if (!this.selectedItems) return;
            this.addBtn_loading = true;
            this.selectFileDialog = false;
            const node = this.selectedItems;
            const payload = {
                name: node.name || node.label || "",
                is_folder: true,
                full_path: node.full_path || node.id,                 
                web_url: node.web_url || node.raw?.web_url || "",
            };
            if (!payload.full_path) {
                this.addBtn_loading = false;
                this.showErrorDialog("未取得資料夾路徑(full_path)，請重新選擇。");
                return;
            }
            this.selectedItems = payload;
            try {
                await UpGPTPortalDataServices.attachFolder(this.documentAgentDetail.id, payload);
            } catch (error) {
                const msg =
                    error?.response?.data?.detail ||
                    error?.message ||
                    "Attach folder failed";
                this.showErrorDialog(msg);
            } finally {
                this.addBtn_loading = false;
                this.$nextTick(() => this.updateTableSize()); // 顯示路徑/按鈕切換會改高度
            }
        },
        async loadTable(tableConfigId, options = {}){
            const currentTable = String(this.currentTableId ?? "");
            const nextTable = String(tableConfigId ?? "");
            if (currentTable !== nextTable) {
                this.selectedFlexfieldData = []; // 切換 Agent/Table 時清空勾選
            }
            const { parentid = null, pushBreadcrumbs = true, parentLabel = "" } = options;
            if (!this.showAllParent) {
                 this.currentParentId = parentid;
            }
            this.page = 1;
            let raw_col = [];
            this.currentTableId = tableConfigId;
            const currentConfig = this.tableConfigurations.find(
                t => t.id == tableConfigId
            );
            // 1) 拿欄位
            const columnsRes = await UpGPTPortalDataServices.documentAgentTableHeader(tableConfigId);
            if(this.currentTableId !== tableConfigId) return;
            let metaColumn = columnsRes.data['tenant_db_flexfieldmetadata'];
            this.currentHeader = metaColumn;                        // 存目前這張表的metadata
            this.userInputList = await this.collectUserInputList(); // 存input下拉選單的items
            // 進入子表前先儲存父表 sort/filter 狀態，必須在 _cleanupSortFilterByMetadata 之前執行
            // 否則子表 metaColumn 會把父表專屬欄位從 sortList/filterList 清掉，導致回到父表時狀態遺失
            if (pushBreadcrumbs) {
                if (this.breadcrumbs.length > 0) {
                    const last = this.breadcrumbs[this.breadcrumbs.length - 1];
                    last.sortList = [...this.sortList];
                    last.filterList = [...this.filterList];
                }
                this.sortList = [];
                this.filterList = [];
                this.addBreadcrumb(currentConfig, parentLabel);
            }
            // hidden 過濾 + 建 map
            metaColumn = metaColumn.filter(item => item.hidden != true);
            this.singleSelectColorCache = Object.create(null);  // 清空快取避免顏色殘留
            //  只在 root table 時，從欄位 metadata 推導 collection tables ids
            if (String(tableConfigId) === String(this.rootTableId)) {
                const ids = [];
                for (const m of (metaColumn || [])) {
                    const dt = String(m?.flexfield_datatype || "").trim().toLowerCase();
                    if (dt !== "collection") continue;
                    // collection_table 可能是表名（object_type_name）或短名，做寬鬆 match
                    const ct = String(m?.collection_table || "").trim();
                    if (!ct) continue;
                    const hit = (this.tableConfigurations || []).find(t => {
                        const ot = String(t?.object_type_name || "");
                        return ot === ct || ot.endsWith(`.${ct}`) || ot.includes(ct);
                    });
                    if (hit?.id) ids.push(String(hit.id));
                }
                this.rootCollectionTableIds = Array.from(new Set(ids));
                console.log("[rootCollectionTableIds]", this.rootCollectionTableIds);
            }
            this.buildColumnMetaMap(metaColumn);
            this._cleanupSortFilterByMetadata(metaColumn); // Task 6-1: 欄位刪除/型別變更時自動清除無效條目
            this.currentFirstVisibleCol = (metaColumn && metaColumn.length > 0)? metaColumn[0].flexfield_column: null;
            // 2) 用 buildColumn 組 columns
            const apiColumns = metaColumn.map(item => this.buildColumn(item));
            raw_col.push(...apiColumns);
            //  Add index column
            raw_col.unshift({
                field: "index",
                key: "index",
                title: "",
                minWidth: 50,
                maxWidth: 50,
                align: "center",
                fixed: "left",
                renderBodyCell: ({ rowIndex, row }) => {
                    const h = this.$createElement;
                    const oidRaw = row?.object_id;
                    const oid = (oidRaw === null || oidRaw === undefined) ? "" : String(oidRaw);
                    const isSelected = oid ? this.isRowSelected(oid) : false;           // 用來顯示已選取狀態不消失
                    const isHover = oid ? (this.indexHoverObjectId === oid) : false;    // hover就顯示選取或未選
                    const showCheckbox = isSelected || isHover;
                    const iconClass = isSelected ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline";
                    return h(
                        "div",
                        {
                            on: {
                                mouseenter: () => { if (oid) this.indexHoverObjectId = oid; },
                                mouseleave: () => { if (this.indexHoverObjectId === oid) this.indexHoverObjectId = null; },
                            }
                        },
                        [
                        showCheckbox
                            ? h(
                                "button",
                                {
                                    class: ["da-index-checkbox-btn", isSelected ? "is-checked" : "is-unchecked"],   // 都會顯示方塊，但選取未選需再判斷
                                    attrs: { type: "button", "aria-label": "select row" },
                                    on: {
                                        click: (e) => {
                                            e?.stopPropagation?.();
                                            this.toggleRowSelection(oid);
                                        }
                                    }
                                },
                                [
                                    h("i", { class: ["v-icon", "notranslate", "mdi", iconClass, "theme--light"] })
                                ]
                            )
                            : h("span", { class: "da-index-number" }, String(rowIndex + 1)) //顯示序號
                        ]
                    );
                }
            });

            this.columns = raw_col;

            // 拿表格資料
            const dataRes = await UpGPTPortalDataServices.documentAgentTableData(tableConfigId, {
                parentid: parentid,
                page: this.page,
                pagesize: this.itemPerPage,
                ...(this.sortList.length && { sort: JSON.stringify(this.sortList) }),
                ...(this.filterList.length && { filter: JSON.stringify(this.filterList) }),
                lang: (this.$i18n && this.$i18n.locale) || 'zh-TW',
            });
            if(this.currentTableId !== tableConfigId) return;   //避免快速切表狀態殘留
            this.tableData = dataRes.data?.items || [];         // 更新表格資料，沒有就給空
            this.totalCount = Number(dataRes.data?.total_count || 0);   // 更新總筆數
            this.$nextTick(() => this.updateTableSize());       // 重新計算表格高度
            this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.itemPerPage));// 更新總頁數，Math.max(1,x)比較選大=設定最小值為1/Math.ceil無條件進位，超出跳下一頁
            this.showEmpty = this.tableData.length == 0 ? true : false; //顯示無資料提示
            
            // 4) reference map
            await this.loadFlexfieldReference(tableConfigId, currentConfig.object_type_name);
            this.startAutoPolling();
        },
        buildColumn(item) {
            const column = {
                title: item.description,
                field: item.flexfield_column,
                key: `${item.flexfield_column}-${item.name}`,
                align: item.flexfield_datatype == "Number" ? "right" : "left",
                width: 230, // 約15個中文字
                flexfield_datatype: item.flexfield_datatype,
                name: item.name,
                input: item.input,
                read_documents: item.read_documents,
                model: item.model,
                description: item.description,
                user_prompt: item.user_prompt,
                reasoning_effort: item.reasoning_effort,
                collection_properties: item.collection_properties,
                collection_properties_description: item.collection_properties_description,
                collection_table: item.collection_table,
            };
            // Header
            column.renderHeaderCell = ({ column }) => {
                const h = this.$createElement;
                const iconSrc = this.getHeaderTypeIcon(item.flexfield_datatype, item.flexfield_datadetail);
                const iconNode = h("img", {
                    class: "da-col-type-icon",
                    attrs: {
                        src: iconSrc,
                        alt: String(item.flexfield_datatype || ""),
                        width: "20",
                        height: "20",
                    },
                });
                const titleNode = h("span", { class: "ve-th-title" }, column.title);
                const moreBtn = h("button", { class: "ve-th-menu-btn" }, [
                h("img", {
                    attrs: {
                    src: this.MoreIcon,
                    alt: "more",
                    width: "20",
                    height: "20",
                    },
                    class: "icon-more-img",
                    on: { click: (e) => this.openHeaderMenu(e, column) },
                }),
                ]);
                const _rawDetail = item?.flexfield_datadetail;
                const isFileUploadCol = String(item?.flexfield_datatype || '').toLowerCase() === 'file' &&
                    this.getDatadetailType(_rawDetail) === 'FileUpload';
                let infoIconNode = null;
                if (isFileUploadCol) {
                    const tooltipText = this.$t('DOCUMENT_AGENT.FILE_FORMAT_TOOLTIP');
                    const isBottom = this.tooltipPlacementByField?.[column.field] === 'bottom';
                    infoIconNode = h(VTooltip, {
                        props: {
                            right: !isBottom,
                            bottom: isBottom,
                            contentClass: 'da-info-tooltip',
                        },
                        scopedSlots: {
                            activator: ({ on }) => h('img', {
                                attrs: { src: this.informationIcon, width: 16, height: 16, alt: 'info' },
                                class: 'da-col-info-icon',
                                on: {
                                    ...on,
                                    mouseenter: (e) => {
                                        this.updateTooltipPlacement(e, column.field);
                                        on?.mouseenter?.(e);
                                    },
                                },
                            }),
                        },
                    }, [h('span', tooltipText)]);
                }
                // Task 2-1: 排序指示器
                const isSortable = ['Text','SingleSelect','Number','File','DocumentOutput'].includes(item.flexfield_datatype);
                let sortNode = null;
                if (isSortable) {
                    const sortState = this.getSortState(item.flexfield_column);
                    const sortPriority = this.getSortPriority(item.flexfield_column);
                    const sortImgSrc = sortState === 'asc'
                        ? ICONS.sortUp
                        : sortState === 'desc'
                        ? ICONS.sortDown
                        : ICONS.sortDefault;
                    const arrowIcon = h('img', {
                        class: ['da-sort-icon', sortState ? '' : 'da-sort-icon--idle'],
                        attrs: { src: sortImgSrc, width: 20, height: 20 },
                    });
                    sortNode = h('button', {
                        class: ['da-sort-btn', sortState ? 'da-sort-btn--active' : ''],
                        attrs: { title: this.$t('DOCUMENT_AGENT.SORT_TOOLTIP') },
                        on: { click: (e) => { e.stopPropagation(); this.handleColumnSortClick(item.flexfield_column); } },
                    }, [arrowIcon]);
                }
                // Task 3-1: 篩選按鈕
                const isFilterable = isSortable;
                let filterNode = null;
                if (isFilterable) {
                    const hasFilter = !!this.getFilterForColumn(item.flexfield_column);
                    filterNode = h('button', {
                        class: ['da-filter-btn', hasFilter ? 'da-filter-btn--active' : ''],
                        on: { click: (e) => this.openFilterPanel(e, item, column) },
                    }, [
                        h('img', { class: 'da-filter-icon', attrs: { src: hasFilter ? ICONS.filterOn : ICONS.filterOff, width: 20, height: 20 } }),
                    ]);
                }
                // 排序優先 badge（多欄排序時顯示）
                const sortPriorityVal = isSortable ? this.getSortPriority(item.flexfield_column) : null;
                const badgeNode = (sortPriorityVal && this.sortList.length > 1)
                    ? h('span', { class: 'da-sort-priority' }, [String(sortPriorityVal)])
                    : null;
                const isMultiOverCol =
                this.dragDrop?.isMulti === true &&
                this.dragDrop?.overField === column.field;
                return h(
                "div",
                {
                    class: ["ve-th-menu d-flex align-center justify-space-between", isMultiOverCol ? "da-th-dropzone--over" : ""],
                    attrs: { "data-drop-col": column.field },
                },
                [
                    // 左：type icon + title + sort + filter + badge
                    h("div", { class: "da-th-left d-flex align-center" }, [iconNode, titleNode, infoIconNode, sortNode, filterNode, badgeNode].filter(Boolean)),
                    // 右：三點選單
                    h("div", { class: "da-th-right d-flex align-center" }, [moreBtn].filter(Boolean)),
                ]
                );
            };
            //  Base body render：只回傳內容，不包 status（避免被 overflow 裁掉）
            const baseRenderBodyCell = ({ row }) => {
            const h = this.$createElement;
            return this.renderCellContent(h, item, row);
            };
            // 預設先掛 base
            column.renderBodyCell = baseRenderBodyCell;
            // File 欄位
            //這段顯示邏輯改由renderCellContent處理
            // if (item.flexfield_datatype === "File") {
            //     column.renderBodyCell = ({ row }) => {
            //     const h = this.$createElement;
            //     const v = row?.[item.flexfield_column];
            //     const file_name = v?.original_filename;
            //     const file_url = v?.original_url;
            //     if (!file_name || !file_url) return h("span", "-");
            //     return h(
            //         "a",
            //         {
            //         class: "file-link",
            //         attrs: { href: file_url, target: "_blank", title: file_name },
            //         },
            //         file_name
            //     );
            //     };
            // }
            // Wrapper：Inline Edit + Reference icon + Edit icon
            const self = this;
            const origRender = column.renderBodyCell;
            column.renderBodyCell = (ctx) => {
                const h = self.$createElement;
                const row = ctx.row;
                const col = column.field;
                const rowPk = row?.object_id ?? null;
                const mainViewNode = origRender ? origRender(ctx) : h("span", String(row?.[col] ?? "")); //這個 cell 要顯示的內容
                const iconMask = (iconUrl, alt) =>
                    h("span", {
                    class: "da-icon-mask",                          //統一顏色
                    attrs: { role: "img", "aria-label": alt },      //將<span>當成「圖片」，描述文字
                    style: { "--da-mask": `url("${iconUrl}")` },    //灰底色+用iconUrl的圖當遮罩=固定顏色icon
                    });
                //  (1) 編輯中：直接顯示 input 
                if (self.canEditCell(col) && rowPk && self.isEditingCell(String(rowPk), col)) {
                    const err = self.cellEdit.error;
                    return h("div", { class: "d-flex flex-column", style: "gap:4px;" }, [
                        h("input", {
                        domProps: { value: self.cellEdit.value },
                        attrs: { type: "text", autofocus: "autofocus" },
                        class: "document-agent-cell-input",
                        on: {
                            input: (e) => (self.cellEdit.value = e.target.value),
                            keydown: async (e) => {
                            if (e.key === "Enter") {            // Enter 鍵儲存
                                e.preventDefault();
                                await self.saveEditCell(row);
                            } else if (e.key === "Escape") {    // Esc 鍵取消
                                e.preventDefault();
                                self.cancelEditCell();
                            }
                            },
                            blur: async () => {                 // 離開input也儲存
                                await self.saveEditCell(row);
                            },
                        },
                        }),
                        err ? h("div", { class: "document-agent-cell-error" }, err) : null,
                    ]);
                }
                // rerun icon
                const rerunBtn = h(
                        "button",
                        {
                            // 授權阻擋時一併停用這顆按鈕；真正的阻擋在 runAgent()。
                            attrs: { type: "button", title: `Rerun`, disabled: self.isLicenseBlocking },
                            class: "da-icon-btn",
                            on: {
                                click: async (e) => {
                                    e?.stopPropagation?.();
                                    e?.preventDefault?.();
                                    if (!rowPk || !col) return;
                                    const parentId = this.showAllParent ? null : this.currentParentId;
                                    await this.runAgent({
                                        type: "cell",
                                        table_config_id: this.currentTableId,
                                        flexfielddata_object_id: rowPk,   // 單一 cell用row id
                                        flexfield_column: col,            // cell 的欄位
                                        parent_id: parentId,              // 若在collection需要parentId
                                    });
                                },
                            },
                        },
                        [
                            iconMask(self.rerunIcon, "rerun"),
                        ]
                    );
                //  (2) Reference icon (DocumentOutput 不顯示)
                const _rawDetailForRef = item?.flexfield_datadetail;
                const isDocumentOutput = self.getDatadetailType(_rawDetailForRef) === "DocumentOutput";
                let refBtn = null;
                if (!isDocumentOutput) {
                    const refs = self.getCellRefs(row.object_id, col);
                    const refCount = Array.isArray(refs) ? refs.length : 0;
                    refBtn = h(
                            "button",
                            {
                                attrs: { type: "button", title: `References: ${refCount}` },
                                class: "da-icon-btn",
                                on: {
                                    click: (e) => {
                                        e?.stopPropagation?.();
                                        const title = self.getCellDisplayText(row, col);
                                        self.openRefPopup(row.object_id, col, title);
                                    },
                                },
                            },
                            [
                                iconMask(self.referenceIcon, "reference"),
                            ]
                        );
                }
                //  (3) Edit icon 
                const canEdit = self.canEditCell(col) && rowPk != null;
                let editBtn = null;
                if (canEdit) {
                editBtn = h(
                    "button",
                    {
                    attrs: { type: "button"},
                    class: "da-icon-btn",
                    on: {
                        click: (e) => {
                            e?.stopPropagation?.();
                            self.startEditCell(String(rowPk), col, row?.[col]);
                        },
                    },
                    },
                    [
                        iconMask(self.editIcon, "edit"),
                    ]
                );
                }
                //  (4)file type 
                const isFile = String(item?.flexfield_datatype || "").trim().toLowerCase() === "file";
                const _rawDetail = item?.flexfield_datadetail;
                const isFileUpload = isFile && this.getDatadetailType(_rawDetail) === "FileUpload";
                let uploadBtn = null;
                if (isFileUpload) {
                    uploadBtn = h(
                        "button",
                        {
                            attrs: { type: "button", title: "Upload" },
                            class: "da-icon-btn",
                            on: {
                                click: (e) => {
                                    e?.stopPropagation?.();         // 避免點到其他層click
                                    if (self.isUploading) return;   //  上鎖，上傳途中不能再開選檔
                                    self.openFilePicker(row, col);  // 開選檔視窗
                                },
                            },
                        },
                        [
                            iconMask(self.uploadIcon, "upload"),
                        ]
                    );
                }
                //  (5) Record Review icon (僅 FileUpload/OneDrive 且有關聯檔案時顯示)
                const cellValue = row?.[col];
                const hasCellFile = isFile && !isDocumentOutput && cellValue !== null && cellValue !== undefined && typeof cellValue === 'object';
                const recordReviewBtn = (rowPk && hasCellFile)
                    ? h(
                        "button",
                        {
                            attrs: { type: "button", title: "Record Review" },
                            class: "da-icon-btn",
                            on: {
                                click: (e) => {
                                    e?.stopPropagation?.();
                                    self.openRecordReview(row, col);
                                },
                            },
                        },
                        [iconMask(self.recordReviewIcon, "record review")]
                    )
                    : null;
                const actionChildren = [recordReviewBtn, uploadBtn, editBtn, rerunBtn, refBtn].filter(Boolean);
                const actions = actionChildren.length
                    ? h("div", { class: "da-actions-float" }, actionChildren)
                    : null;
                //  (5) 最終 cell
                const statusVal = self.getCellStatus(row, col);
                const cellErrorMsg = self.getCellErrorMsg(row, col);
                const statusImg = self.renderStatusIcon(h, statusVal);
                let statusNode = null;
                if (statusImg) {
                    if (statusVal === "ERROR") {
                        const tooltipMsg = cellErrorMsg
                            ? self.resolveCellErrorMsg(cellErrorMsg)
                            : self.$t('DOCUMENT_AGENT.CELL_ERROR_DEFAULT');
                        statusNode = h("div", {
                            class: ["da-status-fixed", isFile ? "da-status-fixed--file" : ""]
                        }, [
                            h(VTooltip, {
                                props: { bottom: true, contentClass: 'da-error-tooltip' },
                                scopedSlots: {
                                    activator: ({ on }) => h("div", { on, class: "da-status-icon-wrap" }, [statusImg]),
                                },
                            }, [h("span", tooltipMsg)])
                        ]);
                    } else {
                        statusNode = h("div", {
                            class: ["da-status-fixed", isFile ? "da-status-fixed--file" : ""]
                        }, [statusImg]);
                    }
                }
                //  ERROR 且有錯誤訊息時，以紅字標籤 + tooltip 取代 cell 原始內容
                //  ERROR 且有錯誤訊息時，以紅字標籤 + tooltip 呈現錯誤
                //  檔案儲存格失敗但保留原始檔時：紅字標籤放在檔名前面，檔名照常顯示
                let displayNode = mainViewNode;
                const detailType = (item?.flexfield_datadetail && typeof item.flexfield_datadetail === "object")
                    ? item.flexfield_datadetail.type : item?.flexfield_datadetail;
                const keepFileName = isFile && detailType !== "DocumentOutput" && !!row?.[col]?.original_filename;
                if (statusVal === "ERROR" && cellErrorMsg) {
                    const resolvedMsg = self.resolveCellErrorMsg(cellErrorMsg);
                    const cellLabel = DOCUMENT_OUTPUT_ERROR_CODES.has(cellErrorMsg)
                        ? resolvedMsg
                        : cellErrorMsg === 'WEB_SEARCH_ERROR_TIMEOUT'
                            ? self.$t('DOCUMENT_AGENT.CELL_ERROR_TIMEOUT')
                            : self.$t('DOCUMENT_AGENT.CELL_ERROR_FAILURE');
                    const errorLabelNode = h(VTooltip, {
                        props: {
                            bottom: true,
                            // 檔案儲存格的紅字在最左邊，置中展開會超出左側；改成對齊紅字左緣往右展開
                            ...(keepFileName ? { right: true, bottom: false, nudgeBottom: 10 } : {}),
                            contentClass: 'da-error-tooltip',
                            zIndex: 300,
                        },
                        scopedSlots: {
                            activator: ({ on }) => h("span", { on, class: "da-cell-error-text" }, cellLabel),
                        },
                    }, [h("span", resolvedMsg)]);

                    displayNode = keepFileName
                        ? h("span", { class: "da-file-error-wrap" }, [
                            errorLabelNode,
                            h("span", { class: "da-file-error-name" }, [mainViewNode]),
                          ])
                        : errorLabelNode;
                }
                let wrapOn = undefined;
                let isSingleOver = false;                   // 單檔拖拉hover，亮一格
                let isMultiOver = false;                    // 多檔拖拉hover，亮一欄
                    if (isFileUpload && rowPk != null) {
                        const pk = String(rowPk);
                        isSingleOver =                      // 單檔，需要pk + 欄位
                        !self.dragDrop?.isMulti &&
                        self.dragDrop?.overPk === pk &&
                        self.dragDrop?.overField === col;

                        isMultiOver =                       // 多檔，僅需欄位
                        self.dragDrop?.isMulti &&
                        self.dragDrop?.overField === col;
                        wrapOn = {
                            dragenter: (e) => self.onCellDragEnter(e, { row, field: col }),
                            dragover:  (e) => self.onCellDragOver(e, { row, field: col }),
                            dragleave: (e) => self.onCellDragLeave(e, { row, field: col }),
                            drop:      (e) => self.onCellDropSingleFile(e, { row, field: col }),
                        };
                    }
                    const isUnsupportedOver = isSingleOver && self.dragDrop?.isUnsupported === true;
                    const isRejected = !isMultiOver && Boolean(self.unsupportedFileCells?.[`${col}__${rowPk}`]);
                    const isCollection = String(item?.flexfield_datatype || '').trim().toLowerCase() === 'collection';
                    const wrapClass = [
                    "da-td-wrap",
                    isCollection ? "da-td-wrap--collection" : "",
                    isFileUpload ? "da-file-dropzone" : "",
                    (isSingleOver && !isUnsupportedOver) ? "da-file-dropzone--over" : "",
                    isUnsupportedOver ? "da-file-dropzone--error-over" : "",
                    isMultiOver ? "da-file-dropzone--col-over" : "",    //  多檔整欄亮
                    isRejected ? "da-file-dropzone--rejected" : "",
                    ].filter(Boolean);

                    return h("div", 
                    {
                        class: wrapClass,
                        on: wrapOn,
                        attrs: isFileUpload ? { "data-drop-col": col } : null,  // 判斷滑鼠是否還在同一欄
                    },
                    [
                        h("div", { class: "da-td-content" }, [
                            h("div", { class: "document-agent-cell-editable" }, [displayNode]),
                        ]),
                        statusNode,
                        actions,
                    ]);
                };
            return column;
        },
        async fetchViewTableData() {
            if (this.runDataInFlight) return this.totalCount;   // 防止重複請求
            const viewId = String(this.currentTableId || "");   // 取目前畫面table id
            if (!viewId) return this.totalCount;                // 沒有viewId不打 API，回傳目前totalCount
            const snapshotViewId = viewId;                      // 固定現在的 viewId
            const parentId = this.showAllParent ? null : this.currentParentId;  // parentId：依 showAllParent 決定要不要帶 parentid
            this.runDataInFlight = true;                        // 上鎖，避免重複請求
            try {
                const res = await UpGPTPortalDataServices.documentAgentTableData(snapshotViewId, {  // 打 API 抓表格資料（帶分頁數）
                    parentid: parentId,              // collection會帶parentid
                    page: this.page,                 // 從1開始
                    pagesize: this.itemPerPage,      // 每頁筆數
                    ...(this.sortList.length && { sort: JSON.stringify(this.sortList) }),
                    ...(this.filterList.length && { filter: JSON.stringify(this.filterList) }),
                    lang: (this.$i18n && this.$i18n.locale) || 'zh-TW',
                });
                if (String(this.currentTableId || "") !== snapshotViewId) return this.totalCount;   // 現在和快照對不上就回目前totalCount
                const data = res?.data || {};                                   // 避免 res / res.data 為 undefined
                this.tableData = data.items || [];                              // 更新畫面用的 tableData
                this.totalCount = Number(data.total_count || 0);                // 更新總筆數
                this.page = Number(data.page || this.page);                     // 同步後端回傳的 page
                this.itemPerPage = Number(data.page_size || this.itemPerPage);  // 避免前後端 page size 不一致
                this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.itemPerPage));   // 計算總頁數
                this.showEmpty = (this.tableData.length === 0);                 // 顯示無資料提示
                return this.totalCount;                                         // 回傳totalCount，算 lastPage
            } finally {
                this.runDataInFlight = false;                                   //解鎖
            }
        },
        async loadFlexfieldReference(tableConfigId, tableName) {
            try {
                const res = await UpGPTPortalDataServices.documentAgentFlexfieldReference( //call API
                    tableConfigId,
                    tableName
                );
                const rows = [];  
                if (Array.isArray(res.data)) {
                    rows.push(...res.data);
                }
                const map = {};
                for (const r of rows) {                             //每個 row 是後端回來的一筆 reference 資料
                    const objectid = String(r.object_id || "");
                    if (!objectid) continue;
                    map[objectid] = r;
                }
                this.referenceMap = map;
            } catch (error) {
                console.warn("loadFlexfieldReference failed:", error);
            }
        },
        async fetchRowReferenceIfMissing(row) {
            if (!row) return;
            const objectId = String(row.object_id || '');
            if (!objectId) return;
            if (this.referenceMap[objectId] !== undefined) return;   // cache hit
            if (this.refFetchInFlight.has(objectId)) return;         // 已在請求中
            this.refFetchInFlight.add(objectId);
            try {
                const res = await UpGPTPortalDataServices.documentAgentFlexfieldReferenceByRow(objectId);
                if (res.data && res.data.object_id) {
                    this.$set(this.referenceMap, objectId, res.data);
                }
            } catch (error) {
                console.warn('fetchRowReferenceIfMissing failed:', error);
            } finally {
                this.refFetchInFlight.delete(objectId);
            }
        },
        getRowReferenceData(row) {
            if (!row) return {}
            return this.referenceMap[String(row.object_id || '')] || {}
        },
        getCellRefs(rowObjectId, col) {
            const rowRef = this.referenceMap[String(rowObjectId)];
            if (!rowRef) return [];
            const v = rowRef[col];              // flexfield_text01 -> [reference id, reference id]
            if (Array.isArray(v)) return v;     // 回傳 reference id 陣列
            return [];
        },
        closeRefPopup() {
            this.clearRefPdfCache();
            this.resetRefViewMode();
            this.refPopup.open = false;
            this.refPopup.rowObjectId = null;
            this.refPopup.col = null;
            this.refPopup.refs = [];
            this.refPopup.activeIndex = 0;
            this.refPopup.activeContextId = null;
            this.refPopup.loading = false;
            this.refPopup.title = "";
            this.refPopup.colLabel = "";
            this.refWebSearchResults = [];
            this.refWebSearchLoading = false;
            this.refWebSearchLoaded = false;
            this.refWebExpanded = {};
            this.applyRefPayload({});
        },
        async openRefPopup(rowObjectId, col, cellTitle = "") {
            this.resetRefViewMode();
            this.refWebSearchResults = [];
            this.refWebSearchLoading = false;
            this.refWebSearchLoaded = false;
            this.refWebExpanded = {};
            this.refSasUrlCache = {};
            const refList = this.getCellRefs(rowObjectId, col).map(String);
            const meta = this.columnMetaMap?.[col];
            const colLabel = meta?.description || meta?.name || col;
            this.refPopup.open = true;
            this.refPopup.rowObjectId = String(rowObjectId);
            this.refPopup.col = col;
            this.refPopup.title = String(cellTitle || "");
            this.refPopup.colLabel = String(colLabel || "");
            this.refPopup.refs = refList;
            this.refPopup.activeIndex = 0;
            this.refPopup.activeContextId = refList[0];
            this.refPopup.content = "";
            this.refPopup.pageNum = [];
            this.refPopup.fileName = "";
            this.refPopup.fileUrl = "";
            this.refPopup.sectionTitle = "";
            const webSearchEnabled = !!this.columnMetaMap?.[col]?.web_search_enabled;
            if (webSearchEnabled) {
                this.refViewMode = 'web';
                this.fetchWebSearchResults();
            }
            if (!refList.length) {                    // 沒有 reference時提示
                this.refPopup.content = this.$t("DOCUMENT_AGENT.NO_REFERENCE_USED");
                return;
            }
            await this.onSelectRefContext(refList[0], 0);
        },
        async onSelectRefContext(contextId, idx = 0, fromUserClick = false) {                        // 選取不同 reference
            const wasInPreview = this.refViewMode === 'preview';
            const wasInWeb = this.refViewMode === 'web';
            if (wasInPreview) {
                this.refPdfPreviewUrl = '';
                this.refPdfPreviewError = false;
                this.refPdfFetchError = false;
            } else if (!wasInWeb) {
                this.resetRefViewMode();
            }
            this.refPopup.activeIndex = idx;                                                        // 切換 reference index
            this.refPopup.activeContextId = String(contextId);                                      // 切換 reference context
            await this.fetchRefContent(this.refPopup.rowObjectId, this.refPopup.activeContextId);   // 抓 reference 內容
            if (wasInPreview) {
                await this._applyPdfPreviewUrl();
            }
            if (wasInWeb && fromUserClick) {
                this.refViewMode = 'text';
            }
        },
        applyRefPayload(payload) {                            //將組好的資料寫進 refPopup，讓畫面更新
            this.refPopup.content = payload?.content ?? "";
            this.refPopup.pageNum = payload?.page_num ?? [];
            this.refPopup.fileName = payload?.file_name ?? "";
            this.refPopup.sectionTitle = payload?.section_title ?? "";
            this.refPopup.fileUrl = payload?.file_url ?? "";
            this.refPopup.contentType = payload?.content_type ?? "TEXT";
            this.refPopup.imageUrl = payload?.image_url ?? null;
            this.refPopup.imageNum = payload?.image_num ?? null;
        },
        async fetchRefContent(rowObjectId, contextId) {
            const key = `${rowObjectId}:${contextId}`;
            if (this.refContentCache[key]) {                        //有快取就直接用
                this.refPopup.loading = false;
                this.applyRefPayload(this.refContentCache[key]);
                return;
            }
            this.refPopup.loading = true;       //開啟loading，清空舊資料
            this.applyRefPayload({});
            try {
                const res = await UpGPTPortalDataServices.documentAgentFlexfieldReferenceChunk(  //call API
                    rowObjectId,
                    contextId
                );
                const payload = {
                    content: res?.data?.reference_content ?? "",
                    page_num: res?.data?.page_num ?? [],
                    file_name: res?.data?.file_name ?? "",
                    section_title: res?.data?.section_title ?? "",
                    file_url: res?.data?.file_url ?? "",
                    content_type: res?.data?.content_type ?? "TEXT",
                    image_url: res?.data?.image_url ?? null,
                    image_num: res?.data?.image_num ?? null,
                };
                this.refContentCache[key] = payload;  //放進快取，備用
                this.applyRefPayload(payload);
            } catch (error) {
                console.warn("fetchRefContent failed:", error);
                this.refPopup.content = "讀取 reference 失敗，請確認 API 路由/權限。";
            } finally {
                this.refPopup.loading = false;  //離開loading
            }
        },
        formatPageNum(pageNum) {                // 拿到 pageNum 陣列，格式化成字串
            if (!pageNum) return "";
            if (Array.isArray(pageNum)) return pageNum.join(", ");
            return String(pageNum);
        },
        getCellDisplayText(row, col) {
            const meta = this.columnMetaMap?.[col];    // 從欄位名稱 col 找到該欄的 metadata
            const dt = String(meta?.flexfield_datatype || "").trim().toLowerCase();
            const v = row?.[col];                      
            if (dt === "file") {                        // file顯示檔名
                return v?.original_filename || v?.file_name || "";
            }
            if (dt === "collection") {                  // collection 顯示 display_value
                return v?.display_value || "";
            }
            return (v === null || v === undefined) ? "" : String(v);
        },
        buildColumnMetaMap(metaColumn) {                // 建立欄位名稱到 metadata 的對應表
            const map = {};
            for (const m of metaColumn || []) {
            if (m && m.flexfield_column) map[m.flexfield_column] = m;
            }
            this.columnMetaMap = map;
        },
        _cleanupSortFilterByMetadata(metaColumn) {
            // Task 6-1: 欄位刪除時移除對應排序/篩選；型別變更時移除運算子不相容的篩選
            const validCols = new Set((metaColumn || []).map(m => m.flexfield_column));
            const typeMap = {};
            (metaColumn || []).forEach(m => { typeMap[m.flexfield_column] = m.flexfield_datatype; });
            const TEXT_OPS  = new Set(['contains','not_contains','equals','not_equals','is_empty','is_not_empty']);
            const NUM_OPS   = new Set(['equals','not_equals','gt','gte','lt','lte','between','is_empty','is_not_empty']);
            const FILE_OPS  = new Set(['is_empty','is_not_empty']);
            this.sortList = this.sortList.filter(s => validCols.has(s.flexfield_column));
            this.filterList = this.filterList.filter(f => {
                if (!validCols.has(f.flexfield_column)) return false;
                const dtype = typeMap[f.flexfield_column] || '';
                if (['Text','SingleSelect'].includes(dtype)) return TEXT_OPS.has(f.operator);
                if (dtype === 'Number') return NUM_OPS.has(f.operator);
                if (['File','DocumentOutput'].includes(dtype)) return FILE_OPS.has(f.operator);
                return false;
            });
        },
        // Task 2-1: 排序互動
        getSortState(flexfield_column) {
            const s = this.sortList.find(s => s.flexfield_column === flexfield_column);
            return s ? s.direction : null;
        },
        getSortPriority(flexfield_column) {
            if (this.sortList.length <= 1) return null;
            const idx = this.sortList.findIndex(s => s.flexfield_column === flexfield_column);
            return idx === -1 ? null : idx + 1;
        },
        handleColumnSortClick(flexfield_column) {
            const idx = this.sortList.findIndex(s => s.flexfield_column === flexfield_column);
            if (idx === -1) {
                this.sortList.push({ flexfield_column, direction: 'asc' });
            } else if (this.sortList[idx].direction === 'asc') {
                this.$set(this.sortList, idx, { flexfield_column, direction: 'desc' });
            } else {
                this.sortList.splice(idx, 1);
            }
            this.columns = [...this.columns]; // 強制表頭重繪以更新排序箭頭
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        removeSort(flexfield_column) {
            this.sortList = this.sortList.filter(s => s.flexfield_column !== flexfield_column);
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        clearAllSorts() {
            this.sortList = [];
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        getSortChipColumnName(s) {
            const meta = this.columnMetaMap?.[s.flexfield_column];
            return meta?.description || meta?.name || s.flexfield_column;
        },
        getSortChipLabel(s) {
            const meta = this.columnMetaMap?.[s.flexfield_column];
            const desc = meta?.description || meta?.name || s.flexfield_column;
            const dir = s.direction === 'asc'
                ? this.$t('DOCUMENT_AGENT.SORT_ASC')
                : this.$t('DOCUMENT_AGENT.SORT_DESC');
            return `${desc}: ${dir}`;
        },
        onSortMenuClick(direction) {
            const col = this.headerMenu?.col;
            if (!col) return;
            this.applySortFromMenu(col.field, direction);
            this.headerMenu.show = false;
        },
        applySortFromMenu(flexfield_column, direction) {
            const idx = this.sortList.findIndex(s => s.flexfield_column === flexfield_column);
            if (idx === -1) {
                this.sortList.push({ flexfield_column, direction });
            } else {
                this.$set(this.sortList, idx, { flexfield_column, direction });
            }
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        // Task 3-1: 篩選面板互動
        getFilterForColumn(flexfield_column) {
            return this.filterList.find(f => f.flexfield_column === flexfield_column) || null;
        },
        getFiltersForColumn(flexfield_column) {
            return this.filterList.filter(f => f.flexfield_column === flexfield_column);
        },
        _defaultOpForDtype(dtype) {
            if (dtype === 'Number') return 'equals';
            if (['File','DocumentOutput'].includes(dtype)) return 'is_empty';
            return 'contains';
        },
        openFilterPanel(e, item, column) {
            e.stopPropagation();
            const btn = e.currentTarget;
            const rect = btn.getBoundingClientRect();
            this.filterPanelPos = {
                top: Math.round(rect.bottom + 4),
                left: Math.max(8, Math.min(Math.round(rect.left), window.innerWidth - 320)),
            };
            const existing = this.getFiltersForColumn(item.flexfield_column);
            const defaultOp = this._defaultOpForDtype(item.flexfield_datatype);
            this.filterPanelDraftConditions = existing.length
                ? existing.map(f => ({ operator: f.operator, value: f.value != null ? String(f.value) : '', value2: f.value2 != null ? String(f.value2) : '' }))
                : [{ operator: defaultOp, value: '', value2: '' }];
            this.filterPanelField = item.flexfield_column;
        },
        closeFilterPanel() {
            this.filterPanelField = null;
        },
        submitFilterPanel() {
            const col = this.filterPanelField;
            if (!col) return;
            const newEntries = this.filterPanelDraftConditions
                .filter(c => {
                    if (['is_empty','is_not_empty'].includes(c.operator)) return true;
                    if (c.operator === 'between') return c.value !== '' && c.value2 !== '';
                    return c.value !== '';
                })
                .map(c => {
                    const entry = { flexfield_column: col, operator: c.operator, value: c.value };
                    if (c.operator === 'between') entry.value2 = c.value2;
                    return entry;
                });
            this.filterList = this.filterList.filter(f => f.flexfield_column !== col);
            this.filterList.push(...newEntries);
            this.closeFilterPanel();
            this.columns = [...this.columns]; // 強制表頭重繪以更新漏斗圖示
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        clearColumnFilter(col) {
            this.filterList = this.filterList.filter(f => f.flexfield_column !== col);
            this.closeFilterPanel();
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        removeFilter(flexfield_column) {
            this.filterList = this.filterList.filter(f => f.flexfield_column !== flexfield_column);
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        removeFilterByIndex(idx) {
            this.filterList.splice(idx, 1);
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        clearAllFilters() {
            this.filterList = [];
            this.columns = [...this.columns];
            this.fetchPageData({ page: 1, pageSize: this.itemPerPage });
        },
        // Task 4-1: 狀態列 chip 標籤
        getFilterChipLabel(f) {
            const meta = this.columnMetaMap?.[f.flexfield_column];
            const desc = meta?.description || meta?.name || f.flexfield_column;
            const opLabel = this.$t('DOCUMENT_AGENT.FILTER_' + f.operator.toUpperCase());
            const isNumber = String(meta?.flexfield_datatype || '').toLowerCase() === 'number';
            if (['is_empty','is_not_empty'].includes(f.operator)) return `${desc}: ${opLabel}`;
            if (f.operator === 'between') return isNumber
                ? `${desc}: ${opLabel} ${f.value} ~ ${f.value2}`
                : `${desc}: ${opLabel} "${f.value}" ~ "${f.value2}"`;
            return isNumber ? `${desc}: ${opLabel} ${f.value}` : `${desc}: ${opLabel} "${f.value}"`;
        },
        // isUserInputColumn(col) {                        // 判斷是否為 userinput 欄位
        //     const meta = this.columnMetaMap?.[col];
        //     if (!meta) return false;
        //     const model = String(meta.model || "").trim().toLowerCase();
        //     return model === "userinput";
        // },
        isEditableColumn(col) {                         // 判斷欄位是否可編輯
            const meta = this.columnMetaMap?.[col];
            if (!meta) return false;
            const model = String(meta.model || "").trim().toLowerCase();
            const dt = String(meta.flexfield_datatype || "").trim().toLowerCase();
            const modelOk = model === "userinput";
            const datatypeOk = !["file", "collection"].includes(dt);
            return modelOk && datatypeOk;
        },
        canEditCell(col) {                          // 判斷 cell 是否可編輯
            const editable = this.isEditableColumn(col);
            if (!editable) return false;
            if (this.run_agent_loading) return false;
            if (this.isUploading) return false;
            return true;
        },
        isEditingCell(rowPk, col) {                     // 判斷這一格要不要顯示編輯中
            const k = `${rowPk}:${col}`;
            return this.cellEdit.key === k;
        },
        startEditCell(rowPk, col, currentValue) {
            if (!this.canEditCell(col)) return;     // 先判斷是否可編輯
            const v = (currentValue === null || currentValue === undefined) ? "" : String(currentValue);  //把目前 cell 的值轉成字串
            this.cellEdit = {
            key: `${rowPk}:${col}`,     //正在編輯的格子的 key
            rowPk: String(rowPk),
            col,
            value: v,                   // 編輯值
            original: v,                // 原始值
            saving: false,
            error: "",
            };
        },
        cancelEditCell() {
            this.cellEdit = {
            key: null,
            rowPk: null,
            col: null,
            value: "",
            original: "",
            saving: false,
            error: "",
            };
        },
        async saveEditCell(row) {
            if (!this.cellEdit.key || this.cellEdit.saving) return;         // 若沒有在編輯中，或正在儲存中 就不處理
            const { col, value, original } = this.cellEdit;                 // 取 欄位、值、原始值
            const pk = this.cellEdit.rowPk;                                 // 取 pk
            if (!pk) {
                this.cellEdit.error = "更新失敗，pk 不存在。";
                return;
            }
            if (String(value) === String(original)) {           // 沒變就取消編輯
                this.cancelEditCell();
                return;
            }
            this.cellEdit.saving = true;
            this.cellEdit.error = "";
            try {
                const payload = { [col]: value };
                const res = await UpGPTPortalDataServices.documentAgentTableUpdateCell(pk, payload);     // call 更新 API
                if (res && res.data) {                                                              //成功直接更新 UI，不用reload
                row[col] = (res.data[col] !== undefined && res.data[col] !== null)
                    ? res.data[col]
                    : value;
                } else {
                row[col] = value;
                }
                if (this.currentTableId && col) {
                    try {
                        const dirtyRes = await UpGPTPortalDataServices.documentAgentSetDirtyflag(this.currentTableId, {
                            flexfield_column: col,
                            flexfielddata_object_id: pk
                        });
                        const s = dirtyRes?.data?.agent_status;
                        if (s) this.$set(this.documentAgentDetail, "status", s);
                    } catch (err) {
                        console.warn("set dirty failed after cell update:", err);
                    }
                }
                await this.fetchStatusOnce({ source: "auto", reloadData: false, ignoreThrottle: true });
                this.cellEdit.original = String(value);            // 更新原始值
                this.cancelEditCell();                             // 取消編輯狀態
            } catch (error) {
                console.warn("saveEditCell failed:", error);
                const msg =
                error?.response?.data?.detail ||
                error?.response?.data?.non_field_errors?.[0] ||
                (typeof error?.response?.data === "string" ? error.response.data : "") ||
                error?.message ||
                "";
                this.cellEdit.error = msg
                ? `更新失敗：${msg}`
                : "更新失敗，請確認 API 路由/權限/pk/object_id 是否正確。";
            } finally {
                this.cellEdit.saving = false;
            }
            },
        async downloadViaSasUrl(blobUrl, filename) {
            if (!blobUrl) return;
            try {
                const res = await UpGPTPortalDataServices.getSasUrl(blobUrl);
                const sasUrl = res.data?.sas_url;
                if (!sasUrl) throw new Error("SAS URL 為空");
                const a = document.createElement("a");
                a.href = sasUrl;
                if (filename) a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } catch (err) {
                console.error("[DA_SAS_DOWNLOAD_ERROR]", err);
                this.errorMessage = this.$t("DOCUMENT_AGENT.DOWNLOAD_FAILED");
                this.errorDialog = true;
            }
        },
        _buildRefPdfUrl(baseUrl) {
            const pageNum = this.refPopup.pageNum;
            const base = baseUrl.split('#')[0];
            if (!pageNum || !pageNum.length) return `${base}#view=FitH`;
            return `${base}#page=${pageNum[0]}&view=FitH`;
        },
        async _applyPdfPreviewUrl() {
            const url = this.refPopup.fileUrl || '';
            if (!url) return;
            const contextId = this.refPopup.activeContextId;
            // ── 使用快取連結 ──
            if (contextId && this._refPdfLinkCache[contextId]) {
                this.refPdfPreviewUrl = this._buildRefPdfUrl(this._refPdfLinkCache[contextId].url);
                this.refViewMode = 'preview';
                return;
            }
            // ── SharePoint / OneDrive ──
            if (/sharepoint\.com|1drv\.ms/i.test(url)) {
                this.refPdfPreviewLoading = true;
                try {
                    const colApiName = (this.refPopup.activeContextId || '').split('.')[0];
                    const res = await UpGPTPortalDataServices.getOnedriveFile(
                        this.refPopup.rowObjectId, colApiName
                    );
                    const blobUrl = URL.createObjectURL(res.data);
                    if (contextId) this._refPdfLinkCache[contextId] = { url: blobUrl, isBlobUrl: true };
                    this.refPdfPreviewUrl = this._buildRefPdfUrl(blobUrl);
                    this.refViewMode = 'preview';
                } catch (err) {
                    console.error('[REF_PDF_PREVIEW_ONEDRIVE_ERROR]', err);
                    this.refPdfFetchError = true;
                    this.refViewMode = 'preview';
                } finally {
                    this.refPdfPreviewLoading = false;
                }
                return;
            }
            // ── Azure Blob 路徑 → getSasUrlInline ──
            this.refPdfPreviewLoading = true;
            try {
                const res = await UpGPTPortalDataServices.getSasUrlInline(url);
                const sasUrl = res.data?.sas_url;
                if (!sasUrl) throw new Error('SAS URL 為空');
                if (contextId) this._refPdfLinkCache[contextId] = { url: sasUrl, isBlobUrl: false };
                this.refPdfPreviewUrl = this._buildRefPdfUrl(sasUrl);
                this.refViewMode = 'preview';
            } catch (err) {
                console.error('[REF_PDF_PREVIEW_ERROR]', err);
                this.refPdfFetchError = true;
            } finally {
                this.refPdfPreviewLoading = false;
            }
        },
        async setRefViewMode(mode) {
            if (mode === this.refViewMode) return;
            if (mode === 'preview') {
                await this._applyPdfPreviewUrl();
                if (!this.refPdfFetchError) {
                    this.refViewMode = 'preview';
                }
            } else {
                if (this.refViewMode === 'preview') {
                    this.refPdfPreviewUrl = '';
                    this.refPdfPreviewError = false;
                    this.refPdfFetchError = false;
                }
                this.refViewMode = mode;
                if (mode === 'web' && !this.refWebSearchLoaded) {
                    this.fetchWebSearchResults();
                }
            }
        },
        async fetchWebSearchResults() {
            if (!this.refPopup.rowObjectId || !this.refPopup.col) return;
            this.refWebSearchLoading = true;
            try {
                const tenant = localStorage.getItem("tenant") || "";
                const colName = this.columnMetaMap?.[this.refPopup.col]?.name || this.refPopup.col;
                const blobPath = `${tenant}/document_agent/${this.doc_agent_id}/${this.refPopup.rowObjectId}/${colName}/web_search/results.json`;
                const sasRes = await UpGPTPortalDataServices.getSasUrlWithContent(blobPath);
                const content = sasRes?.data?.content;
                this.refWebSearchResults = Array.isArray(content) ? content : [];
            } catch (e) {
                this.refWebSearchResults = [];
            } finally {
                this.refWebSearchLoading = false;
                this.refWebSearchLoaded = true;
            }
        },
        onRefPdfIframeError() {
            this.refPdfPreviewError = true;
        },
        resetRefViewMode() {
            this.refViewMode = 'text';
            this.refPdfPreviewUrl = '';
            this.refPdfPreviewLoading = false;
            this.refPdfPreviewError = false;
            this.refPdfFetchError = false;
            if (this._refPdfBlobUrl) {
                URL.revokeObjectURL(this._refPdfBlobUrl);
                this._refPdfBlobUrl = null;
            }
        },
        clearRefPdfCache() {
            if (!this._refPdfLinkCache) return;
            Object.values(this._refPdfLinkCache).forEach(entry => {
                if (entry.isBlobUrl && entry.url) {
                    URL.revokeObjectURL(entry.url);
                }
            });
            this._refPdfLinkCache = {};
        },
        async openRefInNewTab() {
            const url = this.refPopup?.fileUrl || "";           // 取URL
            const name = this.refPopup?.fileName || "download"; // 取檔名
            if (!url) return;
            if (/^https?:\/\//i.test(url)) {                    // OneDrive / SharePoint，有https直接開新分頁
                window.open(url, "_blank");
                return;
            }
            await this.downloadViaSasUrl(url, name);            // Azure Blob 路徑，走 SAS URL 下載
        },
        addBreadcrumb(columnConfiguration, parentLabel = "") {
            if(!columnConfiguration) return;

            const id = columnConfiguration.id;
            const shortName = this.getShortTableName(columnConfiguration.object_type_name); //抓table_configuration.object_type_name=土地清冊
            const label = parentLabel                                                       //抓Row第一個欄位(檔案名)
                ? `${shortName} - ${parentLabel}`                                           //組Breadcrumb名
                : shortName;
                const newItem = {                                                           //組breadcrumb item
                text: label,
                href: "#",
                value: id,
                currentParentId: this.currentParentId,
                sortList: [],   // 儲存該層級的排序狀態（進入子表前寫入，返回時還原）
                filterList: [], // 儲存該層級的篩選狀態（進入子表前寫入，返回時還原）
            }
            const existIndex = this.breadcrumbs.findIndex(b => String(b.value) === String(id)); //確認是否已存在同一個 id 的 crumb，findIndex找不到會回傳-1
            if (existIndex !== -1) {            //找到既有
                this.breadcrumbs = this.breadcrumbs.slice(0, existIndex + 1);   //砍掉既有的id之後的項目
                this.breadcrumbs.splice(existIndex, 1, newItem);                //替換既有的那筆資料
            } else {
            this.breadcrumbs.push(newItem);     //若不存在既有，新增crumb到尾端
            }
            this.syncBreadcrumbDisabled(); 
        },
        handleView(row, tableConfigId){
            let matchParentIdVal = null;
            for(let key in row){
                let value = row[key];
                if(typeof value == "object" && 'table_configuration_id' in value){
                    if(Number(value.table_configuration_id) == Number(row.toNextId)) {
                        matchParentIdVal = value?.parent_id;
                        this.currentParentId = value?.parent_id;
                    }
                }
            }
            if(tableConfigId){
                this.page = 1;
                const parentId = this.showAllParent ? null : matchParentIdVal;
                const parentFirstVal = this.getRowFirstColumnValue(row);
                this.loadTable(tableConfigId, {
                    parentid: parentId,
                    pushBreadcrumbs: true,
                    parentLabel: parentFirstVal, //抓Row第一個欄位(檔案名)
                })
            }

        },
        syncBreadcrumbDisabled() {
            this.breadcrumbs = this.breadcrumbs.map(b => ({ ...b, disabled: false }));
            const last = this.breadcrumbs.length - 1;
            if (last >= 0) this.breadcrumbs[last].disabled = true;  //將最後一個Breadcrumb設為不可點，點前面的可以回去該層
        },
        async handlePageChange(newPage){
            this.page = Number(newPage);        //接UI回傳的page值，轉number
            await this.fetchPageData({ page: this.page, pageSize: this.itemPerPage });  // 傳入目前頁碼與目前每頁筆數
        },
        async handlePageSizeChange(pageSize) {
            const oldPage = Number(this.page) || 1;             // 舊的頁碼
            const oldSize = Number(this.itemPerPage) || 20;     // 舊的每頁筆數
            const newSize = Number(pageSize) || oldSize;        // 新的每頁筆數
            const firstIndex = (oldPage - 1) * oldSize + 1;     // 計算「目前頁面第一筆資料」
            let newPage = Math.floor((firstIndex - 1) / newSize) + 1;// Math.floor向下取整，換 pageSize 後，firstIndex 會落在哪一頁
            if (this.totalCount) {                              // 避免 newPage 超出最大頁
                const maxPage = Math.max(1, Math.ceil(this.totalCount / newSize));  
                newPage = Math.min(newPage, maxPage);           // 把newPage限縮到合理值
            }
            this.itemPerPage = newSize;                         // 更新每頁筆數
            this.page = newPage;                                // 更新頁數
            await this.fetchPageData({ page: this.page, pageSize: this.itemPerPage });  // 用更新後的 page 與 pageSize打API
        },
        async fetchPageData({ page, pageSize } = {}) {
            const viewId = String(this.currentTableId || "");   // 取目前表格 id
            if (!viewId) return;
            const parentId = this.showAllParent ? null : this.currentParentId;  //collection會帶parentid
            const reqId = ++this.pageReqSeq;                    // 產生一個「請求序號」：每呼叫一次就 +1
            this.pageReqInFlight = true;                        // 防止重複請求
            try {
                const res = await UpGPTPortalDataServices.documentAgentTableData(viewId, {  //呼叫後端取資料
                parentid: parentId,                                 // collection會帶parentid
                page: Number(page ?? this.page),                    //用傳入或目前page
                pagesize: Number(pageSize ?? this.itemPerPage),     //用傳入或目前pageSize
                ...(this.sortList.length && { sort: JSON.stringify(this.sortList) }),
                ...(this.filterList.length && { filter: JSON.stringify(this.filterList) }),
                lang: (this.$i18n && this.$i18n.locale) || 'zh-TW',
                });
                if (reqId !== this.pageReqSeq) return;              // 丟棄不是最新的請求
                const data = res?.data || {};                       // 避免 res 或 res.data 是 undefined
                this.tableData = data.items || [];                  // 更新表格顯示資料
                this.totalCount = Number(data.total_count || 0);    // 更新總筆數
                this.page = Number(page ?? this.page);              // 以前端page/pageSize 為準
                this.itemPerPage = Number(pageSize ?? this.itemPerPage);
                this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.itemPerPage));   // 計算總頁數，至少要是 1
                this.showEmpty = (this.tableData.length === 0);     //無資料提示
            } finally {
                if (reqId === this.pageReqSeq) this.pageReqInFlight = false;    // 最後一次請求才關 inFlight
            }
        },
        onBreadcrumbClick(item){
            let breadcrumb_index = this.breadcrumbs.findIndex(b => b.value == item.value);
            if(breadcrumb_index == -1) return;
            // 把 breadcrumbs 切到點擊那一層為止
            this.breadcrumbs = this.breadcrumbs.slice(0, breadcrumb_index+1);
            this.syncBreadcrumbDisabled();
            // // 重新標示最後一個 disabled
            // this.breadcrumbs = this.breadcrumbs.map((b, i) => (
            //     {
            //         ...b,
            //         disabled: i == this.breadcrumbs.length - 1
            //     }
            // ))
            // this.currentParentId = item.currentParentId ?? null;
            const parentId = this.showAllParent ? null : item.currentParentId;
            // 還原該層級儲存的排序/篩選狀態
            this.sortList = [...(item.sortList || [])];
            this.filterList = [...(item.filterList || [])];
            this.page = 1;
            this.loadTable(item.value, {
                parentid: parentId,
                pushBreadcrumbs: false
            })
        },
        showAgentIconEditDialog() {
            this.selectagenticondialog = true;
        },
        onEmitSelectAgentIconDialog(icon_obj) {
            this.select_icon_obj = icon_obj;
            this.documentAgentDetail.icon_path = this.select_icon_obj.name;
            let data = {
                "agent_name": this.documentAgentDetail.agent_name,
                "icon_path": this.documentAgentDetail.icon_path,
                "instruction": this.documentAgentDetail.instruction
            }
            this.editDocumentAgent(data);
            this.selectagenticondialog = false;
        },
        // async waitUploadCompleted({ intervalMs = 2000, timeoutMs = 10 * 60 * 1000 } = {}) {
        //     const start = Date.now();
        //     while (Date.now() - start <= timeoutMs) {
        //         const res = await UpGPTPortalDataServices.getUserDocumentDetail(this.doc_agent_id);
        //         const st = String(res?.data?.upload_status || "").toLowerCase();
        //         this.documentAgentDetail = res.data;
        //         if (st === "completed") return "completed";
        //         if (st === "fail" || st === "failed") return "failed";
        //         await new Promise(r => setTimeout(r, intervalMs));
        // }
        // throw new Error("等待同步/解析逾時，請稍後按 Refresh。");
        // },
        async runAgent(payload = { type: "default" }){                  //傳參數
            const user_agent_id = this.documentAgentDetail.id;
            // 授權停止服務或無效時不執行任何工作。四種執行方式（default / all /
            // column / cell）與儲存欄位設定後的自動重新產生都經過這裡，擋這一處
            // 即可涵蓋全部；UI 上的停用只是外觀提示。送出前重新查一次狀態，
            // 避免使用者長時間停留在頁面上、拿舊狀態放行。
            if (await this.$store.dispatch('refreshLicenseBlocking')) return;
            if (this.run_agent_loading || this.addBtn_loading) return;
            // OneDrive 模式才要求 O365 account，FileUpload不需要O365
            if (this.cloudDriveEnabled && !this.hasSelectedFolder) return;
            const finalPayload = {      // 組payload(default/all)
                type: "default",
                ...(payload || {}),     //前端給all就覆蓋，沒給就default
            };
            const runType = String(finalPayload.type || "default").toLowerCase();
            const isPartialRun = runType === "cell" || runType === "column" || runType === "all";
            if (!this.canRunAgent && !isPartialRun) return; // default需驗證；cell/column/all/collection能rerun
            this.stopAutoPolling();
            this.run_agent_loading = true;
            try {
                await UpGPTPortalDataServices.runAgent(user_agent_id, finalPayload);
                this.runFinalRefreshed = false;
                this.runFinishStableCount = 0;
                this.isRunning = true;
                this.runStartedAt = Date.now();
                this.statusMapByTable = {};
                this.errorMsgMapByTable = {}; //  同步清除錯誤訊息
                this.statusMap = {}; // 兼容舊的，留著
                this.startStatusPolling();
            } catch (err) {
                console.warn("runAgent chain failed:", err);
                const msg =
                    err?.response?.data?.detail ||
                    err?.message ||
                    "Run Agent 失敗";
                this.showErrorDialog(msg);
                this.isRunning = false;
                this.stopStatusPolling();
                this.stopRunDataPolling();
                this.startAutoPolling();
            } finally {
                if (!this.isRunning) {
                    this.run_agent_loading = false;
                }
            }
        },
        mapping_icon_path(icon_name){
            if (icon_name == 'award') {
                return require("@/assets/images/agent_icon/award.png")
            } else if (icon_name == 'cloud'){
                return require("@/assets/images/agent_icon/cloud.png")
            } else if (icon_name == 'construction'){
                return require("@/assets/images/agent_icon/construction.png")
            } else if (icon_name == 'customerservice'){
                return require("@/assets/images/agent_icon/customerservice.png")
            } else if (icon_name == 'finance'){
                return require("@/assets/images/agent_icon/finance.png")
            } else if (icon_name == 'generate'){
                return require("@/assets/images/agent_icon/generate.png")
            } else if (icon_name == 'humanresource'){
                return require("@/assets/images/agent_icon/humanresource.png")
            } else if (icon_name == 'idea'){
                return require("@/assets/images/agent_icon/idea.png")
            } else if (icon_name == 'knowledge'){
                return require("@/assets/images/agent_icon/knowledge.png")
            } else if (icon_name == 'message'){
                return require("@/assets/images/agent_icon/message.png")
            } else if (icon_name == 'metal'){
                return require("@/assets/images/agent_icon/metal.png")
            } else if (icon_name == 'policy'){
                return require("@/assets/images/agent_icon/policy.png")
            } else if (icon_name == 'questionandanswer'){
                return require("@/assets/images/agent_icon/questionandanswer.png")
            } else if (icon_name == 'report'){
                return require("@/assets/images/agent_icon/report.png")
            } else if (icon_name == 'robot'){
                return require("@/assets/images/agent_icon/robot.png")
            } else if (icon_name == 'searchimage'){
                return require("@/assets/images/agent_icon/searchimage.png")
            } else if (icon_name == 'setting'){
                return require("@/assets/images/agent_icon/setting.png")
            } else if (icon_name == 'shopping_cart'){
                return require("@/assets/images/agent_icon/shopping_cart.png")
            } else if (icon_name == 'speclist'){
                return require("@/assets/images/agent_icon/speclist.png")
            } else if (icon_name == 'translate'){
                return require("@/assets/images/agent_icon/translate.png")
            } else if (icon_name == 'conversation'){
                return require("@/assets/images/agent_icon/conversation.png")
            } else if (icon_name == 'record'){
                return require("@/assets/images/agent_icon/record.png")
            } else if (icon_name == 'target'){
                return require("@/assets/images/agent_icon/target.png")
            } else {
                return require("@/assets/images/agent_icon/default.png")
            }
        },
        showErrorDialog(message) {
            this.errorDialog = true;
            this.errorMessage = message;
        },
        onEmitErrorDialog() {
            this.errorDialog = false;
        },
        // 載入 Instance 明細/表格失敗的處理。權限被擁有者撤銷或 Instance 已被刪除後，
        // 使用者若未重整頁面再次進入會拿到 403/404；過去沒有 catch 導致一直卡在 loading skeleton。
        handleDetailAccessError(error) {
            this.loading = false;
            const status = error && error.response && error.response.status;
            if (status === 403 || status === 404) {
                this.accessRevokedDialog = true;
            } else {
                console.error('[getDocumentAgentDetail] 載入失敗', error);
            }
        },
        reloadPage() {
            window.location.reload();
        },
        async refresh(){
            let requested_id = this.doc_agent_id;
            if(requested_id){
                await UpGPTPortalDataServices.getUserDocumentDetail(requested_id).then((response) => {
                    if(this.doc_agent_id !== requested_id) return;
                    const st = String(response.data?.upload_status || "").toLowerCase();
                    if (st === "processing") {
                        this.isUploading = true;
                    } else if (st === "completed") {
                        this.documentAgentDetail = response.data;
                        let object_id = this.documentAgentDetail.table_configurations[0].id;
                        this.loadTable(object_id, {
                            pushBreadcrumbs: false
                        });
                        this.isUploading = false;
                        this.addBtn_loading = false;
                        this.startAutoPolling();
                    } else if (st === "fail" || st === "failed") {
                        this.isUploading = false;          // 避免卡死
                        this.addBtn_loading = false;
                        this.showErrorDialog("檔案同步/解析失敗，請重新嘗試或查看後端 log。");
                    } else {
                        this.isUploading = false;
                        this.addBtn_loading = false;
                    }

                }).catch(this.handleDetailAccessError);
            }
        },
        // normalizeUploadStatus(st){
        //     return String(st || "").toLowerCase();
        // },
        // isUploadBusy(st){
        //     st = this.normalizeUploadStatus(st);
        //     return st === "processing";
        // },
        // isUploadFailed(st){
        //     st = this.normalizeUploadStatus(st);
        //     return st === "fail" || st === "failed";
        // },
        changeAllParent(val){
            let parentId;
            if(val){
                parentId = null
            }else{
                parentId = this.currentParentId
            }
            let object_id = this.currentTableId;
            // 取得表格資料
            this.loadTable(object_id, {
                parentid: parentId,
                pushBreadcrumbs: false
            });
        },
        async exportDOC(){
            console.log("[exportDOC] clicked");
            this.consentDialog = true;
            this.consentLoading = true;
            this.consentForm.project_name = (this.documentAgentDetail?.agent_name || "同意書");
            try {
                const res = await UpGPTPortalDataServices.getConsentFormOptions();
                const data = res?.data || {};
                this.consentOptions = {
                    land_agents: Array.isArray(data.land_agents) ? data.land_agents : [],
                    construction_agents: Array.isArray(data.construction_agents) ? data.construction_agents : [],
                };
                if (this.consentOptions.land_agents.length === 1) {
                    this.consentForm.land_agent_id = this.consentOptions.land_agents[0].id;
                }
                if (this.consentOptions.construction_agents.length === 1) {
                    this.consentForm.construction_agent_id = this.consentOptions.construction_agents[0].id;
                }
            } catch (e) {
                console.warn("getConsentFormOptions failed:", e);
                const msg = e?.response?.data?.detail || e?.message || "取得同意書選項失敗";
                this.showErrorDialog(msg);
                this.consentDialog = false;
            } finally {
                this.consentLoading = false;
            }
        },
        submitConsentForm(){
            if (!String(this.consentForm.project_name || "").trim()) {  //專案名稱必填
                this.showErrorDialog("請輸入專案名稱");
                return;
            }
            if (!this.consentForm.land_agent_id) {              //土地清冊必填  
                this.showErrorDialog("請選擇土地清冊");
                return;
            }
            if (!this.consentForm.construction_agent_id) {      //建號清冊必填
                this.showErrorDialog("請選擇建號清冊");
                return;
            }
            this.consentSubmitting = true;                  //進入loading
            UpGPTPortalDataServices.generateConsentForm({   //call API 產生同意書
                python_code: "generate_consent_form",       //對應後端python function名稱
                project_name: this.consentForm.project_name,    //專案名稱
                land_agent_id: this.consentForm.land_agent_id,  //土地清冊id
                construction_agent_id: this.consentForm.construction_agent_id,  //建號清冊id
            })
            .then((response) => {
                const blob = new Blob([response.data], { type: "application/zip" });    //用 Blob 封裝 response.data，並指定type為zip
                const cd = response?.headers?.["content-disposition"] || "";            //從 response headers 解析檔名（Content-Disposition）
                const m = cd.match(/filename\*?=(?:UTF-8''|")?([^";\n]+)(?:"|;|\n|$)/i);    //用正則表達式抓 filename
                const filename = decodeURIComponent(m?.[1] || "") || `${this.consentForm.project_name}.zip`;    //用decodeURIComponent解碼filename*=UTF-8''，若沒提供檔名或解析失敗，改用專案名稱當檔名
                const url = window.URL.createObjectURL(blob);   //建立一個URL讓瀏覽器下載 Blob
                const a = document.createElement("a");          //用 <a download> 觸發下載
                a.href = url;
                a.download = filename;              //設定下載檔名
                document.body.appendChild(a);       //把 <a> 加到 DOM 裡
                a.click();                          //觸發下載
                a.remove();                         //下載後移除 <a>
                window.URL.revokeObjectURL(url);    //釋放URL避免占用記憶體
                this.consentDialog = false;         //關閉dialog
            })
            .catch((e) => {
                console.warn("generateConsentForm failed:", e);     //錯誤處理
                const status = e?.response?.status;                 //抓status code
                if (status === 404) {
                    this.showErrorDialog("土地清冊及建號清冊無資料，請先 Run Agent 產生資料後再匯出。");
                    return;
                }
                const msg = e?.response?.data?.detail || e?.message || "生成同意書失敗";    //錯誤訊息優先用後端回傳的 detail，其次用 JS error message，最後給預設文字
                this.showErrorDialog(msg);  
            })
            .finally(() => {
                this.consentSubmitting = false;     //結束 loading
            });
        },
        closeConsentDialog(){
            this.consentDialog = false;
        },
        saveAsTemplate() {
            this.saveAsTemplateDialogVisible = true;
        },
        onEmitSaveAsTemplateSuccess() {
            this.saveAsTemplateDialogVisible = false;
        },
        onEmitSaveAsTemplateCancel() {
            this.$refs.saveAsTemplateDialog && this.$refs.saveAsTemplateDialog.resetForm();
            this.saveAsTemplateDialogVisible = false;
        },
        onEmitSaveAsTemplateError(msg) {
            this.$refs.saveAsTemplateDialog && this.$refs.saveAsTemplateDialog.resetForm();
            this.saveAsTemplateDialogVisible = false;
            this.showErrorDialog(msg);
        },
        async exportExcel(){
            this.addBtn_loading = true;
            let config = this.tableConfigurations.find(
                t => t.id == this.currentTableId
            );
            let fileName = `${this.documentAgentDetail.agent_name.replaceAll(/\./g, '')}-${config.object_type_name.replaceAll(/\./g, '')}`;
            const parentIdToSend = this.showAllParent ? null : this.currentParentId;
            fetchExcelDownload(this.currentTableId, parentIdToSend, fileName);
            this.addBtn_loading = false;
        },
        async changeAutoSync(){
            let data = {
                "schedule_update": this.autoSync,
            };
            await UpGPTPortalDataServices.autoSyncDocumentAgent(this.documentAgentDetail.id, data)
            // .then((response) => {
            //     console.log("AAAAA", response.data)
            // })
        },
        openHeaderMenu(e,column){
            this.headerMenu.x = e.clientX;
            this.headerMenu.y = e.clientY;
            this.headerMenu.col = column;
            this.headerMenu.show = false;
            this.$nextTick(() => (this.headerMenu.show = true));
        },
        showDeleteColumnDialog(){
            this.deleteColumnDialog = true;
        },
        async onClickMenuAction(key){
            if(!this.headerMenu.col) return;
            // 排序（三點選單入口）
            if (key === 'sort_asc' || key === 'sort_desc') {
                this.applySortFromMenu(this.headerMenu.col.field, key === 'sort_asc' ? 'asc' : 'desc');
                this.headerMenu.show = false;
                return;
            }
            // 篩選（三點選單入口）
            if (key === 'filter') {
                const col = this.headerMenu.col;
                const meta = this.columnMetaMap?.[col.field];
                if (!meta) return;
                this.filterPanelPos = {
                    top: Math.round(this.headerMenu.y),
                    left: Math.max(8, Math.min(Math.round(this.headerMenu.x), window.innerWidth - 320)),
                };
                const existing = this.getFiltersForColumn(col.field);
                const defaultOp = this._defaultOpForDtype(meta.flexfield_datatype);
                this.filterPanelDraftConditions = existing.length
                    ? existing.map(f => ({ operator: f.operator, value: f.value != null ? String(f.value) : '', value2: f.value2 != null ? String(f.value2) : '' }))
                    : [{ operator: defaultOp, value: '', value2: '' }];
                this.filterPanelField = col.field;
                this.headerMenu.show = false;
                return;
            }
            if(key == "properties"){
                try {
                    const cfg = this.getCurrentTableConfig?.() || this.tableConfigurations.find(t => String(t.id) === String(this.currentTableId));
                    this.editingConfigTableName = cfg?.object_type_name || this.documentAgentDetail?.agent_config?.table || "";
                    const editData = await this.getTableConfigList(this.headerMenu.col);
                    if (!editData || !editData.flexfield_column) {
                        this.showErrorDialog("找不到該欄位設定，請確認 documentAgentTableHeader API 回傳是否包含此欄位。");
                        return;
                    }
                    if (editData.model === null || editData.model === undefined || String(editData.model).trim() === "") {
                        const model = this.documentAgentDetail?.agent_config?.model;
                        if (model) editData.model = model;
                    }
                    this.editData = editData;
                    this.original_data = JSON.parse(JSON.stringify(editData));
                    const model = String(editData?.model || "").trim().toLowerCase();
                    this.isEditColumnLinkedInput = model === "linkedinput";
                    this.columnDialog.key += 1;
                    const ensureIds = Array.isArray(this.editData?.read_documents) ? this.editData.read_documents : []; // 確保視窗打開時，已勾選項目有在items中
                    await this.searchReadDocuments({ keyword: "", ensureIds }); // 拿清單，keyword先給空，確保資料出現，並填入已勾選項目
                    this.columnDialog.childCollectionColumns = [];
                    const _dt = String(editData?.flexfield_datatype || "").trim().toLowerCase();
                    if (_dt === "collection") {
                        const _ct = String(editData?.collection_table || "").trim();
                        const _childCfg = _ct
                            ? (this.tableConfigurations || []).find(t => {
                                const ot = String(t?.object_type_name || "");
                                return ot === _ct || ot.endsWith(`.${_ct}`) || ot.includes(_ct);
                              })
                            : null;
                        if (_childCfg?.id) {
                            try {
                                const _childRes = await UpGPTPortalDataServices.documentAgentTableHeader(_childCfg.id);
                                this.columnDialog.childCollectionColumns = _childRes?.data?.tenant_db_flexfieldmetadata || [];
                            } catch (_) {
                                // 無法取得時不做跨表驗證
                            }
                        }
                    }
                    this.openColumnDialogForEdit(editData);
                } catch (e) {
                const msg =
                    e?.response?.data?.detail ||
                    e?.message ||
                    "開啟欄位設定失敗";
                this.showErrorDialog(msg);
                } finally {
                this.headerMenu.show = false;
                }
            }
            if(key == "regenerate"){
                try {
                    const field = this.headerMenu.col.field || "";
                    if(!field) return;
                    const parentId = this.showAllParent ? null : this.currentParentId;
                    await this.runAgent({
                        type: "column",
                        table_config_id: this.currentTableId,
                        flexfield_column: field,
                        parent_id: parentId,
                    });
                } finally {
                    this.headerMenu.show = false;
                }
            }
            if (key == "delete") {
                try {
                    const col = this.headerMenu.col;
                    if (!col || !col.field) return;
                    const editData = await this.getTableConfigList(col);
                    this.deleteColumnTarget = { name: col.name, field: col.field, label: col.title, flexfield_datadetail: editData?.flexfield_datadetail || "",};
                    this.deleteColumnDialog = true;
                } catch (e) {
                    const msg = e?.response?.data?.detail || e?.message || "刪除欄位失敗";
                    this.showErrorDialog(msg);
                } finally {
                    this.headerMenu.show = false;
                }
            }
        },
        async getTableConfigList(col){
            let config = await UpGPTPortalDataServices.documentAgentTableHeader(this.currentTableId);
            let metaColumn = config.data['tenant_db_flexfieldmetadata'];
            let target = metaColumn.filter(item=> item.flexfield_column
            == col.field)
            let [data] = target
            if (data && (data.model === null || data.model === undefined || String(data.model).trim() === "")) {
                const model = this.documentAgentDetail?.agent_config?.model;
                if (model) data.model = model;
            }
            return data
        },
        async collectUserInputList() {
            const agentConfig = this.documentAgentDetail?.agent_config;
            const rootName = String(agentConfig?.table || "").trim();   // 取object_type_name
            const currentId = String(this.currentTableId);
            const rootId = String(this.rootTableId);
            const currentCfg = (this.tableConfigurations || []).find(t => String(t?.id) === currentId);// 從currentId抓當前Config
            const currentFullName = String(currentCfg?.object_type_name || "").trim();  // 找目前表名稱(object_type_name)
            const chain = [];                   // chain：自己>父>...>>root("土地清冊.所有權人.地址明細", "土地清冊.所有權人", "土地清冊")
            if (currentId === rootId) {         
                chain.push(rootName);           // 目前表名稱(object_type_name)
            } else {
                let name = currentFullName;
                while (name) {
                    chain.push(name);
                    if (name === rootName) {    // 持續push object_type_name直到=root
                        break;
                    }
                    const dotIndex = name.lastIndexOf(".");
                    if (dotIndex < 0) {
                        break;
                    }
                    name = name.slice(0, dotIndex); // 把.後去掉，得到父層
                }
            }
            const items = [];                       //陣列，包含header/divider/選項
            for (let i = 0; i < chain.length; i++) {
                const tableName = chain[i];         // 這一層的表名
                if (i > 0) {                        // 從第二層開始
                    items.push({ divider: true });  // 目前和父層之間加分隔線
                }
                items.push({ header: this.getShortTableName(tableName) });// 土地清冊.所有權人=>所有權人
                let cols = [];                      // 放這一層table的flexfield metadata
                if (i === 0) {                      // 第一層
                    cols = this.currentHeader || [];// 拿metadata list
                } else {
                    const cfg = (this.tableConfigurations || []).find(      // 去Config找object_type_name等於tableName的那一筆
                        t => String(t?.object_type_name || "") === tableName
                    );
                    const tableId = cfg?.id;        // 取那一筆的 tableConfigId
                    const res = await UpGPTPortalDataServices.documentAgentTableHeader(tableId);    // call API 取得那一筆資訊
                    cols = res?.data?.tenant_db_flexfieldmetadata || [];    // 取metadata
                }
                for (let colIndex = 0; colIndex < cols.length; colIndex++) { // 把該層 table 的欄位 cols 轉成 v-select 的選項
                    const col = cols[colIndex];         // 把col下的每一筆id, name push出來
                    if (!col) continue;
                    if (col.hidden === true) continue;  // hidden不顯示(FK) 
                    items.push({                        // 加入可被選擇的項目
                        id: col.name,                   // COL-XXX
                        name: col.description,          // "所有權人"
                    });
                }
            }
            return items;                               // 回傳給 v-select 當作選項
        },
        async editDocumentAgentConfig(data){
            this.addBtn_loading = true;
            try {
                const cfg = this.getCurrentTableConfig?.() || this.tableConfigurations.find(t => String(t.id) === String(this.currentTableId));
                const tableName = this.editingConfigTableName || cfg?.object_type_name || this.documentAgentDetail?.agent_config?.table;
                let processedDetail = data.flexfield_datadetail;                                                //處理 flexfield_datadetail 的資料型別問題
                const dt = String(data.flexfield_datatype || "").trim();
                if(dt === "File"){
                    if (processedDetail == null || processedDetail === "null" || processedDetail === "" || processedDetail === undefined){
                        processedDetail = null;
                    }
                } else if (typeof processedDetail === 'string') {
                    try {
                        const parsed = JSON.parse(processedDetail);                                             // 解析 JSON 字串
                        processedDetail = Array.isArray(parsed) ? parsed : null;                                //如果解析失敗則設為 null
                    } catch (e) {
                        processedDetail = null;
                    }
                }
                const payload = {
                    table: tableName,
                    name: data.name,
                    description: data.description,
                    model: data.model,
                    reasoning_effort: data.reasoning_effort,
                    input: data.input,
                    read_documents: data.read_documents,
                    web_search_enabled: data.web_search_enabled ?? false,
                    user_prompt: data.user_prompt,
                    tool_config: data.tool_config ?? undefined,
                    hidden: data.hidden ?? false,
                    is_key_field: data.is_key_field ?? false,
                    flexfield_datatype: data.flexfield_datatype,
                    flexfield_column: data.flexfield_column || data.field,
                    collection_table: data.collection_table,
                    collection_properties: data.collection_properties,
                    collection_properties_description: data.collection_properties_description,
                    flexfield_datadetail: processedDetail, // 使用處理後的資料
                };
                if (!payload.table) throw new Error("找不到目前表格名稱（table / object_type_name）");
                if (!payload.name) throw new Error("缺少欄位 name");
                if (!payload.flexfield_column) throw new Error("缺少 flexfield_column");
                const res = await UpGPTPortalDataServices.updateAgentConfigColumn(this.documentAgentDetail.id, payload);
                if (res?.data?.status) {
                    this.$set(this.documentAgentDetail, "status", res.data.status);
                }
                await this.fetchDocumentAgentFileType();
                // Task9560: 統一刷新 tableConfigurations 與 agent_config，不導航，覆蓋所有 file_type
                await this.refreshAgentConfigAndTableList();
                // 不在此呼叫 getDocumentAgentDetail()：它內部 loadTable(pushBreadcrumbs:true) 會清空
                // sortList/filterList（排序/篩選 chip）並新增麵包屑。欄位設定存檔屬於「同表刷新」，
                // 需要的 tableConfigurations/agent_config 已由 refreshAgentConfigAndTableList() 更新，
                // 表格欄位資料由下方 loadTable(pushBreadcrumbs:false) 重抓即可。

                const skipDirtyflag = (() => {
                    if (String(payload.model || "").trim().toLowerCase() !== "python") return false;
                    const orig = this.original_data || {};
                    const scriptChanged =
                        String(orig.user_prompt || "") !== String(payload.user_prompt || "");
                    const origInput = JSON.stringify([...(orig.input || [])].sort());
                    const newInput = JSON.stringify([...(payload.input || [])].sort());
                    const inputChanged = origInput !== newInput;
                    return scriptChanged || inputChanged;
                })();

                // 「以圖像分析 PDF」有效值變更時，後端已只針對 PDF 儲存格標示，前端不再整欄標示
                const pdfAsImageChanged = (() => {
                    if (dt !== "File") return false;
                    const eff = (d) => !!(d && typeof d === "object" && !Array.isArray(d) && d.pdf_as_image);
                    return eff(this.original_data?.flexfield_datadetail) !== eff(payload.flexfield_datadetail);
                })();
                
                if (this.currentTableId && payload.flexfield_column && !skipDirtyflag && !pdfAsImageChanged) {
                    try {
                        const dirtyRes = await UpGPTPortalDataServices.documentAgentSetDirtyflag(this.currentTableId, {
                            flexfield_column: payload.flexfield_column,
                            flexfielddata_object_id: null
                        });
                        const s = dirtyRes?.data?.agent_status;
                        if (s) this.$set(this.documentAgentDetail, "status", s);
                    } catch (err) {
                        console.warn("set dirty failed after config update:", err);
                    }
                }
                this.columnDialog.open = false;
                this.columnDialog.key += 1;
                await this.loadTable(this.currentTableId, {
                    parentid: this.currentParentId,
                    pushBreadcrumbs: false,
                });
            } catch (e) {
                const responseData = e?.response?.data;
                let msg = "";
                if (Array.isArray(responseData)) msg = responseData.join("\n");         //responseData 若是 Array就join 成文字
                else if (typeof responseData === "object" && responseData !== null) {   //若是 Object，例如 {"flexfield_datadetail":["..."]}
                    msg = Object.values(responseData).flat().join("\n");                //把 values 展開顯示
                }
                else msg = responseData?.detail || e?.message || "更新 agent_config 失敗";
                this.showErrorDialog(msg);
                this.columnDialog.key += 1;
            } finally {
                this.addBtn_loading = false;
            }
        },
        async refreshAgentConfigAndTableList() {
            try {
                const detailRes = await UpGPTPortalDataServices.getUserDocumentDetail(this.documentAgentDetail.id);
                this.tableConfigurations = detailRes.data["table_configurations"];
                this.rootTableId = this.tableConfigurations[0]?.id;
                if (detailRes.data.agent_config) {
                    this.documentAgentDetail.agent_config = detailRes.data.agent_config;
                }
            } catch (err) {
                console.warn("refreshAgentConfigAndTableList failed:", err);
            }
        },
        getCurrentTableConfig() {
            return this.tableConfigurations.find(t => String(t.id) === String(this.currentTableId)) || null;
        },
        // async checkCurrentStatus(){
        //     let object_id = this.currentTableId;
        //     await UpGPTPortalDataServices.checkCurrentStatus(object_id, {
        //         tableName: this.documentAgentDetail.agent_config.table
        //     }).then((response)=>{
        //         console.log("STATUS RES", response.data)
        //     })
        // },
        applyStatusMap(statusList, tableId) {
            const tid = String(tableId || this.currentTableId || "");
            if (!tid) return;
            if (!this.statusMapByTable) this.statusMapByTable = {};
            if (!this.statusMapByTable[tid]) this.$set(this.statusMapByTable, tid, {});
            if (!this.errorMsgMapByTable) this.errorMsgMapByTable = {};
            if (!this.errorMsgMapByTable[tid]) this.$set(this.errorMsgMapByTable, tid, {});
            const tableMap = this.statusMapByTable[tid];
            const errorMap = this.errorMsgMapByTable[tid];
            const meaningful = new Set(["PROCESSING", "FINISHED", "UPDATED" , "NOT_STARTED", "ERROR"]);
            //  若後端回空陣列：不要清空，維持原 icon（避免閃掉）
            if (!Array.isArray(statusList) || statusList.length === 0) return;
            for (const row of statusList) {
                const oid = String(row?.object_id || "");
                if (!oid) continue;
                if (!tableMap[oid]) this.$set(tableMap, oid, {});
                if (!errorMap[oid]) this.$set(errorMap, oid, {});
                const cellMap = tableMap[oid];
                const cellErrorMap = errorMap[oid];
                //  從 flexfield_error 更新錯誤訊息快取
                const rowErrors = row.flexfield_error || {};
                const allErrorCols = new Set([...Object.keys(cellErrorMap), ...Object.keys(rowErrors)]);
                for (const col of allErrorCols) {
                    const msg = rowErrors[col] != null ? String(rowErrors[col]) : null;
                    if (msg) {
                        this.$set(cellErrorMap, col, msg);
                    } else {
                        this.$delete(cellErrorMap, col);
                    }
                }
                // 合併每個欄位狀態：只在「有意義」時更新
                for (const [k, v] of Object.entries(row || {})) {
                    if (k === "object_id") continue;
                    if (k === "flexfield_error") continue; //  跳過 flexfield_error 物件本身
                    if (v == null) continue;
                    const sv = String(v).trim().toUpperCase();
                    if (!meaningful.has(sv)) continue;
                    this.$set(cellMap, k, sv);
                    //  狀態恢復為非 ERROR 時，清除對應的錯誤訊息
                    if (sv !== "ERROR" && cellErrorMap[k]) {
                        this.$delete(cellErrorMap, k);
                    }
                }
            }
        },
        getCellStatus(row, flexfieldColumn) {
            const tid = String(this.currentTableId || "");
            const oid = String(row?.object_id || "");
            if (!tid || !oid || !flexfieldColumn) return null;
            //  優先用 per-table map
            const v = this.statusMapByTable?.[tid]?.[oid]?.[flexfieldColumn];
            if (v) return v;
            // （保險）兼容舊 statusMap
            const legacy = this.statusMap?.[oid]?.[flexfieldColumn];
            return legacy || null;
        },
        getCellErrorMsg(row, flexfieldColumn) {
            const tid = String(this.currentTableId || "");
            const oid = String(row?.object_id || "");
            if (!tid || !oid || !flexfieldColumn) return null;
            return this.errorMsgMapByTable?.[tid]?.[oid]?.[flexfieldColumn] || null;
        },
        // 把儲存格錯誤訊息轉成顯示文字：已知代碼翻譯（含參數插值），其餘原文顯示
        resolveCellErrorMsg(msg) {
            if (!msg) return msg;
            if (WEB_SEARCH_ERROR_CODES.has(msg) || DOCUMENT_OUTPUT_ERROR_CODES.has(msg)) {
                return this.$t('DOCUMENT_AGENT_PROPERTY.' + msg);
            }
            if (typeof msg === 'string' && msg.trim().startsWith('{')) {
                try {
                    const parsed = JSON.parse(msg);
                    if (parsed && IMAGE_ERROR_CODES.has(parsed.code)) {
                        return this.$t('DOCUMENT_AGENT_PROPERTY.' + parsed.code, parsed.params || {});
                    }
                } catch (e) {
                    // 不是合法 JSON：當成一般錯誤原文顯示
                }
            }
            return msg;
        },
        // isAllFinish(statusList) {
        //     if (!Array.isArray(statusList)) return false;
        //     const allowed = new Set((this.columns || []).map(c => c?.field).filter(f => f && f !== "index").map(String));
        //     return statusList.every(row => {
        //         for (const [key, value] of Object.entries(row || {})) {
        //             if (key === "object_id") continue;
        //             if (String(key).startsWith("flexfield_collection")) continue;
        //             if (!allowed.has(key)) continue;
        //             if (!(value === "FINISHED" || value === "ERROR" || value === null)) {
        //                 return false;
        //             }
        //         }
        //         return true;
        //     });
        // },
        // ****************************
        // replaced by renderStatusIcon
        // ****************************
        // renderStatusCell(h, status, node){
        //     const icon = (() => {
        //         if (!status) return null;
        //         if (status === "PROCESSING") {
        //             return h("img", {
        //                 attrs: { src: this.processingIcon, alt: "processing", width: "15", height: "15" },
        //                 class: "da-status-icon"
        //             });
        //         }
        //         if (status === "FINISHED") {
        //             return h("img", {
        //                 attrs: { src: this.finishIcon, alt: "finished", width: "15", height: "15" },
        //                 class: "da-status-icon"
        //             });
        //         }
        //         return null;
        //     })();
        //     return h("div", { class: ["da-cell", "da-cell-status"] }, [
        //         h("div", { class: "da-cell-content" }, [node]),
        //         icon ? h("span", { class: "da-status-wrap" }, [icon]) : null
        //     ]);
        // },
        renderStatusIcon(h, status) {
            if (!status) return null;
            if (status === "PROCESSING") {
                return h(VProgressCircular, {
                    props: {
                        indeterminate: true,
                        size: 14,
                        width: 2,
                        color: "#18bedf"
                    },
                    class: "da-status-icon",
                    style: { display: "inline-block" }
                });
            }
            if (status === "FINISHED") {
                return h("img", {
                    attrs: { src: this.finishedIcon, alt: "finished", width: "10", height: "10" },
                    class: "da-status-icon"
                });
            }
            if (status === "NOT_STARTED") {
                return h("img", {
                    attrs: { src: this.notStartedIcon, alt: "not_started", width: "10", height: "10" },
                    class: "da-status-icon"
                });
            }
            if (status === "UPDATED") {
                return h("img", {
                    attrs: { src: this.updatedIcon, alt: "updated", width: "10", height: "10" },
                    class: "da-status-icon"
                });
            }

            if (status === "ERROR") {
                return h("img", {
                    attrs: { src: this.errorIcon, alt: "error", width: "10", height: "10" },
                    class: "da-status-icon"
                });
            }

            return null;
        },
        renderCellContent(h, item, row) {
            const field = item.flexfield_column;
            const dt = String(item?.flexfield_datatype || "").trim().toLowerCase();
            if (dt === "collection") {
                const cellValue = row[field]?.display_value;
                const children = [h("span", { class: "da-ellipsis", attrs: { title: cellValue } },  cellValue)];
                if(cellValue){
                    row.toNextId = Number(row[field]?.table_configuration_id);
                    let tableConfigId = Number(row[field]?.table_configuration_id);
                    children.push(
                        h(
                            "button",
                            {
                                class: "ml-2 btn-style",
                                on: { click: () => this.handleView(row, tableConfigId) },
                            },
                            [
                                h("img", {
                                    attrs: {
                                        src: this.linkIcon,
                                        alt: "link",
                                        width: "15",
                                        height: "15",
                                    },
                                    class: "icon-img"
                                }),
                            ]
                        )
                    );
                }
                return h("div", { class: "d-flex align-center da-content" }, children);
            }
            if (dt === "file") {
                let file_data = this.normalizeMaybeJson(row[field]) || row[field];                       //轉成物件
                if (typeof file_data === "string") file_data = null;                                     //若還是字串，非file 物件，回null
                const file_name = file_data?.original_filename || file_data?.file_name || "";            // 兼容命名
                const file_url  = file_data?.original_url || file_data?.file_url || "";                  //取URL
                const isManualUpload = this.getDatadetailType(item?.flexfield_datadetail) === "FileUpload"; //確認上傳模式
                const _detail = item?.flexfield_datadetail;
                const isDocumentOutput = typeof _detail === "object" && _detail !== null && _detail?.type === "DocumentOutput";
                const pk = row?.object_id != null ? String(row.object_id) : null;
                const cellKey = `${field}__${pk}`;
                const rejected = isManualUpload && pk && this.unsupportedFileCells?.[cellKey];
                if (rejected) {
                    const errIcon = h('img', {
                        attrs: { src: this.unsupportedFileFormatIcon, width: 20, height: 20, alt: 'unsupported' },
                        class: 'da-cell-unsupported-icon',
                    });
                    const errText = h('span', { class: 'da-cell-unsupported-text' }, this.$t('DOCUMENT_AGENT.UNSUPPORTED_FILE_FORMAT'));
                    return h('div', { class: 'da-file-cell da-file-cell--rejected' }, [errIcon, errText]);
                }
                let innerNode = null;           // 內容容器，讓事件綁定層跟互動內容層分開
                if (file_name && file_url) {    // 有檔名 + 有 URL：顯示超連結（點擊開啟檔案）
                    if (!isManualUpload && !isDocumentOutput) {      // OneDrive維持開檔案
                        innerNode = h(
                            "a", 
                            { 
                                class: "file-link", 
                                attrs: { href: file_url, target: "_blank", title: file_name },
                                on: {
                                    click: (e) => {
                                        e.stopPropagation(); // 防止點連結時觸發 row click（例如選列/開detail）
                                    },
                                }, 
                            }, 
                            file_name   //顯示檔名
                        );
                    }
                    else {              // FileUpload / DocumentOutput 走 SAS 下載
                        innerNode = h(
                            "a",
                            {
                                class: "file-link",
                                attrs: { title: file_name, role: "link", tabindex: "0", },
                                on: {
                                    click: async (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        await this.downloadViaSasUrl(file_url, file_name);
                                    },
                                },
                            },
                            file_name   //顯示檔名
                        );
                    }
                }
                else if (isManualUpload) {   // 沒檔案+上傳模式：顯示可點擊的上傳 placeholder
                    innerNode = h(
                        "span",
                        { class: "da-upload-hint" },
                        "上傳或拖拉檔案"
                    );
                }
                else{
                    innerNode = h("span", "-");
                } 
                return h(
                    "div",
                    { class: "da-file-cell" },
                    [innerNode] // 內層顯示內容：超連結/placeholder/"-"
                );
            }
            if (dt === "singleselect") {
                const label = row[field];
                const text = (label === null || label === undefined) ? "" : String(label);
                if (!text) {
                    return h("div", { class: "da-pill-ellipsis" }, [h("span", "")]);
                }
                const style = this.getSingleSelectPillStyle(field, item?.flexfield_datadetail, text);
                    return h("div", { class: "da-content" }, [
                        h("span", { style, attrs: { title: text } }, [
                            h("span", { class: "da-pill-text" }, text),
                        ]),
                    ]);
                }
            const v = row[field];
            return h("div", { class: "da-content" }, [
                h("span", { class: "da-ellipsis", attrs: { title: v } }, v)
            ]);
        },
        stopRunDataPolling() {
            if (this.runDataTimer) {
                clearInterval(this.runDataTimer);
                this.runDataTimer = null;
            }
        },
        startStatusPolling() {
            this.stopStatusPolling();
            const loop = async () => {
                if (!this.run_agent_loading) return;
                try {
                    //  Run 模式：一定要 reloadData 才會看到 collection table 值一直變
                    //  loop 本身保證不重疊，所以不用 setInterval + skip
                    await this.fetchStatusOnce({ source: "run", reloadData: true, ignoreThrottle: true });
                } finally {
                    //  做完再等 2 秒，永遠穩定
                    if (this.run_agent_loading) {
                        this.runPollTimer = setTimeout(loop, this.runPollIntervalMs);
                    }
                }
            };
            loop();
        },
        stopStatusPolling() {
            if (this.runPollTimer) {
                clearTimeout(this.runPollTimer);
                this.runPollTimer = null;
            }
        },
        startAutoPolling() {
            this.stopAutoPolling();
            if (this.run_agent_loading) return;     // run agent時不跑
            if (this.cloudDriveEnabled && !this.hasSelectedFolder) return;  //OneDrive 模式才要求 O365 account，FileUpload不需要O365
            if (this.isUploading) return;
            if (!this.currentTableId) return;
            const tick = async () => {
                if (this.run_agent_loading) return;   //  run 時不要 auto polling
                await this.fetchStatusOnce({ source: "auto", reloadData: true });
            };
            tick();
            this.autoPollingTimer = setInterval(tick, this.autoPollingIntervalMs);
        },
        stopAutoPolling() {
            if (this.autoPollingTimer) {
                clearInterval(this.autoPollingTimer);
                this.autoPollingTimer = null;
            }
        },
        hasAnyActive(statusList) {
            if (!Array.isArray(statusList)) return false;
            const activeSet = new Set(["PROCESSING", "NOT_STARTED"]);
            for (const row of statusList) {
                for (const [k, v] of Object.entries(row || {})) {
                    if (k === "object_id") continue;
                    if (!v) continue;
                    const sv = String(v).trim().toUpperCase();
                    if (activeSet.has(sv)) return true;
                }
            }
            return false;
        },
        async fetchStatusOnce({ source = "auto", reloadData = true, ignoreThrottle = false } = {}) {
            const currentId = String(this.currentTableId || "");
            const rootId = String(this.rootTableId || "");
            if (!currentId || !rootId) return;
            if (!this.documentAgentDetail?.agent_config?.table) return;
            //  auto 才節流；run loop 不節流（run loop 自己確保不重疊）
            if (!ignoreThrottle) {
                if (this.fetchInFlight) return;
                const now = Date.now();
                if (now - this.lastFetchAt < this.minFetchGapMs) return;
                this.lastFetchAt = now;
            } else {
                // run 模式也更新一下 lastFetchAt（純紀錄用）
                this.lastFetchAt = Date.now();
            }
            this.fetchInFlight = true;
            try {
                //  1) 以「當下」currentTableId 決定要抓哪些表的 status
                const viewIdAtStart = String(this.currentTableId || "");
                if (!viewIdAtStart) return;
                const ids = new Set();
                if (source === "auto") {
                    ids.add(viewIdAtStart);
                } else {
                    ids.add(rootId);
                    ids.add(viewIdAtStart);
                    (this.rootCollectionTableIds || []).forEach(tid => ids.add(String(tid)));
                }
                //  2) 並行抓 status，寫入 per-table map（空陣列不清空）
                const results = await Promise.all(
                    Array.from(ids).map(async (tableId) => {
                        const cfg = (this.tableConfigurations || []).find(t => String(t.id) === String(tableId));
                        const tableName = cfg?.object_type_name || this.documentAgentDetail?.agent_config?.table || "";
                        if (!tableName) return { tableId: String(tableId), list: [] };
                        let list = [];
                        try {
                            const res = await UpGPTPortalDataServices.checkCurrentStatus(tableId, { tableName });
                            list = res?.data || [];
                        } catch {
                            list = [];
                        }
                        this.applyStatusMap(list, tableId);
                        return { tableId: String(tableId), list: Array.isArray(list) ? list : [] };
                    })
                );
                //  3) reload 畫面資料：改成「以當下正在看的表」為準，並加 stale guard
                if (reloadData) {
                    const viewId = String(this.currentTableId || "");
                    if (viewId) {
                        const snapshotViewId = viewId; // 🔒 防止切表後舊 response 覆蓋
                        const parentId = this.showAllParent ? null : this.currentParentId;
                        const dataRes = await UpGPTPortalDataServices.documentAgentTableData(snapshotViewId, {
                            parentid: parentId,
                            page: this.page,
                            pagesize: this.itemPerPage,
                            ...(this.sortList.length && { sort: JSON.stringify(this.sortList) }),
                            ...(this.filterList.length && { filter: JSON.stringify(this.filterList) }),
                            lang: (this.$i18n && this.$i18n.locale) || 'zh-TW',
                        });
                        //  如果使用者在等待期間切表了，丟掉這次結果
                        if (String(this.currentTableId || "") !== snapshotViewId) return;
                        this.tableData = dataRes.data?.items || [];
                        this.totalCount = Number(dataRes.data?.total_count || 0);
                        this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.itemPerPage));
                        this.showEmpty = this.tableData.length === 0;
                    }
                }
                //  4) run stop 條件：root + collections 都沒有 active 才停（沿用你原本）
                if (source === "run") {
                    const byId = {};
                    results.forEach(r => (byId[String(r.tableId)] = r.list));
                    const doc_agent = await UpGPTPortalDataServices.getDocumentUserAgentDetail(this.doc_agent_id);
                    const nextStatus = String(doc_agent?.data?.status || "").trim().toUpperCase();
                    this.documentAgentDetail.status = nextStatus;
                    const agentProcessing = nextStatus === "PROCESSING";                                // User_Agent是否是"PROCESSING"
                    const anyActiveCells = Object.values(byId).some(list => this.hasAnyActive(list));   // 各表各 cell還有"PROCESSING","NOT_STARTED"
                    if (agentProcessing || anyActiveCells) return;  //還在跑就return
                    if (!this.runFinalRefreshed) {      //最後刷新
                        this.runFinalRefreshed = true;
                        if (this.currentTableId) {
                            const { data } = await UpGPTPortalDataServices.documentAgentTableData(this.currentTableId, {
                                parentid: this.showAllParent ? null : this.currentParentId,
                                page: this.page,
                                pagesize: this.itemPerPage,
                                ...(this.sortList.length && { sort: JSON.stringify(this.sortList) }),
                                ...(this.filterList.length && { filter: JSON.stringify(this.filterList) }),
                                lang: (this.$i18n && this.$i18n.locale) || 'zh-TW',
                            }); // 最後再取一次新DATA
                            this.tableData = data?.items || [];
                            // 刷新 referenceMap
                            const cfg = (this.tableConfigurations || []).find(t => String(t.id) === String(this.currentTableId));
                            if (cfg) await this.loadFlexfieldReference(this.currentTableId, cfg.object_type_name);
                            this.refContentCache = {};
                        }
                        return;
                    }
                    this.isRunning = false;
                    this.run_agent_loading = false;
                    this.stopStatusPolling();
                    this.stopRunDataPolling();
                    this.startAutoPolling();
                }
            } catch (e) {
                console.warn("fetchStatusOnce failed:", e);
                if (source === "run") {
                    this.isRunning = false;
                    this.run_agent_loading = false;
                    this.stopStatusPolling();
                    this.startAutoPolling();
                }
            } finally {
                this.fetchInFlight = false;
            }
        },
        getShortTableName(objectTypeName) {
            const s = String(objectTypeName || "").trim();  //先轉成空字串，再去掉前後空白
            if (!s) return "";                              //無值就回空字串
            const parts = s.split(".");                     //以 "." 分割
            return parts[parts.length - 1] || s;            //取最後一段作為短名
        },
        getRowFirstColumnValue(row) {
            const col = this.currentFirstVisibleCol;        //取第一個欄位值
            if (!col) return "";
            return this.getCellDisplayText(row, col) || "";
        },
        getSingleSelectColorMap(fieldKey, datadetail) {
            const fk = String(fieldKey || "");
            if (!fk) return Object.create(null);
            const cached = this.singleSelectColorCache?.[fk];   //先查快取
            if (cached) return cached;
            const map = Object.create(null);                    //建立label顏色對應表
            if (Array.isArray(datadetail)) {                    //datadetail:[{label, color},{...},...]
                for (const opt of datadetail) {
                const k = String(opt?.label ?? "").trim().toUpperCase();
                const c = String(opt?.color || "").trim();
                if (k) map[k] = c || null;                      //有label進map；沒有就null
                }
            }
            this.$set(this.singleSelectColorCache, fk, map);    //寫入cache
            return map;
            },
        getSingleSelectPillStyle(fieldKey, datadetail, label) {     //目前cell值，去map找顏色
            const key = String(label ?? "").trim().toUpperCase();
            if (!key) return null;
            const map = this.getSingleSelectColorMap(fieldKey, datadetail); //取得該欄位的map
            const fg = String(map[key] || "").trim() || "#CCCCCC";          //map不到就用半透明
            const bg = /^#([0-9a-fA-F]{6})$/.test(fg) ? `${fg}33` : "rgba(0,0,0,0.06)"; //背景透明度20%
            return {       //回傳pill樣式
                color: fg,
                backgroundColor: bg,
                fontSize: "12px",
                height: "22px",
                lineHeight: "22px",
                padding: "0 8px",
                borderRadius: "4px",
                fontWeight: 500,
                display: "inline-flex",
                alignItems: "center",
                boxSizing: "border-box",
                maxWidth: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            };
        },
        buildSingleSelectChangeLabelsByOrig(editData, deletedLabels = []) {                 // 依「_origLabel」計算 SingleSelect 的 rename/delete 對照表 change_labels
            const norm = (s) => (s === null || s === undefined) ? "" : String(s).trim();    // 統一label
            const newList = Array.isArray(editData?.flexfield_datadetail) ? editData.flexfield_datadetail : []; // 取新option清單
            const changes = [];                                                             //接更新清單
            for (const opt of newList) {                // _origLabel有值+label有值，且兩者不同，視為改名
                const from = norm(opt?._origLabel);     // 舊 label
                const to = norm(opt?.label);            // 新 label
                if (from && to && from !== to) {
                    changes.push({ from, to });
                }
            }
            for (const from of (deletedLabels || [])) { //刪除時轉成null，給後端把DB舊label的cell清空
                const f = norm(from);
                if (f) changes.push({ from: f, to: null });
            }
            const seen = new Set();
            return changes.filter(x => {
                const k = `${x.from}=>${x.to}`;         // to null，字串化後也能當 key
                if (seen.has(k)) return false;
                seen.add(k);
                return true;
            });
        },
        stripUidFromSingleSelect(editData){                             //刪_uid避免進DB
            const cloned = JSON.parse(JSON.stringify(editData || {}));
            const list = Array.isArray(cloned.flexfield_datadetail) ? cloned.flexfield_datadetail : [];  // 取option清單
            for (const o of list){
                if (!o) continue;
                if (Object.prototype.hasOwnProperty.call(o, "_uid")) delete o._uid;
                if (Object.prototype.hasOwnProperty.call(o, "_origLabel")) delete o._origLabel; // 一併移除
            }
            return cloned;
        },
        async onEmitEditDocumentAgentConfig(payload){          // 先更新agent_config，若是singleselect且label有rename，再更新
            if (this.disabledAll || this.addBtn_loading) return;
            const runAfterUpdate = Boolean(payload?.runAfterUpdate);// onSaveAndRun給runAfterUpdate
            let runPayload = null;                                  // 更新成功後才傳入參數，finally時run agent
            this.addBtn_loading = true;
            try {
                const editData = payload?.editData || payload;                      // 兼容舊呼叫
                const deletedLabels = payload?.deletedSingleSelectLabels || [];     // 收集被刪除清單
                const dt = String(editData?.flexfield_datatype || "").trim().toLowerCase();
                let change_labels = [];             //取rename清單
                if (dt === "singleselect") {
                    change_labels = this.buildSingleSelectChangeLabelsByOrig(editData, deletedLabels);  // 根據 _origLabel + deletedLabels 組 rename/delete 對照表
                }
                const cleanedEditData = (dt === "singleselect") ? this.stripUidFromSingleSelect(editData) : editData;   //先刪_uid避免進DB
                await this.editDocumentAgentConfig(cleanedEditData);        // 更新agent_config
                if (dt === "singleselect" && change_labels.length > 0) {    // 有rename call API更新label
                    const field = cleanedEditData.flexfield_column || cleanedEditData.field;
                    await UpGPTPortalDataServices.documentAgentSingleSelectLabelUpdate(
                        this.currentTableId,
                        { field, change_labels }
                    );
                }
                await this.loadTable(this.currentTableId, { // reload表格
                    parentid: this.currentParentId,
                    pushBreadcrumbs: false,
                });
                this.columnDialog.open = false;      // 關閉dialog+更新key
                this.columnDialog.key += 1;
                if (runAfterUpdate) {                                                       //需要 Save & Run，組runPayload
                    const field = cleanedEditData.flexfield_column || cleanedEditData.field;// 要run的欄位
                    runPayload = {                                                          //run_agent時傳入參數
                        type: "column",                                                     // 設定type:"column"
                        table_config_id: this.currentTableId,                               // 目前table_config_id
                        flexfield_column: field,                                            // 目前欄位
                        parent_id: null,                                                    // 有無勾都null
                    };
                }
            } catch (e) {
                const data = e?.response?.data;
                let msg;
                if (data) {
                    if (typeof data.detail === "string") {
                        msg = data.detail;
                    } else if (typeof data === "object") {
                        const firstKey = Object.keys(data)[0];
                        if (firstKey) {
                            const fieldErr = data[firstKey];
                            msg = Array.isArray(fieldErr) ? fieldErr[0] : String(fieldErr || "");
                        }
                    }
                }
                msg = msg || e?.message || "更新失敗";
                this.showErrorDialog(msg);
            } finally {
                this.addBtn_loading = false;
                if (runPayload) {
                    await this.runAgent(runPayload);    // 更新成功後runAgent
                }
        }
    },
        normalizeTextForDisplay(s) {
            return String(s ?? "")
                .replace(/\r\n/g, "\n") // 讓 markdown-it 或 HTML 顯示換行時一致
                .replace(/\\n/g, "\n")  // 把文字的 \n 轉成換行
                .replace(/\s+$/g, "");  // 去掉結尾多餘空白/換行，避免尾端留白
        },
        renderMd(raw) {
            const s = this.normalizeTextForDisplay(raw);
            return this.refMarkdownIt ? this.refMarkdownIt.render(s) : s;    // 若 markdown-it 已初始化就用它 render 成 HTML（支援 markdown + html table + 換行）
        },
        async onCustomizationClick(btn) {               //btn = {"button_name": "生成同意書","dialog_path": "generateConsentFormDialog"}
            const path = btn?.dialog_path;              // 取出 dialog_path
            if (path === "generateConsentFormDialog") { //目前已實作的功能
                await this.exportDOC();                 //匯出同意書 
                return;
            }
            if (path === "omsUploadInvoice") {
                await this.uploadOmsInvoice();
                return;
            }
            this.message = `客製按鈕，功能待新增：${btn?.button_name || ""} (${path || ""})`;   //通知待實作
            this.messageDialog = true;                  //開訊息框
        },
        async uploadOmsInvoice() {
            if (this.omsUploading) return;
            this.omsUploading = true;
            try {
                const res = await UpGPTPortalDataServices.uploadOmsInvoice(this.doc_agent_id);
                this.omsDoneMessage = res?.data?.agent_deleted === false
                    ? "發票與收據已上傳完畢，但 Agent 刪除失敗，請手動刪除。"
                    : "發票與收據已上傳完畢。";
                this.omsDoneDialog = true;
            } catch (e) {
                const data = e?.response?.data || {};
                const missing = Array.isArray(data.missing_fields) && data.missing_fields.length
                    ? `：${data.missing_fields.join("、")}` : "";
                this.showErrorDialog((data.detail || "上傳失敗") + missing);
            } finally {
                this.omsUploading = false;
            }
        },
        async fetchDocumentAgentFileType(){                         // 抓DocumentAgent類型
            const agentId = String(this.doc_agent_id || "").trim(); //取doc_agent_id
            if(!agentId) return;
            if(this.filetypeloading) return;
            this.filetypeloading = true;                            // 進入loading，防止連續請求
            this.file_type = null;                                  // 先清掉避免舊值殘留         
            try{
                const response = await UpGPTPortalDataServices.getDocumentAgentFileType(agentId);   //call API，會回{ file_type: "OneDrive"或其他 }
                this.file_type = response?.data?.file_type ?? null; //若file_type 不存在就設為 null
            } catch (e){
                console.warn("getDocumentAgentFileType Failed:",e);
            } finally{
                this.filetypeloading = false;                       //關loading
                this.$nextTick(() => this.updateTableSize()); // file_type 影響 OneDrive 區塊顯示
            }
        },
        async createFlexfieldDataRow() {
            const tableConfigId = String(this.currentTableId || "");    // 取目前tableConfigId
            if (!tableConfigId) return;
            if (this.createRowLoading) return;                          // 避免連點
            const parentId = this.currentParentId;                              // 取parentId
            const payload = (!this.isRootTable) ? { parent_id: parentId } : {}; // 不在root就要給parentId
            this.createRowLoading = true;                               // 上鎖
            this.lastCreatedFlexfieldDataId = null;                     // 先清空最後新增那筆，避免UI抓錯最新row
            try {
                const createRes = await UpGPTPortalDataServices.createFlexfieldData(tableConfigId, payload); // 增加帶payload
                const newId = createRes?.data?.flexfield_data_id || null;   // 回新列 ID
                this.lastCreatedFlexfieldDataId = newId;                    // 保存新列 ID，定位分頁
                await this.fetchViewTableData();                            // 抓最新資料
                const lastPage = Math.max(1, Math.ceil(this.totalCount / this.itemPerPage)); // 算最後一頁並跳過去
                if (this.page !== lastPage) {                               // 目前不在最後頁，才需要跳頁
                    this.page = lastPage;
                    await this.fetchViewTableData();                        // 抓最新資料
                }
            } catch (e) {
                this.showErrorDialog?.("新增列失敗，請稍後再試");
            } finally {
                this.createRowLoading = false;                              // 解鎖
            }
        },
        async onFilePicked(e) {                     // 新增選擇檔案邏輯
            const file = e?.target?.files?.[0];     // 取得第一個檔案(單檔上傳)
            if (!file || !this.pendingUpload) {     // 沒檔案、或沒有指定回寫哪一列哪一欄{ row, field }
                this.fileInputKey++;                    // 重置 file input，可上傳同檔名
                return;
            }
            const { row, field } = this.pendingUpload;  // 把檔案上傳到哪一筆(row)的哪一個欄位(field)
            if (!row?.object_id) {                      // 上傳需要 pk/object_id，沒有就不能上傳
                this.showErrorDialog?.("此列沒有 object_id，請先新增列再上傳。");
                this.pendingUpload = null;
                this.fileInputKey++;
                return;
            }
            if (!this.isFileSupported(file)) {
                this.showErrorDialog(this.$t('DOCUMENT_AGENT.UNSUPPORTED_FILE_FORMAT'));
                this.pendingUpload = null;
                this.fileInputKey++;
                return;
            }
            const tableConfigId = this.currentTableId;  //取目前表的Id
            const form = new FormData();                // 用 multipart/form-data 上傳檔案(瀏覽器檔案上傳物件)
            form.append("file", file);                  // 實際檔案內容
            form.append("field_name", field);           // 定位哪一個 flexfield 欄位
            form.append("pk", row.object_id);           // 定位要更新哪一筆 row
            this.isUploading = true;                    // 上鎖
            try {
                const res = await UpGPTPortalDataServices.uploadDocumentAgentFile(tableConfigId, form);
                const fileValue = {     // 回傳 row 的 flexfield_file01物件
                    parsed_url: "",
                    original_url: res?.data?.original_url || "",
                    parsed_filename: "",
                    original_filename: res?.data?.original_filename || file.name,
                };
                row[field] = fileValue;
                this.$delete(this.unsupportedFileCells, `${field}__${row.object_id}`);
                this.tableData = [...this.tableData];   // 刷新tableData，不用reload也能看到fileValue(...展開運算子)
                this.$nextTick(() => this.updateTableSize()); // 重新計算表格高度
                try {
                    const dirtyRes = await UpGPTPortalDataServices.documentAgentSetDirtyflag(
                        String(tableConfigId),{
                            flexfield_column: field,
                            flexfielddata_object_id: String(row.object_id),
                        });
                    const s = dirtyRes?.data?.agent_status;
                    if (s) this.$set(this.documentAgentDetail, "status", s);
                } catch (err) {
                    console.warn("set dirty failed after cell update:", err);
                }
                await this.fetchStatusOnce({ source: "auto", reloadData: true, ignoreThrottle: true });
            } catch (err) {
                const msg = err?.response?.data?.detail || err?.message || "Upload failed";
                this.showErrorDialog?.(msg);
            } finally {
                this.isUploading = false;   // 解鎖
                this.pendingUpload = null;  // 清空狀態
                this.fileInputKey++;        // 讓同檔名可重選
            }
        },
        openFilePicker(row, field) {
            if (!row?.object_id) {         // 有row才允許上傳
                this.showErrorDialog?.("請先新增一列取得 object_id，再上傳檔案。");
                return;
            }
            this.pendingUpload = { row, field };    // 定位回寫哪一列 + 哪一欄
            if (this.$refs.filePicker) {
                this.$refs.filePicker.click();      // 開啟選檔視窗
            }
        },
        normalizeMaybeJson(v) { // 兼容後端回傳物件、JSON 字串、"null"、空
            if (!v) return null;
            if (typeof v === "object") return v;    //物件不用parse
            if (typeof v === "string") {            
                const s = v.trim();
                if (!s) return null;
                if (s.toLowerCase() === "null") return null;    //字串"null"轉null
                if (s.startsWith("{") || s.startsWith("[")) {   // 類似JSON 的字串才parse
                try { return JSON.parse(s); } catch { return null; }
                }
            }
            return null;
        },
        setCellOver(row, field) {
            const id = row?.object_id;
            if (id == null) {
                this.dragDrop.overPk = null;
                this.dragDrop.overField = null;
                return;
            }
            this.dragDrop.overPk = String(id);  //哪一列
            this.dragDrop.overField = field;    //哪一欄
        },
        isFileSupported(file) {
            const name = file?.name || '';
            const dotIndex = name.lastIndexOf('.');
            if (dotIndex === -1) return false;
            const ext = name.slice(dotIndex).toLowerCase();
            return SUPPORTED_FILE_EXTENSIONS.includes(ext);
        },
        isMimeUnsupportedForHover(mimeType) {
            if (!mimeType) return false;
            return !SUPPORTED_FILE_MIME_TYPES.includes(mimeType);
        },
        showUnsupportedFilesDialog(successCount, failCount) {
            this.unsupportedFilesResult = { successCount, failCount };
            this.unsupportedFilesDialog = true;
        },
        clearCellOver() {
            this.dragDrop.overPk = null;
            this.dragDrop.overField = null;
            this.dragDrop.isMulti = false;
            this.dragDrop.isUnsupported = false;
        },
        onCellDragEnter(e, { row, field }) {// 檔案進入的一瞬間
            e?.preventDefault?.();          // 允許drop，若無preventDefault，瀏覽器會擋drop事件
            e?.stopPropagation?.();         // 避免外層事件
            const count = this.getDragFileCount(e);
            this.dragDrop.isMulti = count > 1;   // file數量>1，多檔顯示方式
            if (count === 1) {
                const mimeType = e?.dataTransfer?.items?.[0]?.type || '';
                this.dragDrop.isUnsupported = this.isMimeUnsupportedForHover(mimeType);
            } else {
                this.dragDrop.isUnsupported = false;
            }
            this.setCellOver(row, field);   // 拖曳到哪一欄哪一列上，顯示底色
        },
        onCellDragOver(e, { row, field }) { // 檔案停留的途中
            e?.preventDefault?.();          // 同上
            e?.stopPropagation?.();
            const count = this.getDragFileCount(e);
            this.dragDrop.isMulti = count > 1;  // file數量>1，多檔顯示方式
            if (count === 1) {
                const mimeType = e?.dataTransfer?.items?.[0]?.type || '';
                this.dragDrop.isUnsupported = this.isMimeUnsupportedForHover(mimeType);
            } else {
                this.dragDrop.isUnsupported = false;
            }
            this.setCellOver(row, field);
        },
        onCellDragLeave(e, payload) {
            const ct = e?.currentTarget;    //目前cell   
            const rt = e?.relatedTarget;    //cell中其他元素
            if (ct && rt && ct.contains?.(rt)) return; // 在cell內部移動，不算離開，不動底色
            const field = payload?.field;                   // 目前所在欄位
            if (this.dragDrop?.isMulti) {                   // 多檔拖拉
                let element;
                if (rt && rt.nodeType === 1) {              // nodeType === 1，等於是Element（div/span/button）
                    element = rt;
                } else {
                    element = rt?.parentElement;            // 若不是就找父層元素
                }
                let stillInSameCol = false;                 // 預設不在同column
                if (field) {                                // 目前所在欄位
                    const hit = element?.closest?.(`[data-drop-col="${field}"]`);   // closest:從自己開始往父層找到第一個符合()條件的元素
                    stillInSameCol = hit;                                           // 是drop且同欄，就不關高亮
                }
                if (stillInSameCol) return;                 //還在同欄就不關
                if (this.dragDrop?.overField === field) {   // 真的離開這欄，關狀態
                    this.dragDrop.overField = null;
                    this.dragDrop.overPk = null;
                    this.dragDrop.isMulti = false;
                }
                return;                                     // 避免顯示單檔狀態
            }
            this.clearCellOver();                      // 真的離開，關閉底色
        },
        getDragFileCount(e) {
            const dt = e?.dataTransfer;                         // 取dataTransfer(含檔案/文字/網址)
            if (!dt) return 0;
            return dt.items.length;                             //回傳file數量
        },
        async onCellDropSingleFile(e, { row, field }) {
            e?.preventDefault?.();      // 允許drop，若無preventDefault，瀏覽器會擋drop事件     
            e?.stopPropagation?.();     // 避免外層事件
            this.clearCellOver();       //關閉底色
            if (this.run_agent_loading || this.addBtn_loading || this.isUploading) return;  //避免狀態錯亂
            const files = Array.from(e?.dataTransfer?.files || []).filter(Boolean);
            if (!files.length) return;
            const tableConfigId = String(this.currentTableId || "");
            if (!tableConfigId) return;
            this.isUploading = true;    // 上鎖，避免同時重複上傳
            try {
                // 單檔
                if (files.length === 1) {
                    const file = files[0];
                    const pk = row?.object_id != null ? String(row.object_id) : null;
                    if (!pk) return;
                    if (!this.isFileSupported(file)) {
                        this.$set(this.unsupportedFileCells, `${field}__${pk}`, { fileName: file.name });
                        this.tableData = [...this.tableData];
                        return;
                    }
                    const form = new FormData();        //用 multipart/form-data 上傳檔案(瀏覽器檔案上傳物件)
                    form.append("file", file);          //實際檔案內容
                    form.append("field_name", field);   //更新哪個flexfield_column
                    form.append("pk", pk);              //更新哪一列
                    const res = await UpGPTPortalDataServices.uploadDocumentAgentFile(tableConfigId, form); //call API
                    const fileValue = {                 //後端回的內容為 "detail"、"flexfield_data_id"、"field_name"、"original_url"、"original_filename"
                        parsed_url: "",                 //前端轉成 table cell所需格式
                        original_url: res?.data?.original_url || "",
                        parsed_filename: "",
                        original_filename: res?.data?.original_filename || file?.name || "",
                    };
                    this.$set(row, field, fileValue);    //把這一列 row 的 field，更新成 fileValue
                    this.$delete(this.unsupportedFileCells, `${field}__${pk}`);
                    this.tableData = [...this.tableData];// 刷新tableData，不用reload
                    this.$nextTick(() => this.updateTableSize());   // 重新計算表格高度
                    try {
                        const dirtyRes = await UpGPTPortalDataServices.documentAgentSetDirtyflag(
                        tableConfigId,{
                            flexfield_column: field,
                            flexfielddata_object_id: pk,
                        });
                        const s = dirtyRes?.data?.agent_status;
                        if (s) this.$set(this.documentAgentDetail, "status", s);
                    } catch (err) {
                        console.warn("set dirty failed after cell update:", err);
                    }
                    await this.fetchStatusOnce({ source: "auto", reloadData: true, ignoreThrottle: true });
                    return;
                }
                //多檔
                let successCount = 0;
                let failCount = 0;
                for (const file of files) {
                    if (!this.isFileSupported(file)) {
                        failCount++;
                        continue;
                    }
                    await this.createFlexfieldDataRow();    // 先call新增row
                    const lastRow = Array.isArray(this.tableData) && this.tableData.length ? this.tableData[this.tableData.length - 1] : null;//最後一列為目標 row
                    const newPk = lastRow?.object_id != null ? String(lastRow.object_id) : null;    //pk為剛剛新增的row
                    if (!newPk) throw new Error("Cannot find new row pk after create");
                    const form = new FormData();
                    form.append("file", file);
                    form.append("field_name", field);
                    form.append("pk", newPk);            //新增的row
                    const res = await UpGPTPortalDataServices.uploadDocumentAgentFile(tableConfigId, form);
                    const fileValue = {
                        parsed_url: "",
                        original_url: res?.data?.original_url || "",
                        parsed_filename: "",
                        original_filename: res?.data?.original_filename || file?.name || "",
                    };
                    this.$set(lastRow, field, fileValue);   //顯示最後一列row
                    this.tableData = [...this.tableData];
                    this.$nextTick(() => this.updateTableSize());   // 重新計算表格高度
                    successCount++;
                }
                if (failCount > 0) {
                    this.showUnsupportedFilesDialog(successCount, failCount);
                }
            } catch (err) {
                const msg = err?.response?.data?.detail || err?.message || "Upload failed";
                this.showErrorDialog?.(msg);
            } finally {
                this.isUploading = false;   // 解鎖
            }
        },
        async setDirtyAndFetchStatus(tableConfigId, field, pk) {    //set dirty後抓Status
            const tableId = String(tableConfigId);
            const rowPk = String(pk);
            try {
                const dirtyRes = await UpGPTPortalDataServices.documentAgentSetDirtyflag(tableId, { // set dirty
                    flexfield_column: field,
                    flexfielddata_object_id: rowPk,
                });
                const s = dirtyRes?.data?.agent_status;
                if (s) this.$set(this.documentAgentDetail, "status", s);    // agent回狀態
            } catch (err) {
                console.warn("set dirty failed after file upload:", err);
            }
            const cfg = (this.tableConfigurations || []).find(t => String(t.id) === tableId);
            const tableName = cfg?.object_type_name || this.documentAgentDetail?.agent_config?.table || "";
            if (!tableName) return;
            try {
                const st = await UpGPTPortalDataServices.checkCurrentStatus(tableId, { tableName }); // 更新Status
                this.applyStatusMap(st?.data || [], tableId);
            } catch (err) {
                console.warn("check Status failed after dirty:", err);
            }
        },
        getHeaderTypeIcon(datatype, datadetail) {
            const dt = String(datatype || "").trim().toLowerCase();
            const rawDetail = (typeof datadetail === 'object' && datadetail !== null) ? datadetail.type : datadetail;
            const detail = String(rawDetail || "").trim().toLowerCase();
            if (dt === "collection") return this.typeCollectionIcon;
            if (dt === "date") return this.typeDateIcon;
            if (dt === "file") {
                if (detail === "onedrive") return this.typeOneDriveIcon;
                if (detail === "documentoutput") return this.typeDocumentOutputIcon;
                return this.typeFileIcon;
            }
            if (dt === "number") return this.typeNumberIcon;
            if (dt === "singleselect") return this.typeSingleSelectIcon;
            return this.typeTextIcon;
        },
        updateTableSize() {                                                                // 計算高度
            const wrap = this.$refs.tableWrap;                                             // 取得表格外層容器
            if (!wrap) return;
            const wrapTop = wrap.getBoundingClientRect().top;                              //瀏覽器原生方法，取得 wrap 距離視窗頂部的距離
            const footerHeight = this.$el?.querySelector?.(".da-footer-row")?.offsetHeight || 45; // 找footer元素的高，沒有就用45
            const addRowBtnHeight = this.canShowCreateRowBtn ? 42 : 0;                     // 有addrow按鈕時 預留42
            const buffer = 10;                                                             // 緩衝，避免太貼底
            const availableHeight = window.innerHeight - wrapTop - footerHeight - addRowBtnHeight - buffer; // innerHeight減掉上述元素算可用高度
            const nextMaxHeight = Math.max(150, Math.floor(availableHeight));              // 設定表格最大高度，下限 150px 避免太小
            const nextScrollWidth = wrap.clientWidth;                                      // 記錄 wrap 寬度
            if (nextMaxHeight !== this.tableMaxHeight) this.tableMaxHeight = nextMaxHeight;// 值有變才觸發更新
            if (nextScrollWidth !== this.tableScrollWidth) this.tableScrollWidth = nextScrollWidth;
        },
        initTableResizeWatcher() {                                                         // 自動偵測「會改高度」的事件
            if (!this.onWinResizeHandler) {
                this.onWinResizeHandler = () => this.updateTableSize();                    // 計算高度
                window.addEventListener("resize", this.onWinResizeHandler, { passive: true }); // 拖拉視窗、改變視窗大小時會觸發
            }
            if (!this.tableRO && window.ResizeObserver) {                                  // 瀏覽器原生 API，監聽元素的尺寸變化，!this.tableRO避免重複監聽
                this.tableRO = new ResizeObserver(() => {
                    this.updateTableSize();                                                // 有變化就重新計算高度
                });
                if (this.$refs.tableWrap) this.tableRO.observe(this.$refs.tableWrap);      // 監聽表格外層容器變化
                if (this.$el) this.tableRO.observe(this.$el);                              // 監聽整個元件外框變化
            }
        },
        cleanupTableSize() {                                                               // 清除監聽事件
            if (this.tableRO) {
                this.tableRO.disconnect();                                                 // 停止觀察
                this.tableRO = null;                                                       // 回復 null
            }
            if (this.onWinResizeHandler) {
                window.removeEventListener("resize", this.onWinResizeHandler);             // 解除 resize 綁定
                this.onWinResizeHandler = null;                                            // 回復 null
            }
        },
        copyCell(text) {
            navigator.clipboard.writeText(text); // 瀏覽器的剪貼 API，把文字寫入剪貼簿
            if (this.copied === false) {
                this.copied = true;
                setTimeout(() => (this.copied = false), 1000);
            }
        },
        async searchReadDocuments({ keyword = "", ensureIds = [] } = {}) {
            const kw = String(keyword || "").trim();
            const ids = Array.isArray(ensureIds) ? ensureIds.map(String) : [];
            this.readDocuments.keyword = kw;                            // 重置搜尋狀態，每次搜尋都重新從第一頁開始
            this.readDocuments.page = 1;
            this.readDocuments.hasMore = true;
            this.readDocuments.ensureIds = ids;
            await this.fetchReadDocuments({ page: 1, append: false });  // 先抓第一頁資料，append:false，覆蓋清單，避免舊資料殘留
            await this.prefetchAllSearchResults();                      // 搜尋時預抓所有結果
        },
        resetReadDocuments() {
            this.readDocuments.reqSeq += 1;         // 請求次數記錄 + 1
            this.readDocuments.inFlight = false;    // 關閉正在跑的請求
            this.readDocuments.keyword = "";        // 清空搜尋
            this.readDocuments.page = 1;            // 回到第1頁
            this.readDocuments.hasMore = true;      // 重置 hasMore，預設有下一頁
            this.readDocumentsList = [];            // 清空目前 items
            this.readDocumentsLoading = false;      // 解鎖
        },
        async prefetchAllSearchResults({ maxPages = 200, maxItems = 1000 } = {}) {
            const kw = String(this.readDocuments.keyword || "").trim();
            if (!kw) return;                                                        // 沒有keyword不做
            let guard = 0;                                                          // 避免無限迴圈
            while (
                String(this.readDocuments.keyword || "").trim() === kw &&           // keyword 沒改變
                this.readDocuments.hasMore &&                                       // 且有下一頁
                (this.readDocumentsList || []).length < maxItems &&                 // 且總筆數未達上限
                guard < maxPages                                                    // 且總頁數未達上限
            ) {
                const nextPage = Number(this.readDocuments.page || 1) + 1;          // 計算下一頁
                await this.fetchReadDocuments({ page: nextPage, append: true });    // 抓下一頁資料並 append 到清單中
                guard++;                                                            // 確保最多跑只能跑200次
            }
        },
        async loadMoreReadDocuments() {
            if (!this.readDocuments.hasMore) return;
            if (this.readDocuments.inFlight) return;                                // 有請求在進行中就不做
            const nextPage = Number(this.readDocuments.page || 1) + 1;              // 計算下一頁頁碼
            await this.fetchReadDocuments({ page: nextPage, append: true });        // 抓下一頁
        },
        async fetchReadDocuments({ page = 1, append = false } = {}) {
            const userId = this.user_id;
            if (!userId) return;
            const keyword = String(this.readDocuments.keyword || "").trim();
            const ensureIds = Array.isArray(this.readDocuments.ensureIds) ? this.readDocuments.ensureIds : [];
            const reqSeq = ++this.readDocuments.reqSeq;             // 請求序號，用來判斷新舊請求
            this.readDocuments.inFlight = true;                     // 正在請求中
            this.readDocumentsLoading = true;                       // 載入中
            try {
                const res = await UpGPTPortalDataServices.getDocumentAgentKnowledgeList({   // 打 API 取得清單
                    user_id: userId,
                    keyword,                                        // keyword 搜尋
                    page: Number(page || 1),                        // page 頁碼
                    ensure_ids: ensureIds.join(","),                // 已選項目，用逗號分隔字串
                });
                if (reqSeq !== this.readDocuments.reqSeq) return;   //若不是最新的請求，就不做
                const data = res?.data || {};                       // 取得回傳資料
                const rows = Array.isArray(data.results) ? data.results : [];           // 取本頁 rows，確保是陣列
                const merged = append ? [...this.readDocumentsList, ...rows] : rows;    // 合併清單
                const seen = new Set();
                this.readDocumentsList = merged.filter(r => {       // 過濾重複項目
                    const id = r?.id;                               // 以 id 去重複
                    if (seen.has(id)) return false;                 // 既有id就略過
                    seen.add(id);                                   // 新id加入seen
                    return true;
                });
                this.readDocuments.page = Number(data.page || page || 1);    // 更新目前頁碼
                this.readDocuments.hasMore = data.has_more;                  // 更新是否有下一頁
            } finally {
                if (reqSeq === this.readDocuments.reqSeq) {         // 這次請求是最新才可以關，避免還有新請求
                    this.readDocuments.inFlight = false;
                    this.readDocumentsLoading = false;
                }
            }
        },
        isRowSelected(objectId) {                      // 判斷某 row 是否已被勾選
            const id = String(objectId ?? "");
            if (!id) return false;
            return (this.selectedFlexfieldData || []).includes(id);
        },
        toggleRowSelection(objectId) {
            const id = String(objectId ?? "");
            if (!id) return;
            const list = Array.isArray(this.selectedFlexfieldData) ? this.selectedFlexfieldData : [];
            this.selectedFlexfieldData = list.includes(id)
            if (list.includes(id)) {
            this.selectedFlexfieldData = list.filter(x => x !== id); // 已勾選>>取消：把 id 從陣列移除
            } else {
            this.selectedFlexfieldData = [...list, id]; // 未勾選>>打勾：把 id 加到陣列最後面
            }
        },
        onClickBulkDelete() {                           // 有勾選才打開確認刪除彈窗
            if (!this.selectedFlexfieldData.length) return;
            this.deleteRowsDialogOpen = true;
        },
        async bulkDeleteSelectedRows() {                // 執行刪除，清空勾選，重抓表格
            this.deleteRowsDialogOpen = false;
            if (this.bulkDeleteLoading) return;
            const ids = this.selectedFlexfieldData ?? [];
            if (ids.length === 0) return;
            this.bulkDeleteLoading = true;
            try {
                const res = await UpGPTPortalDataServices.bulkDeleteFlexfieldData({ object_ids: ids });
                this.$set(this.documentAgentDetail, "status", res.data.agent_status);
                this.selectedFlexfieldData = [];
                await this.fetchViewTableData();
            } finally {
                this.bulkDeleteLoading = false;
            }
        },
        onRecordReviewNavigate(newRow) {
            this.recordReviewRow = newRow;
            this.fetchRowReferenceIfMissing(newRow);
        },
        onRecordReviewBreadcrumbClick(item) {
            this.recordReviewPageOpen = false;
            this.onBreadcrumbClick(item);
        },
        onRecordReviewTableDown() {
            this.recordReviewPageOpen = false;
            // 從 currentHeader 找第一個 collection 欄位
            const collectionCol = (this.currentHeader || []).find(
                col => String(col?.flexfield_datatype || '').trim().toLowerCase() === 'collection'
            );
            if (!collectionCol) return;
            const colField = collectionCol.flexfield_column;
            const collectionTableName = String(collectionCol.collection_table || '').trim();
            // 從 tableConfigurations 找對應的子 table config
            const childConfig = (this.tableConfigurations || []).find(t => {
                const ot = String(t?.object_type_name || '');
                return ot === collectionTableName || ot.endsWith(`.${collectionTableName}`) || ot.includes(collectionTableName);
            });
            if (!childConfig) return;
            // 從 recordReviewRow 取得 parentId
            const cellValue = this.recordReviewRow?.[colField];
            const parentId = (cellValue && typeof cellValue === 'object') ? (cellValue.parent_id ?? null) : null;
            const parentLabel = this.getRowFirstColumnValue(this.recordReviewRow);
            this.page = 1;
            this.loadTable(childConfig.id, {
                parentid: parentId,
                pushBreadcrumbs: true,
                parentLabel,
            });
        },
        onRecordReviewOpenFile({ url, fileName }) {
            if (!url) return;
            if (/^https?:\/\//i.test(url)) {
                window.open(url, "_blank");
                return;
            }
            this.downloadViaSasUrl(url, fileName || "download");
        },
        /**
         * 處理 RecordDataPane（Feature 3）emit 的 on-citation-click 事件。
         * 透過 $refs 呼叫 RecordReviewPage（Feature 1）的 handleCitationClick，
         * 由 Feature 1 負責切換左側欄位並轉呼叫 Feature 2 的 navigateTo。
         *
         * @param {Object} payload - { column_name, page_num, image_num }
         */
        onCitationClick(payload) {
            const reviewPage = this.$refs.recordReviewPage;
            if (!reviewPage) return;
            reviewPage.handleCitationClick(payload);
        },
        openRecordReview(row, col) {
            if (this.recordReviewPageOpen) return;
            this.recordReviewRow = row;
            this.recordReviewField = col ?? null;
            this.recordReviewPageOpen = true;
            const cfg = this.tableConfigurations.find(t => t.id == this.currentTableId);
            if (cfg) this.loadFlexfieldReference(this.currentTableId, cfg.object_type_name);
        },
        openRecordReviewFromToolbar() {
            const objectId = this.selectedFlexfieldData[0];
            const row = (this.tableData || []).find(r => String(r.object_id) === String(objectId));
            if (!row) return;
            const cols = Array.isArray(this.currentHeader) ? this.currentHeader : [];
            const fileCol = cols.find(m => {
                const dt = String(m?.flexfield_datatype || "").trim().toLowerCase();
                if (dt !== "file") return false;
                const detailType = this.getDatadetailType(m?.flexfield_datadetail);
                if (detailType === "DocumentOutput") return false;
                const cellValue = row[m.flexfield_column];
                return cellValue !== null && cellValue !== undefined && typeof cellValue === "object";
            });
            this.openRecordReview(row, fileCol ? fileCol.flexfield_column : null);
        },
        onCancelDeleteColumn() {
            this.deleteColumnDialog = false;
            this.deleteColumnTarget = null;
        },
        async onConfirmDeleteColumn() {
            if (this.deleteColumnLoading) return;
            const target = this.deleteColumnTarget;
            if (!target?.field) return;
            this.deleteColumnLoading = true;
            try {
                const agentId = this.documentAgentDetail?.id;
                if (!agentId) return
                const payload = {
                    name: target.name,
                };
                await UpGPTPortalDataServices.deleteDocumentAgentColumn(agentId, payload);
                // call delete api 成功後重新抓資料
                const _rawDelTarget = target.flexfield_datadetail;
                const _delTargetType = this.getDatadetailType(_rawDelTarget);
                if (String(_delTargetType || "").trim().toLowerCase() === "onedrive") {
                    // [VIEWER_ONEDRIVE_TAKEOVER] detach_folder 後端以「OneDrive 綁定者」把關；
                    // 未綁定（token_store=None）時會回 403。此 detach 僅為清理，無綁定即無資料可清，
                    // 故忽略 403，不中斷刪除欄位流程。
                    try {
                        await UpGPTPortalDataServices.deleteFile(this.documentAgentDetail.id, this.selectedItems);
                    } catch (delErr) {
                        if (delErr?.response?.status !== 403) throw delErr;
                    }
                    // 僅在實際刪除 OneDrive 綁定資料夾時清空選取；一般欄位刪除須保留現有綁定顯示
                    this.selectedItems = {};
                }
                // 不呼叫 getDocumentAgentDetail()：它內部 loadTable(pushBreadcrumbs:true) 會清空
                // sortList/filterList 並新增麵包屑，導致刪除使用中欄位時排序/篩選整組消失（無法遞補）。
                // 刪除欄位屬「同表刷新」，所需 tableConfigurations/agent_config 由 refreshAgentConfigAndTableList()
                // 更新，表格資料由下方 loadTable(pushBreadcrumbs:false) 重抓並觸發 _cleanupSortFilterByMetadata。
                await this.refreshAgentConfigAndTableList();
                await this.loadTable(this.currentTableId, { parentid: this.currentParentId, pushBreadcrumbs: false });
                await this.fetchDocumentAgentFileType();
                this.deleteColumnDialog = false;
                this.deleteColumnTarget = null;
            } catch (e) {
                const msg = e?.response?.data?.detail || e?.message || "刪除欄位失敗";
                this.showErrorDialog(msg);
            } finally {
                this.deleteColumnLoading = false;
            }
        },
        onVeTableScroll() {                                                         // 同步表格滾動位置給工具列
            const left = this.tableScrollEl?.scrollLeft || 0;                       // 讀取表格水平捲動位置
            this.tableScrollLeft = left;                                            // 表格目前滾動位置
            const bar = this.$refs.colToolbarScroll;                                // 取得工具列的水平捲動容器
            if (bar && bar.scrollLeft !== left) {                                   // 有改動
                bar.scrollLeft = left;                                              // 更新表格位置給工具列
            }
        },
        bindTableScrollSync() {                                                     // 綁定表格水平滾動事件
            const el = this.$el?.querySelector("#loading-container .ve-table-container") || null; // 監聽這個元素的滾動事件
            if (!el) return;
            if (this.tableScrollEl === el) {                                        // 已綁定元素不重複綁定，避免多次觸發
                this.onVeTableScroll();                                             // 呼叫同步，讓工具列對齊表格
                return;
            }
            if (this.tableScrollEl) {                                               // 綁定元素改變，先移除舊的事件
                this.tableScrollEl.removeEventListener("scroll", this.onVeTableScroll);
            }
            this.tableScrollEl = el;                                                // 更新目前綁定元素
            el.addEventListener("scroll", this.onVeTableScroll, { passive: true }); // 監聽新的滾動事件
            this.onVeTableScroll();                                                 // 呼叫同步
        },
        syncColToolbarWidths() {                                                    // 偵測表頭寬度，更新工具列對齊位置
            this.bindTableScrollSync();                                             // 綁定表格水平滾動事件
            const ths = this.$el?.querySelectorAll("#loading-container thead th");  // 找出表頭每一欄
            if (!ths || !ths.length) return;
            const widthsAll = Array.from(ths).map(th => Math.round(th.getBoundingClientRect().width));  //getBoundingClientRect()取得元素的尺寸和位置，記錄每個th的實際寬度
            this.toolbarFixedLeftWidth = widthsAll[0] || 0;                         // 第一欄序號另外處理
            const widths = widthsAll.slice(1);                                      // 排除序號欄的剩餘寬度清單
            this.toolbarColWidths = widths;
            this.toolbarTableWidth = widths.reduce((a, b) => a + b, 0);             // 計算工具列寬度總和
        },
        findNearestBoundaryIndex(mouseX, widths, snapPx) {                          // 找滑鼠最靠近哪一條線的index
            let boundaryX = 0;
            let bestIndex = null;                                                   // 目前最接近的index
            let bestDist = snapPx + 1;                                              // 目前找到的最小距離，用 snapPx+1 當初始值，表示尚未命中任何邊界
            for (let i = 0; i <= widths.length; i++) {
                if (i > 0) boundaryX += Number(widths[i - 1] || 0);                 // i>0 才把前一欄寬加進來，得到第 i 條邊界的位置
                const dist = Math.abs(mouseX - boundaryX);                          // 滑鼠到這條線的距離
                if (dist <= snapPx && dist < bestDist) {                            // 若距離在 snapPx 內，且比目前更近，就更新
                bestDist = dist;                                                    // 更新最小距離
                bestIndex = i;                                                      // 更新index值
                }
            }
            return bestIndex;
        },
        onColToolbarMouseMove(e) {                                                  // 滑鼠移動靠近，顯示插入欄位按鈕
            const bar = this.$refs.colToolbarScroll;                                // 工具列的水平捲動容器 
            const widths = this.toolbarColWidths;                                   // 工具列每一欄的寬度陣列
            if (!bar || !widths?.length) return;                             
            const rect = bar.getBoundingClientRect();                               // 取得bar元素的尺寸和位置
            const mouseX = (e.clientX - rect.left) + bar.scrollLeft;                // 把滑鼠位置換成內容座標
            const SNAP = 8;                                                         // 靠近邊界8px內會顯示按鈕
            const index = this.findNearestBoundaryIndex(mouseX, widths, SNAP);      // 最佳插入位置，初始為 null，表示不顯示
            if (index == null) {                                                    // 找不到邊界就關掉按鈕和藍線
                if (this.colInsertHover.active) {
                this.colInsertHover = { active: false, index: null };
                }
                return;
            }
            if (!this.colInsertHover.active || this.colInsertHover.index !== index) {// index有值，顯示按鈕和藍線，index改變時才更新
                this.colInsertHover = { active: true, index };
            }
        },
        onColToolbarMouseLeave(e) {                                                 // 滑鼠離開工具列關掉按鈕和藍線
            const rt = e?.relatedTarget;                                            // 滑鼠進入的下一個元素
            if (rt?.closest?.(".da-col-insert-overlay, .da-insert-col-btn")) return;// 下一個元素是按鈕或藍線，就不關，避免閃爍
            this.colInsertHover = { active: false, index: null };                   // 真的離開
        },
        onClickInsertCol(idx) {
            this.openColumnDialogForAdd(idx);
        },
        onAddColCancel() {
            this.closeColumnDialog();
        },
        async onAddColConfirm(payload) {
            const insertIndex = payload?.insertIndex ?? 0;
            const draft = payload?.payload || null;
            this.ColumnPropertyDialog = false;
            const isCollectionTable = String(this.getCurrentTableConfig()?.object_type_name || "").includes(".");
            const realInsertIndex = insertIndex + (isCollectionTable ? 1 : 0);   // collection有hidden的FK，要+1跳過
            const body = {
                table: this.getCurrentTableConfig()?.object_type_name,
                insert_index: realInsertIndex,
                ...draft,
            };
            const res = await UpGPTPortalDataServices.addAgentConfigColumn(this.documentAgentDetail.id, body);
            this.documentAgentDetail.status = res.data.status;
            await this.fetchDocumentAgentFileType();
            // Task8304 / Task9560: 刷新 tableConfigurations 與 agent_config，確保子表格 configuration 與快取同步
            await this.refreshAgentConfigAndTableList();
            // #8438 document_output add 模式：save 成功後若有待上傳模板，執行上傳並 patch template_url
            const newColumnName = res.data.new_column_name;
            const newFlexfieldColumn = res.data.new_flexfield_column;
            const pendingFile = this.$refs.columnDialogRef?.getPendingUploadFile?.();
            if (newColumnName && newFlexfieldColumn && pendingFile) {
                try {
                    const uploadResult = await this.$refs.columnDialogRef?.uploadPendingTemplate?.(newColumnName);
                    if (uploadResult) {
                        await UpGPTPortalDataServices.updateAgentConfigColumn(this.documentAgentDetail.id, {
                            table: body.table,
                            name: newColumnName,
                            description: draft?.description || "",
                            model: draft?.model || "",
                            reasoning_effort: draft?.reasoning_effort || "",
                            input: draft?.input || [],
                            read_documents: draft?.read_documents || [],
                            user_prompt: draft?.user_prompt || "",
                            hidden: draft?.hidden ?? false,
                            is_key_field: draft?.is_key_field ?? false,
                            flexfield_datatype: draft?.flexfield_datatype || "File",
                            flexfield_column: newFlexfieldColumn,
                            collection_table: draft?.collection_table,
                            collection_properties: draft?.collection_properties,
                            collection_properties_description: draft?.collection_properties_description,
                            flexfield_datadetail: {
                                type: "DocumentOutput",
                                template_url: uploadResult.template_url,
                                template_original_filename: uploadResult.template_original_filename,
                            },
                        });
                    }
                } catch (e) {
                    console.error("Template url patch failed after add column", e);
                }
            }
            await this.loadTable(this.currentTableId, { parentid: this.currentParentId, pushBreadcrumbs: false });
        },
        openColumnDialogForEdit(editData) {
            this.columnDialog.mode = "edit";
            this.columnDialog.model = editData;
            this.columnDialog.key += 1;
            this.columnDialog.open = true;
        },
        openColumnDialogForAdd(idx) {
            this.columnDialog.mode = "add";
            this.columnDialog.insertIndex = Number.isFinite(Number(idx)) ? Number(idx) : 0;
            this.columnDialog.model = {};
            this.columnDialog.key += 1;
            this.columnDialog.open = true;
            this.resetReadDocuments();
        },
        closeColumnDialog() {
            this.$refs.columnDialogRef?.cleanup?.();
            this.columnDialog.open = false;
            this.columnDialog.key += 1;
            this.resetReadDocuments();
            this.$nextTick(() => this.$refs.columnDialogRef?.resetValidationOnClose?.());
        },
        async onColumnDialogConfirm({ mode, payload, insertIndex, runAfterUpdate, deletedSingleSelectLabels }) {
            if (!this.isOwner || this.disabledAll || this.addBtn_loading) return;           // 非 owner 不可新增/編輯欄位，於送出 API 前攔下

            const wasFileUpload = String(this.file_type || "") === "FileUpload";
            const _rawOneDrive = payload?.flexfield_datadetail;
            const isOneDrive = this.getDatadetailType(_rawOneDrive) === "OneDrive";
            const wasOneDrive = mode === "edit" && this.getDatadetailType(this.original_data?.flexfield_datadetail) === "OneDrive";

            if (isOneDrive && !wasOneDrive) {
                const confirmed = await new Promise((resolve) => {
                    this.confirmOneDriveDialog.resolve = resolve;
                    this.confirmOneDriveDialog.open = true;
                });
                if (!confirmed) return;
            }

            try {
                if (mode === "add") {
                    await this.onAddColConfirm({
                        insertIndex,
                        payload,
                        runAfterUpdate,
                    });
                } else {
                    await this.onEmitEditDocumentAgentConfig({
                    editData: payload,
                    deletedSingleSelectLabels,
                    runAfterUpdate,
                    });

                    if (wasFileUpload && String(this.file_type || "") === "OneDrive") {
                        // [VIEWER_ONEDRIVE_TAKEOVER] detach_folder 後端改以「OneDrive 綁定者」把關。
                        // 由 FileUpload 切換成 OneDrive 時尚未綁定任何 OneDrive（token_store 為 None），
                        // 後端會回 403。此處 detach 僅為清理舊資料，沒有綁定即代表沒有要清的同步資料，
                        // 因此 403 視為可忽略，不應中斷欄位型別切換流程。
                        try {
                            await UpGPTPortalDataServices.deleteFile(this.documentAgentDetail.id, this.selectedItems);
                        } catch (delErr) {
                            if (delErr?.response?.status !== 403) throw delErr;
                        }
                        this.selectedItems = {};
                        await this.getDocumentAgentDetail();
                    }
                }
                this.closeColumnDialog();
            } catch (e) {
                // backstop：欄位設定儲存失敗（如 owner 權限變更、競態、API 直呼）不再靜默，改跳錯誤提示
                const status = e?.response?.status;
                const msg = status === 403
                    ? this.$t('WORK_AGENT.NO_EDIT_PERMISSION')
                    : (e?.response?.data?.detail || e?.message || this.$t('WORK_AGENT.ERROR_NO_PERMISSION'));
                this.showErrorDialog(msg);
            }
        },
        onCancelConfirmOneDriveDialog() {
            this.confirmOneDriveDialog.open = false;
            this.confirmOneDriveDialog.resolve?.(false);
            this.confirmOneDriveDialog.resolve = null;
        },
        onConfirmUpdateToOneDriveDialog() {
            this.confirmOneDriveDialog.open = false;
            this.confirmOneDriveDialog.resolve?.(true);
            this.confirmOneDriveDialog.resolve = null;
        },
        updateTooltipPlacement(e, field) {                                                          // 計算可用空間，決定 tooltip 顯示位置
            const el = e?.currentTarget;
            if (!el || !field) return;
            const rect = el.getBoundingClientRect();                                                // 取得 icon 實際位置與尺寸
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;   // 取得目前視窗寬度
            const rightSpace = viewportWidth - rect.right;                                          // 計算 icon 右側剩餘空間
            const nextPlacement = rightSpace >= (this.tooltipMaxWidthPx + 12) ? "right" : "bottom";
            if (this.tooltipPlacementByField[field] !== nextPlacement) {
                this.$set(this.tooltipPlacementByField, field, nextPlacement);
            }
        },
        parseReferenceCards(raw) {
            if (!raw) return [];

            let parsed = raw;

            if (typeof raw === "string") {
            const trimmed = raw.trim();
            if (!trimmed) return [];

            // 只嘗試解析 JSON array / object
            if (
                (trimmed.startsWith("[") && trimmed.endsWith("]")) ||
                (trimmed.startsWith("{") && trimmed.endsWith("}"))
            ) {
                try {
                parsed = JSON.parse(trimmed);
                } catch (e) {
                return [];
                }
            } else {
                return [];
            }
            }

            if (Array.isArray(parsed)) {
            return parsed
                .filter(item => item && typeof item === "object")
                .map(item => ({
                context_id: item.context_id || "",
                title: item.title || "",
                url: item.url || "",
                content: item.content || "",
                score: item.score,
                }));
            }

            return [];
        },

        getRefDomain(url) {
            if (!url) return "";
            try {
            return new URL(url).hostname.replace(/^www\./, "");
            } catch (e) {
            return url;
            }
        },
    },
    computed: {
        daIcons() { return { ...ICONS, clearIcon: CLEAR_ICON }; },
        // 授權停止服務或無效時，四個執行入口一律呈現停用外觀。
        // 這只是給使用者看的提示，真正擋住執行的是 runAgent() 的前置檢查。
        isLicenseBlocking() {
            return this.$store.getters.isLicenseBlocking;
        },
        webCardItems() {
            if (Array.isArray(this.refWebSearchResults) && this.refWebSearchResults.length) {
            return this.refWebSearchResults;
            }
            return this.referenceCards || [];
        },
        displayRefContent() {
            if (this.refPopup && typeof this.refPopup.content !== "undefined") {
            return this.refPopup.content;
            }

            if (
            this.refPopup &&
            Array.isArray(this.refPopup.refs) &&
            this.refPopup.refs[this.refPopup.activeIndex]
            ) {
            return this.refPopup.refs[this.refPopup.activeIndex].content || "";
            }

            return "";
        },

        referenceCards() {
            return this.parseReferenceCards(this.displayRefContent);
        },
        isAdmin() {
            return localStorage.getItem('is_staff') === 'true';
        },
        supportedFileAccept() {
            return SUPPORTED_FILE_EXTENSIONS.join(',');
        },
        hasSelectedFolder() {
            const s = this.selectedItems;
            return s != null && Boolean(s.full_path || s.id);
        },
        refRenderedHtml() {
            const raw0 = String(this.refPopup?.content || "");
            const raw = this.normalizeTextForDisplay(raw0); // 讓 \\n / \r\n 都能正常換行
            if (!this.refMarkdownIt) return raw;
            return this.refMarkdownIt.render(raw);
        },
        refTitleRenderedHtml() {
            const raw = this.normalizeTextForDisplay(this.refPopup.title);
            return this.refMarkdownIt ? this.refMarkdownIt.render(raw) : raw;
        },
        customizationButtons() {                                    //取客製按鈕清單
        const agentConfig = this.documentAgentDetail?.agent_config; // 先拿agent_config
        const rawButtons = agentConfig?.customization_button;       //從 agent_config 取 customization_button
        if (!Array.isArray(rawButtons)) return [];                  //如果不是Array就回空
        return rawButtons;                                          //回按鈕陣列給 v-for
        },
        cloudDriveEnabled(){
            return String(this.file_type || "") === "OneDrive";     // file_type 為 "OneDrive" 時，才啟用(OneDrive)相關 UI/按鈕
        },
        canShowCreateRowBtn(){
            if (!this.manualUploadMode) return false;  // 是fileupload
            return true;
        },
        isRootTable() {
            const cur = String(this.currentTableId || "");
            const root = String(this.rootTableId || "");
            if (cur === "") return false;
            if (root === "") return false;
            return cur === root;
        },
        hasManualUploadColumn() {
            const cols = Array.isArray(this.currentHeader) ? this.currentHeader : [];// 取目前表的欄位定義
            return cols.some(m => {                                                  // 存在任一個符合條件的欄位，就回 true
            const dt = String(m?.flexfield_datatype || "").trim().toLowerCase();     // 整理格式
            const _rawHMU = m?.flexfield_datadetail;
            const detail = this.getDatadetailType(_rawHMU);             // 整理格式
            return dt === "file" && detail === "FileUpload";                         // type=file且detail=FileUpload
            });
        },
        manualUploadMode() {    //是否符合上傳模式
            return String(this.file_type || "") === "FileUpload";
        },
        canRunAgent() { //兩種模式可以run的條件判斷
            if (this.cloudDriveEnabled) return this.hasSelectedFolder; // OneDrive要選到資料夾
            if (this.manualUploadMode) return true; // FileUpload不檢查檔案
            return false;
        },
        hasTableData() { 
            return Number(this.totalCount || 0) > 0;
        },
        canUsePostRunButtons() {
            if (this.run_agent_loading) return false;
            if (this.addBtn_loading) return false;
            if (this.isUploading) return false;
            if (this.cloudDriveEnabled && !this.hasSelectedFolder) return false; // OneDrive 模式才要求 o365AccountData
            if (!this.hasTableData) return false;   // 有資料才允許匯出/客製功能
            return true;
        },
        agentStatusIcon() {
            const s = String(this.documentAgentDetail?.status).trim().toUpperCase();
            const map = {
                PROCESSING: this.processingIcon,
                FINISHED: this.finishedIcon,
                UPDATED: this.updatedIcon,
                NOT_STARTED: this.notStartedIcon,
            };
            return map[s];
        },
        isFileUploadMode() {
            const cols = this.documentAgentDetail?.agent_config?.columns || [];
            return cols.some(c => {
                const _raw = c?.flexfield_datadetail;
                return this.getDatadetailType(_raw) === "FileUpload";
            });
        },
        isOwner() {
            const ownerId = this.documentAgentDetail?.owner;
            const userId = this.user_id;
            if (ownerId == null || userId == null) return false;
            return Number(ownerId) === Number(userId);
        },
        // [VIEWER_ONEDRIVE_TAKEOVER] 目前這組 OneDrive 綁定是否為「我自己連結的」，決定資料夾區/自動同步是否開放。
        // 優先採用後端權威布林 o365AccountData.is_binding_mine（後端以 token.owner_id == request.user.id 判定，見 serializer）。
        // 安全退回：後端尚未回傳此欄位（版本未更新）時退回原 isOwner 行為，避免 owner 被誤擋；
        //   注意此退回會讓「viewer 接管」在後端更新前暫時失效（需重啟後端使 is_binding_mine 生效）。
        // 還原此功能時可一併移除此 computed。
        isBindingMine() {
            const v = this.o365AccountData?.is_binding_mine;
            if (typeof v === "boolean") return v;   // 後端權威判定
            return this.isOwner;                      // 後端未提供（未更新）→ 退回原 owner 行為
        },
        currentTableShortName() {
            const cfg = (this.tableConfigurations || []).find(t => String(t.id) === String(this.currentTableId));
            return this.getShortTableName(cfg?.object_type_name || "");
        },
        colInsertX() {                                                                      // 計算按鈕和藍線的 x 座標
            const idx = Number(this.colInsertHover?.index ?? 0);                            // 取得目前 hover 到的插入位置 index
            const ws = Array.isArray(this.toolbarColWidths) ? this.toolbarColWidths : [];   // 取每一欄的寬度
            let x = 0;
            for (let i = 0; i < idx && i < ws.length; i++) x += Number(ws[i] || 0);         // 前面所有欄位的寬度總和
            return x;                                                                       // 回傳座標
        },
        colInsertLeftPx() {
            const x = Number(this.colInsertX || 0);                                         // 取內容座標的 x
            const left = x - Number(this.tableScrollLeft || 0);                             // 扣掉表格目前滾動的範圍
            return Number(this.toolbarFixedLeftWidth || 0) + left;                          // 再加回序號欄的固定寬度
        },
        canShowColInsertOverlay() {
            if (!this.isOwner) return false;                                                // 僅 owner 可新增欄位，被分享者唯讀（隱藏插入鈕）
            if (!this.colInsertHover.active) return false;
            const fixedLeft = Number(this.toolbarFixedLeftWidth || 0);                      // 抓左側固定欄寬度
            const leftPx = Number(this.colInsertLeftPx || 0);                               // 藍線目前實際座標
            return leftPx >= (fixedLeft);                                                   // 藍線座標>=固定欄寬度才顯示
        },
        currentOneDriveCount() {
            const cols = Array.isArray(this.currentHeader) ? this.currentHeader : [];
            return cols.filter(m => {
                const _raw = m?.flexfield_datadetail;
                const _type = this.getDatadetailType(_raw);
                return String(m?.flexfield_datatype || "").trim().toLowerCase() === "file" &&
                    String(_type || "").trim().toLowerCase() === "onedrive";
            }).length;
        },
        currentLevelColumns() {
            return Array.isArray(this.currentHeader) ? this.currentHeader : [];
        },
        visibleHeaders() {
            return (Array.isArray(this.currentHeader) ? this.currentHeader : []).filter(c => !c.hidden);
        },
        showRefViewToggle() {
            return (
                this.refPopup.contentType === 'TEXT' &&
                /\.pdf$/i.test(this.refPopup.fileName || '') &&
                !!this.refPopup.fileUrl
            );
        },
        // 三點選單項目（依當前欄位型別動態生成）
        headerActions() {
            const col = this.headerMenu?.col;
            const meta = col ? (this.columnMetaMap?.[col.field] || null) : null;
            const dtype = meta?.flexfield_datatype || '';
            const isSortFilter = ['Text','SingleSelect','Number','File','DocumentOutput'].includes(dtype);
            const items = [];
            items.push({ key: 'properties', text: this.$t('DOCUMENT_AGENT.PROPERTIES'), icon: require('@/assets/images/properties-setting.svg') });
            items.push({ key: 'regenerate',  text: this.$t('DOCUMENT_AGENT.REGENERATE'),  icon: require('@/assets/images/regenerate-column.svg') });
            if (isSortFilter) {
                items.push({ key: '__divider_1__' });
                items.push({ key: 'sort', text: this.$t('DOCUMENT_AGENT.MENU_SORT'), type: 'sort-row', mdiIcon: 'mdi-sort' });
                items.push({ key: 'filter', text: this.$t('DOCUMENT_AGENT.MENU_FILTER'), mdiIcon: 'mdi-filter-outline' });
            }
            if (this.isOwner) {                                                             // 刪除欄位僅 owner 可操作，被分享者隱藏（regenerate/排序/篩選為檢視+執行類，維持可用）
                items.push({ key: '__divider_2__' });
                items.push({ key: 'delete', text: this.$t('GENERAL.DELETE'), icon: require('@/assets/images/delete_column.svg') });
            }
            return items;
        },
        currentHeaderSortDir() {
            const col = this.headerMenu?.col;
            return col ? this.getSortState(col.field) : null;
        },
        // Task 3-1: 篩選面板下拉選單選項（依欄位型別）
        filterPanelOperators() {
            if (!this.filterPanelField) return [];
            const meta = this.columnMetaMap?.[this.filterPanelField];
            if (!meta) return [];
            const dtype = meta.flexfield_datatype;
            const t = (k) => this.$t('DOCUMENT_AGENT.' + k);
            if (['Text','SingleSelect'].includes(dtype)) {
                return [
                    { value: 'contains',     label: t('FILTER_CONTAINS') },
                    { value: 'not_contains', label: t('FILTER_NOT_CONTAINS') },
                    { value: 'equals',       label: t('FILTER_EQUALS') },
                    { value: 'not_equals',   label: t('FILTER_NOT_EQUALS') },
                    { value: 'is_empty',     label: t('FILTER_IS_EMPTY') },
                    { value: 'is_not_empty', label: t('FILTER_IS_NOT_EMPTY') },
                ];
            }
            if (dtype === 'Number') {
                return [
                    { value: 'equals',       label: t('FILTER_EQUALS') },
                    { value: 'not_equals',   label: t('FILTER_NOT_EQUALS') },
                    { value: 'gt',           label: t('FILTER_GT') },
                    { value: 'gte',          label: t('FILTER_GTE') },
                    { value: 'lt',           label: t('FILTER_LT') },
                    { value: 'lte',          label: t('FILTER_LTE') },
                    { value: 'between',      label: t('FILTER_BETWEEN') },
                    { value: 'is_empty',     label: t('FILTER_IS_EMPTY') },
                    { value: 'is_not_empty', label: t('FILTER_IS_NOT_EMPTY') },
                ];
            }
            if (['File','DocumentOutput'].includes(dtype)) {
                return [
                    { value: 'is_empty',     label: t('FILTER_IS_EMPTY') },
                    { value: 'is_not_empty', label: t('FILTER_IS_NOT_EMPTY') },
                ];
            }
            return [];
        },
        filterPanelIsNumber() {
            if (!this.filterPanelField) return false;
            const meta = this.columnMetaMap?.[this.filterPanelField];
            return meta?.flexfield_datatype === 'Number';
        },
    },
    watch:{
        doc_agent_id(val){
            if(val){
                this.selectedFlexfieldData = [];    // 切表清空勾選
                this.breadcrumbs = [];
                this.currentParentId = null;
                this.showAllParent = null;
                this.showAllParentCheckBox = false;
                this.recordReviewPageOpen = false;
                this.recordReviewRow = null;
                this.recordReviewField = null;
                this.getDocumentAgentDetail();
                this.getDocUserAgentO365AccountData();
                this.fetchDocumentAgentFileType();  //切表時重抓file_type
            }
        },
        selectedItems(val){
            if(val){
                console.log("this.selectItems", this.selectedItems)
            }
        },
        breadcrumbs(val){
            if(val.length <= 1){
                this.showAllParentCheckBox = false;
            }else{
                this.showAllParentCheckBox = true;
            } 
        },
        "agentCardData.icon_path":function(e){
            if (e){
                this.select_icon_obj = { name: e, path: this.mapping_icon_path(e) }
            } else {
                this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
            }
        },
        loading(val) {          // 監聽 loading 狀態變化
            if (!val) {         // loading 結束
                this.$nextTick(() => {
                    this.updateTableSize();         // 重算高度
                    this.bindTableScrollSync();     // 綁定滾動事件
                    this.syncColToolbarWidths();    // 重新量測表頭寬度   
                });
            }
        },
        columns: {                                  // 監聽表格欄位定義變化
            deep: true,
            handler() {
                this.$nextTick(() => this.syncColToolbarWidths());
            },
        },
        tableData() {                               // 監聽表格資料變化，換頁/重抓/更新 cell 都會觸發
            this.$nextTick(() => this.syncColToolbarWidths());
        },
    }
}
</script>
<style scoped lang="css">
.DocumentAgent {
  color: #444444;
  font-family: 'Segoe UI', 'Noto Sans TC', sans-serif;
}
.theme--light.v-input input,
.theme--light.v-input textarea {
  color: #444 !important;
}
.defaultFontBtn.theme--light.v-btn {
  color: #444;
}
.empty-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100%;
  color: #666;
  font-size: 16px;
  border: 1px solid #d1d1d1;
  border-top: 0;
}
/* 編輯儲存格*/
.document-agent-cell-editable {
  cursor: default; 
  min-height: 22px;
}
.document-agent-cell-input {
  width: 100%;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 13px;
  outline: none;
}
.document-agent-cell-input:focus {
  border-color: #18bedf;
  box-shadow: 0 0 0 2px rgba(24, 190, 223, 0.15);
}
.document-agent-cell-error {
  font-size: 12px;
  color: #d32f2f;
}
/* Reference 彈窗樣式 */
.ref-modal-custom {
  border-radius: 12px !important;
  overflow: hidden;
}
.ref-card-container {
  height: 80vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.ref-body-container {
  flex: 1;
}
.ref-two-pane {
  display: flex;
  width: 100%;
}
.ref-pane {
  height: 100%;
}
.ref-pane-header {
  height: 70px;
  min-height: 70px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fff;
}
.ref-content-left {
  flex: 0 0 60%;
  max-width: 60%;
  border-right: 1px solid #F5F5F5;
}
.ref-left-header {
  height: 70px;
  min-height: 70px;
  background-color: #F5F5F5 !important;
  border-bottom: 1px solid #e0e0e0;
}
.ref-left-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  column-gap: 16px;
}
.ref-pane-header__left,
.ref-pane-header__center,
.ref-pane-header__right {
  min-width: 0;
}
.ref-pane-header__center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ref-pane-header__right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.ref-left-body {
  overflow-y: auto;
  background-color: #F5F5F5 !important;
  display: flex;
  flex-direction: column;
}
.ref-pre-text {
  user-select: text;
  white-space: normal;
  word-break: break-word;
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  font-family: "PingFang TC", "Microsoft JhengHei", sans-serif;
  margin: 0;
}
.ref-empty-state {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  font-family: "PingFang TC", "Microsoft JhengHei", sans-serif;
  user-select: text;
  cursor: text;
}
.ref-sidebar-right {
  flex: 0 0 40%;
  max-width: 40%;
  background-color:  #FFFFFF !important;
}
.ref-right-header {
  background-color: #fff;
}
.ref-sidebar-col-label {
  font-size: 16px;
  color: #666;
}
.sidebar-value-text {
  user-select: text;
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  display: block;
  word-break: break-all;
}
.ref-index-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;            
  width: auto;               /* 隨文字延伸 */
  height: 16px;
  padding: 0 4px;            
  background-color: #F3F3EE;
  border: 1px solid #898989;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #666;
}
.ref-nav-btn {
  min-width: 16px !important;
  width: 16px !important;
  height: 16px !important;
  padding: 0 !important;
  background-color: #F3F3EE !important;
  border: 1px solid #898989 !important;
  border-radius: 4px !important;
  color: #444 !important;
  font-size: 10px !important;
  font-weight: 500 !important;
}
.ref-nav-btn-active {
  border-color: #14C6DE !important;
  background-color: #e0f7fa !important;
  color: #444 !important;
}
.ref-nav-btn:hover {
  border-color: #14C6DE !important;
}
.ref-meta-label {
  color: #666;
  font-size: 13px;
  margin-right: 4px;
}
.ref-meta-value {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.ref-open-link-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 14px;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep #loading-container .ve-table-header-th {
  white-space: nowrap !important;
}
/* 文字/collection/file link的ellipsis */
::v-deep #loading-container .file-link,
::v-deep #loading-container .da-ellipsis{
  display: block;           /* 有block，ellipsis 才有「裁切邊界」 */    
  max-width: 100%;          /* 文字不能超出cell寬度 */
  white-space: nowrap;      /* 單行顯示，不換行 */
  overflow: hidden;         /* 超出 max-width 的部分裁掉 */
  text-overflow: ellipsis;  /* 被裁掉時顯示 ...（即ellipsis） */
  min-width: 0;             /* 內容區塊變窄，壓縮到文字，才會出現... */
}
::v-deep #loading-container .file-link{
  padding-left: 10px;
}
::v-deep #loading-container .da-ellipsis{
  color: #666;
  padding-left: 0px;
}
/* pill中的文字ellipsis */
::v-deep #loading-container .da-pill-text{
  display: block;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep #loading-container .da-pill-ellipsis{
  display: inline-block;    /* pill的背景不填滿 */
}
::v-deep #loading-container .ve-th-menu .ve-th-menu-btn{    /* 固定三點按鈕位置 */
  position: absolute;           /* 固定出現在版面上 */
  right: 8px;                
  top: 50%;                     /* 把「按鈕的上緣」放到容器高度的中間 */
  transform: translateY(-50%);  /* 再往上拉自身高度的一半，達到垂直置中 */
  z-index: 5;                   /* 疊在標題文字上層，避免被蓋住或點不到 */
}
::v-deep #loading-container {
  --da-hover-bg: #f4f4f4;
}
::v-deep #loading-container .da-td-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  min-height: 22px;
}
::v-deep #loading-container .da-td-content {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 2px;
}
::v-deep #loading-container .da-actions-float {
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #F5F7FA;
  box-shadow: -14px 0 12px var(--da-hover-bg);
  padding-left: 6px;
  padding-right: 2px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.12s ease;
}
::v-deep #loading-container .ve-table-body-td:hover .da-actions-float {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}
/* collection 欄位：右側永久保留 2 個 icon 寬度，避免 hover icon 蓋住聯結按鈕 */
::v-deep #loading-container .da-td-wrap--collection .da-td-content {
  padding-right: 44px;
}
::v-deep #loading-container .da-td-wrap--collection .da-actions-float {
  background-color: transparent;
  box-shadow: none;
}
::v-deep #loading-container .da-icon-btn {
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  line-height: 1;
}
::v-deep #loading-container .da-icon-btn:hover {
  opacity: 0.85;
}
::v-deep #loading-container .da-icon-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
::v-deep #loading-container .da-icon-btn:disabled:hover {
  opacity: 0.3;
}
::v-deep #loading-container{
  --da-table-header-color: #444444;
  --da-table-body-color: #666666;
}
::v-deep #loading-container .ve-table-header-th,
::v-deep #loading-container .ve-table-header-th-cell{
  color: var(--da-table-header-color) !important;
}
::v-deep .DocumentAgentPage{
  color: #444444 !important;
}
::v-deep .consent-dialog {
  border-radius: 12px !important;
}
::v-deep .consent-dialog .consent-card {
  border-radius: 12px !important;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.22) !important;
  font-family: "Segoe UI", "SF Pro Display", "PingFang TC", "Microsoft JhengHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  color: #222;
}
::v-deep .consent-dialog .consent-title {
  justify-content: center;
  text-align: center;
  padding: 24px 24px 14px 24px !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  color: #222 !important;
  letter-spacing: 0px !important;
}
::v-deep .consent-dialog .consent-body {
  padding: 14px 52px 20px 52px !important;
}
::v-deep .consent-dialog .consent-body .v-row {
  margin-bottom: 18px !important;
}
::v-deep .consent-dialog .consent-body .v-row:last-child {
  margin-bottom: 10px !important;
}
::v-deep .consent-dialog .consent-label {
  display: inline-flex;
  align-items: center;
  height: 46px;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
  color: #444 !important;
  letter-spacing: 0px !important;
  white-space: nowrap;
}
::v-deep .consent-dialog .consent-field .v-input__control {
  min-height: 46px !important;
}
::v-deep .consent-dialog .consent-field .v-input__slot {
  min-height: 46px !important;
  border-radius: 6px !important;
}
::v-deep .consent-dialog .consent-field fieldset {
  border: 1.5px solid #7f7f7f !important;
}
::v-deep .consent-dialog .consent-field.v-input--is-focused fieldset {
  border-color: #32DBF7 !important;
}
::v-deep .consent-dialog .consent-field input,
::v-deep .consent-dialog .consent-field textarea,
::v-deep .consent-dialog .consent-field .v-select__selection,
::v-deep .consent-dialog .consent-field .v-select__selections {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
  color: #222 !important;
}
::v-deep .consent-dialog .consent-field .v-input__append-inner {
  margin-top: 11px !important;
}
::v-deep .consent-dialog .consent-field .v-icon {
  font-size: 20px !important;
  color: #666 !important;
}
::v-deep .consent-dialog .consent-hint {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #8a8a8a;
  line-height: 1.2;
}
::v-deep .consent-dialog .consent-actions {
  background: #f2f2f2 !important;
  padding: 16px 34px !important;
  border-top: 1px solid #e6e6e6;
}
::v-deep .consent-dialog .consent-btn {
  height: 46px !important;
  border-radius: 6px !important;

  font-family: "Segoe UI", "PingFang TC", "Microsoft JhengHei", sans-serif;
  text-transform: none !important;
  box-shadow: none !important;
}
::v-deep .consent-dialog .consent-btn .v-btn__content {
  font-size: 18px !important;
  font-weight: 800 !important;
  line-height: 1 !important;
  letter-spacing: 1px !important;
}
::v-deep .consent-dialog .consent-btn-cancel {
  background: #fff !important;
  color: #666 !important;
  border: 1.5px solid #7f7f7f !important;
}
::v-deep .consent-dialog .consent-btn-cancel.v-btn--disabled {
  border-radius: 4px !important;
  border: 1px solid var(--Btn-Border-Blue-Text-Inactive, #CCC) !important;
  background: transparent !important;
  color: #CCC !important;
}
::v-deep .consent-dialog .consent-btn-submit {
  background-color: #14C6DE !important;
  color: #fff !important;
}
::v-deep .consent-dialog .consent-btn-submit:hover {
  opacity: 0.92;
}
::v-deep .consent-dialog .consent-btn-submit.v-btn--disabled {
  border-radius: 4px !important;
  background: var(--Btn-Primary-blue-BG-Inactive, #E8E8E8) !important;
  color: #CCC !important;
}
.ts-option-label,
.ts-value-label{
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ts-folder-icon{
  width: 16px;
  height: 16px;
  display: inline-block;
}
::v-deep .vue-treeselect__no-children-tip-text {
  font-size: 0 !important;          
}
::v-deep .vue-treeselect__no-children-tip-text::after {
  content: "No sub-folders";
  font-size: 12px;                  
}
/* 麵包屑左緣與排序/篩選狀態列、表格對齊（覆蓋 Vuetify .v-application ul 的 24px 左內距），並縮小上下內距 */
.v-breadcrumbs {
  padding: 8px 0px;
}
/* 本頁相鄰列間距 */
.row + .row {
  margin-top: 16px;
}
::v-deep .theme--light.v-breadcrumbs a.v-breadcrumbs__item {
  color: #999999 !important;
}
::v-deep .theme--light.v-breadcrumbs a.v-breadcrumbs__item--disabled,
::v-deep .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
  color: #666666 !important;
}
::v-deep .theme--light.v-breadcrumbs .v-breadcrumbs__divider {
  color: #999999 !important;
}
::v-deep #loading-container .da-cell-status{
  display: flex;
  align-items: center;
  gap: 6px;
}
::v-deep #loading-container .da-status-wrap{
  margin-left: auto;
  flex: 0 0 auto;
}
::v-deep #loading-container .da-status-fixed{
  margin-left: auto;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding-left: 6px;
  pointer-events: none;
}
.ref-filename{
  font-size: 20px;
  font-weight: 700;
  color: #444;
  line-height: 1.2;
  max-width: 100%;
}
.ref-md-content {
  user-select: text;
  cursor: text;
}
/*  Reference modal - markdown/html table 顯示 */
::v-deep .ref-md-content p {
  margin: 0 0 10px;
}
::v-deep .ref-md-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  table-layout: auto;
}
::v-deep .ref-md-content th,
::v-deep .ref-md-content td {
  border: 1px solid #e8e8e8;
  padding: 6px 8px;
  vertical-align: top;
}
::v-deep .ref-md-content th {
  background: #f6f7f9;
  font-weight: 700;
}
::v-deep .ref-md-content pre {
  white-space: pre-wrap;
  word-break: break-word;
  background: #f6f7f9;
  padding: 10px;
  border-radius: 6px;
}
.sidebar-value-text{
  white-space: normal;
  word-break: break-word;
}
::v-deep .sidebar-value-text table{
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
}
::v-deep .sidebar-value-text th,
::v-deep .sidebar-value-text td{
  border: 1px solid #e8e8e8;
  padding: 6px 8px;
  vertical-align: top;
}
.ref-right-body {
  overflow-y: auto;
}
.da-add-btn {
  width: 50px; 
  height: 42px;
  min-width: 50px !important;
  border: 1px solid #ccc;
  border-top: none;
  background-color: #f5f5f5;
}
::v-deep #loading-container .da-upload-placeholder {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 8px;
  border: 1px dashed #d1d1d1;
  background-color: #f9f9f9;
  border-radius: 4px;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  line-height: 1.5;
  width: 100%;
  min-height: 28px;
  box-sizing: border-box;
}
::v-deep #loading-container .da-upload-placeholder:hover {
  border-color: #14C6DE;
  color: #666;
  background-color: #f0fbfc;
}
::v-deep .ve-table-container {
    background-color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
}
.da-ve-table-wrap {
    position: relative;
    width: 100%;
}
/* 表格空白時（尚無資料／篩選無結果）撐出最小高度顯示提示 */
.da-ve-table-wrap--empty ::v-deep .ve-table-container {
    min-height: 200px;
}
.da-empty-absolute-overlay {
    position: absolute;
    top: 36px;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
}
.da-empty-absolute-overlay span {
    color: #666;
    font-size: 16px;
    font-weight: 500;
}
/* 篩選無結果時的「清除所有篩選」CTA：overlay 容器為 pointer-events:none，按鈕需重新開啟點擊 */
.da-empty-absolute-overlay .da-empty-clear-btn.v-btn {
    pointer-events: auto;
    height: 32px !important;
    text-transform: none;
    background: #FFFFFF !important;
    border: 1px solid #CCCCCC !important;
    border-radius: 4px !important;
}
.da-empty-absolute-overlay .da-empty-clear-btn.v-btn .v-btn__content {
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.5px;
}
#GPT.DocumentAgent .da-add-row-area {
  position: relative;
  top: auto;
  left: 0;
  z-index: 5;
}
.da-add-btn {
    width: 50px;
    height: 42px;
    border: 1px solid #d1d1d1;
    border-top: none;
    background-color: #f5f5f5 !important;
}
::v-deep .ve-table-scroll-wrapper {
    bottom: 0 !important;
}
::v-deep #loading-container .da-file-dropzone {
  width: 100%;
  min-height: 42px;
  display: flex;
  align-items: center;
}
::v-deep #loading-container .da-file-dropzone--over {
  outline: 1px solid #14C6DE;
  outline-offset: -1px;
  background-color: #f0fbfc;
}
.da-ai-disclaimer {
  font-size: 14px;
  color: #999;
}
::v-deep #loading-container .da-upload-hint{
  color: #999;
  font-size: 14px;
  padding-left: 10px !important;
}
::v-deep .da-run-split {
  padding: 0 !important;
  border-radius: 6px !important;
  min-width: 150px;
  margin-bottom: 5px;
}
::v-deep .da-run-left {
  padding: 0 12px;
  height: 30px;
}
::v-deep .da-run-menu {
  min-width: 100% !important;
}
::v-deep .da-run-split:focus {
  outline: none;
}
::v-deep .da-run-split .v-btn__content {
  height: 100%;
}
::v-deep .da-run-caret {
  width: 36px;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
::v-deep .da-run-caret::after {
  content: "";
  position: absolute;
  inset: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background: rgba(0, 0, 0, 0.12);
  opacity: 0;
  transition: opacity 0.15s ease;
  pointer-events: none;
}
::v-deep .da-run-split:not(.v-btn--disabled) .da-run-caret:hover::after,
::v-deep .da-run-caret.da-run-caret--active::after {
  opacity: 1;
}
::v-deep .da-run-menu-list .v-list-item {
  min-height: 30px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  align-items: center !important;
  font-size: 14px;
}
::v-deep .da-run-menu-list.v-list {
  padding: 0 !important;
}
::v-deep .da-run-menu-list .da-runall-icon {
  margin-right: 8px !important;
  display: inline-block;
  vertical-align: middle;
}
::v-deep .da-run-menu-list .v-list-item__title {
  margin-left: 0 !important;
}
::v-deep #loading-container .da-file-error-wrap {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
}
::v-deep #loading-container .da-file-error-wrap .da-cell-error-text {
  flex: 0 0 auto;
}
::v-deep #loading-container .da-file-error-name {
  margin-left: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep #loading-container .ve-table-body-td:has(.da-file-cell) {
  padding: 0px !important;
}
::v-deep #loading-container .da-td-content:has(.da-file-cell) {
  padding: 0px !important;
}
::v-deep #loading-container .da-status-fixed--file {
  padding-right: 10px !important;
}
.da-run-all{
    font-weight: 500;
}
::v-deep #loading-container .da-file-dropzone--col-over {
  background-color: #f0fbfc !important; 
  border-left: 1px solid #14C6DE;
  border-right: 1px solid #14C6DE;
  box-sizing: border-box;
}
::v-deep #loading-container .da-file-dropzone--error-over {
  outline: 1px solid #ED4242;
  outline-offset: -1px;
  background-color: #FCFBF7;
}
::v-deep #loading-container .da-file-dropzone--rejected {
  outline: 1px solid #ED4242;
  outline-offset: -1px;
  background-color: #FCFBF7;
}
::v-deep #loading-container .ve-table-body-td:has(.da-file-dropzone--error-over),
::v-deep #loading-container .ve-table-body-td:has(.da-file-dropzone--rejected) {
  position: relative;
  z-index: 6;
  overflow: visible !important;
}
::v-deep #loading-container .da-th-dropzone--over {
  background-color: #f0fbfc !important;
  outline: none !important;
  border-top: 1px solid #14C6DE;
  border-left: 1px solid #14C6DE;
  border-right: 1px solid #14C6DE;
  border-bottom: none; 
  min-height: 40px;
}
::v-deep #loading-container .ve-table-header-th {
  padding: 0 !important;
  background: #F4F4F4 !important;
  border-top: 1px solid #CCCCCC !important;
  border-left: 1px solid #CCCCCC !important;
}
::v-deep #loading-container .ve-th-menu {
  height: 36px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  box-sizing: border-box;
}
::v-deep #loading-container .ve-table-header-th-cell {
  font-family: 'Noto Sans TC', sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #444444 !important;
  letter-spacing: 0.5px !important;
}
::v-deep .v-tab {
    text-transform: none !important;
}
::v-deep .vue-treeselect__option--selected .ts-value-label span {
    font-weight: 700 !important;
    color: #000 !important;
}
::v-deep .vue-treeselect__option--selected {
     background-color: #f5f5f5;
     font-weight: 700;
     color: #000;
}
::v-deep .btn-add-connection {
    border-radius: 50% !important;
}
::v-deep .btn-add-connection:focus,
::v-deep .btn-add-connection:active {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
}
::v-deep .sync-checkbox .v-label {
  margin-left: 8px;
}
::v-deep .da-cloud-row {
  height: 40px !important;
  align-items: center !important;
  padding-left: 0;
  padding-right: 0;
}
::v-deep #loading-container .ve-table-body-td:has(.da-file-dropzone--over) {
  position: relative;
  z-index: 6;
  box-shadow: 0 10px 26px rgba(153, 153, 153, 0.50);
  overflow: visible !important;
}
::v-deep #loading-container .ve-table-body-td:has(.da-file-dropzone--col-over) {
  position: relative;
  z-index: 5;
  box-shadow: 0 12px 30px rgba(153, 153, 153, 0.50);
  overflow: visible !important;
}
::v-deep .agent_title_text_field .v-input__control,
::v-deep .agent_title_text_field .v-input__slot,
::v-deep .agent_title_text_field .v-text-field__slot{
  max-width: 100%;
  min-width: 0 !important;
  overflow: hidden;
  width: auto !important;
}
::v-deep .agent_title_text_field input{
  field-sizing: content;
}
::v-deep .agent_title_text_field input {
  color: #444444 !important;
}
::v-deep #loading-container .da-icon-mask{
  width: 16px;
  height: 16px;
  display: block;
  background-color:#999;
  mask-image: var(--da-mask);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
.da-run-icon--disabled {
  filter: brightness(0) invert(0.7);
}
#GPT.DocumentAgent.main-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
  isolation: isolate;
}
#GPT.DocumentAgent{
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
}
#GPT.DocumentAgent .da-table-wrap {
  flex: none !important;
  display: block !important; 
  width: 100%;
  min-height: 0;
  overflow: visible; 
  isolation: isolate;
}
#GPT.DocumentAgent .document-agent-table {
  flex: none !important;
  height: auto !important;
  width: 100%;
  margin: 0 !important;
  position: relative;
  z-index: 0;
  overflow: hidden;
}
.da-footer-row {
  flex: none !important;
  width: 100%;
  padding: 10px 0;
}
::v-deep .da-pagination-wrap .v-pagination {
  margin: 0;
}
::v-deep .da-pagination-wrap .v-pagination .v-pagination__item,
::v-deep .da-pagination-wrap .v-pagination .v-pagination__navigation {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  box-shadow: none !important;
  background: #FFFFFF !important;
  background-color: #FFFFFF !important;
  border: 1px solid #C8C8C8 !important;
  color: #666666 !important;
  font-size: 12px;
}
::v-deep .da-pagination-wrap .v-pagination .v-pagination__item--active,
::v-deep .da-pagination-wrap .v-pagination .v-pagination__item--active.v-btn,
::v-deep .da-pagination-wrap .v-pagination .v-pagination__item--active .v-btn {
  background: #E9F9FD !important;
  background-color: #E9F9FD !important;
  border-color: #14C6DE !important;
  color: #14C6DE !important;
}
::v-deep .da-pagination-wrap .v-pagination .v-pagination__navigation--disabled {
  opacity: 1 !important;
  background: #FFFFFF !important;
  background-color: #FFFFFF !important;
  border-color: #E0E0E0 !important;
  color: #CCCCCC !important;
}
::v-deep .da-pagination-wrap .v-pagination .v-pagination__navigation .v-icon {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #666666 !important;
}
::v-deep .da-pagination-wrap .v-pagination .v-pagination__navigation--disabled .v-icon {
  color: #CCCCCC !important;
}
::v-deep .da-pagination-wrap .v-pagination .v-pagination__more {
  color: #999999;
  margin: 0 6px;
}
::v-deep #loading-container .da-index-number{
  color: #666;
}
::v-deep #loading-container .da-index-checkbox-btn .v-icon{
  line-height: 18px !important;
}
::v-deep #loading-container .da-index-checkbox-btn.is-checked .v-icon{ 
  color:#18bedf !important; 
}
::v-deep .da-record-review-btn {
  gap: 4px;
  border-radius: 4px;
  border: none !important;
}
::v-deep .da-record-review-icon {
  filter: brightness(0.667);
  flex: none;
  flex-grow: 0;
}
::v-deep .da-record-review-text {
  color: #666;
  font-size: 16px;
}
::v-deep .da-delete-btn{
  padding-bottom:10px ;
  border: none !important;
}
::v-deep .da-delete-btn .da-delete-text{
  color: #666;
  font-size: 16px;
}
::v-deep .da-delete-btn.v-btn--disabled .da-delete-text{
  color: #CCCCCC;
}
.da-col-toolbar {
  height: 5px;
  width: 100%;
  background: transparent;
  position: relative;
  z-index: 30;
  display: flex;
  align-items: stretch;
}
.da-col-toolbar-scroll {
  height: 28px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  scrollbar-width: none; /* Firefox */
}
.da-col-toolbar-scroll::-webkit-scrollbar {
  height: 0;
}
.da-col-toolbar-fixed{
  height: 28px;
  flex: 0 0 auto;
}
.da-col-insert-overlay{
  position: absolute;
  inset: 0;
  z-index: 50;
  pointer-events: none;
}
.da-col-highlight-line{
  position: absolute;
  top: 5px;
  bottom: 14px;
  width: 2px;
  background: #14C6DE;
  pointer-events: none;
}
.da-col-highlight-line.da-col-highlight-line--fileupload{
  bottom: 50px;
}
.da-insert-col-btn{
  position: absolute;
  top: -9px;
  transform: translateX(-50%);
  width: 14px !important;
  height: 14px !important;
  min-width: 14px !important;
  border-radius: 9999px !important;
  background: #fff !important;
  border: 2px solid #14C6DE !important;
  pointer-events: auto; /* 只有按鈕可點 */
  padding: 0 !important;
}
.da-insert-col-btn .v-icon{
  color: #14C6DE !important;
}
.da-file-cell--rejected {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 8px;
    width: 100%;
    overflow: hidden;
}
.da-cell-unsupported-icon { flex-shrink: 0; }
.da-cell-unsupported-text {
    color: #ED4242;
    font-size: 14px;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.da-col-info-icon {
    cursor: pointer;
    margin-left: 4px;
    opacity: 0.7;
    flex-shrink: 0;
}
.da-col-info-icon:hover { opacity: 1; }
</style>
<style lang="css">
.da-header-menu {
    width: 167px !important;
    min-width: 167px !important;
    max-width: 167px !important;
    box-shadow: 0 0 8px 0 rgba(153, 153, 153, 0.50) !important;
}
.da-header-menu .v-list-item {
    padding: 0 12px !important;
}
.da-header-menu .v-list-item__title {
    line-height: normal !important;
}
.da-info-tooltip {
    background: #FFFFFF !important;
    border: 1px solid #CCCCCC !important;
    box-shadow: 0px 0px 8px rgba(153, 153, 153, 0.5) !important;
    border-radius: 4px !important;
    color: #666666 !important;
    font-family: 'Segoe UI', sans-serif !important;
    font-size: 12px !important;
    letter-spacing: 0.5px !important;
    max-width: 360px !important;
    opacity: 1 !important;
}
.da-error-tooltip {
    background: #FFFFFF !important;
    border: 1px solid #CCCCCC !important;
    box-shadow: 0px 0px 8px rgba(153, 153, 153, 0.5) !important;
    border-radius: 4px !important;
    color: #ED4242 !important;
    font-family: 'Segoe UI', sans-serif !important;
    font-size: 12px !important;
    letter-spacing: 0.5px !important;
    max-width: 360px !important;
    opacity: 1 !important;
}
.da-cell-error-text {
    color: #ED4242;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    text-align: left;
}
.ref-action-btn {
  min-width: 0 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 6px !important;
  background: transparent !important;
  text-transform: none !important;
  box-shadow: none !important;
}
.ref-action-btn::before {
  display: none !important;
}
.ref-action-btn,
.ref-action-btn .v-btn__content,
.ref-action-btn .v-icon,
.ref-action-btn .v-btn__content span {
  color: #666 !important;
}
.ref-action-btn:hover {
  background: #eee !important;
}
.ref-action-btn:focus,
.ref-action-btn:active {
  background: #e8e8e8 !important;
}
.ref-action-btn:focus,
.ref-action-btn:focus .v-btn__content,
.ref-action-btn:focus .v-icon,
.ref-action-btn:focus .v-btn__content span,
.ref-action-btn:active,
.ref-action-btn:active .v-btn__content,
.ref-action-btn:active .v-icon,
.ref-action-btn:active .v-btn__content span {
  color: #444 !important;
}
/* ── 三模式按鈕群組 ── */
.ref-mode-btns {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    background: #F2EEE6;
    border-radius: 999px;
    flex-shrink: 0;
    margin: 0;
}
/* ── 單顆按鈕：default ── */
.ref-mode-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 32px;
    padding: 0 16px;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: #666;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    appearance: none;
    -webkit-appearance: none;
    transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}
.ref-mode-btn img {
    display: block;
    flex: 0 0 auto;
}
.ref-mode-btn span {
    display: block;
}
.ref-mode-btn:hover:not(:disabled) {
    background: #FCFBF7;
    color: #666;
}
.ref-mode-btn--active {
    background: #FFFFFF;
    color: #444;
}
.ref-mode-btn:focus,
.ref-mode-btn:focus-visible,
.ref-mode-btn:active {
    outline: none !important;
    box-shadow: none !important;
}
.ref-mode-btn::-moz-focus-inner {
    border: 0;
}
.ref-mode-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.ref-mode-btn:disabled:hover {
    background: transparent;
    color: #666;
}
.ref-action-btn--header {
    margin-left: 0;
    flex-shrink: 0;
}
/* ── PDF 預覽模式容器 ── */
.ref-pdf-preview-container {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.ref-pdf-iframe {
    flex: 1;
    width: 100%;
    min-height: 0;
    border: none;
}

.ref-pdf-error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #999;
    font-size: 14px;
    padding: 16px;
    text-align: center;
}

.ref-pdf-load-hint {
    padding: 8px 16px;
    color: #999999;
    font-size: 13px;
    text-align: center;
}

.ref-pdf-fetch-error-hint {
    padding: 8px 0;
    color: #999999;
    font-size: 14px;
}
.ref-pdf-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.ref-search-card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  user-select: text;
  cursor: text;
}

.ref-search-card {
  background: #F3F3EE;
  border: 1px solid #cccccc;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.ref-search-card__title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}

.ref-search-card__index {
  flex: 0 0 auto;
  min-width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #f3f4f6;
  color: #666;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  font-weight: 600;
}

.ref-search-card__title {
  color: #444 !important;
  font-size: 18px;
  line-height: 1.5;
  font-weight: 700;
  text-decoration: none;
  word-break: break-word;
}

a.ref-search-card__title:hover {
  text-decoration: underline;
}

.ref-search-card__content {
  color: #444;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 10px;
}

.ref-search-card__footer {
  display: flex;
  align-items: center;
}

.ref-search-card__site {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
}

/* ── Task 2-1: 表頭排序 ───────────────────────────────── */
.da-th-left {
  gap: 4px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.da-th-right {
  flex: none;
  gap: 4px;
}
/* 把右側按鈕群組改為 flex 以容納 sort/filter */
::v-deep #loading-container .ve-th-menu {
  gap: 0;
}
.da-sort-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 3px;
  line-height: 1;
  transition: background 0.15s;
}
.da-sort-btn:hover {
  background: #F0F0F0;
}
.da-sort-icon {
  display: block;
  object-fit: contain;
}
/* 未排序時箭頭預設隱藏，hover 表頭時顯示 */
.da-sort-icon--idle {
  opacity: 0;
  transition: opacity 0.15s;
}
#loading-container .ve-table-header-th:hover .da-sort-icon--idle {
  opacity: 1;
}
.da-sort-priority {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 17px;
  height: 16px;
  padding: 0 6px;
  border-radius: 10px;
  background: #C3DBF0;
  color: #666666;
  font-size: 12px;
  line-height: 1;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  letter-spacing: 0.5px;
  margin-left: 1px;
}

/* ── Task 3-1: 篩選按鈕 & 篩選面板 ───────────────────── */
.da-filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 3px;
  line-height: 1;
  transition: background 0.15s;
  opacity: 0;
}
#loading-container .ve-table-header-th:hover .da-filter-btn {
  opacity: 1;
}
.da-filter-btn--active {
  opacity: 1 !important;
}
.da-filter-btn:hover {
  background: #F0F0F0;
}
.da-filter-icon {
  display: block;
  object-fit: contain;
}
.da-filter-overlay {
  position: fixed;
  inset: 0;
  z-index: 9997;
  background: transparent;
}
.da-filter-panel {
  position: fixed;
  z-index: 9998;
  background: #FFFFFF;
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(153, 153, 153, 0.5);
  padding: 15px 13px 13px;
  width: 312px;
  min-width: 312px;
  max-width: 312px;
}
/* 面板標題列 */
.da-filter-panel-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #F0F0F0;
  margin-bottom: 10px;
  cursor: default;
}
.da-filter-title {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  letter-spacing: 0.5px;
}
/* 篩選條件列 */
.da-filter-condition-row {
  gap: 8px;
}
.da-filter-op-spacer {
  width: 110px;
  min-width: 110px;
  flex: none;
}
.da-filter-op-select {
  width: 110px;
  min-width: 110px;
  max-width: 110px;
  flex: none;
}
.da-filter-op-select .v-input__append-inner,
.da-filter-value-input .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}
.da-filter-op-select .v-input__slot,
.da-filter-value-input .v-input__slot {
  min-height: 28px !important;
  height: 28px !important;
  border-color: #888888 !important;
  border-radius: 4px !important;
}
.da-filter-op-select .v-input__control,
.da-filter-op-select .v-select__selection,
.da-filter-op-select input {
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #333333;
}
.da-filter-value-input {
  flex: 1;
  min-width: 0;
}
.da-filter-value-input .v-input__control,
.da-filter-value-input input {
  font-size: 14px;
  letter-spacing: 0.5px;
}
.da-filter-value-input input::placeholder {
  color: #999999;
}
/* 清除 / 套用 按鈕共用基底 */
.da-filter-clear-btn.v-btn,
.da-filter-apply-btn.v-btn {
  width: 80px;
  min-width: 80px !important;
  height: 29px !important;
  border-radius: 4px !important;
  padding: 4px 8px !important;
  box-shadow: none !important;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-transform: none;
}
/* 清除按鈕 */
.da-filter-clear-btn.v-btn {
  border: 1px solid #888888 !important;
  background: transparent !important;
  color: #666666;
}
/* 套用按鈕 */
.da-filter-apply-btn.v-btn {
  background: #14C6DE !important;
  border: none !important;
  color: #FFFFFF !important;
}
/* 三點選單排序列 */
.da-sort-menu-row {
  cursor: default !important;
}
.da-sort-dir-btn {
  width: 24px !important;
  height: 24px !important;
}
::v-deep .da-sort-menu-row .v-list-item__content {
  padding: 0;
}

/* ── Task 4-1: 排序/篩選狀態列 ───────────────────────── */
.da-sort-filter-bar {
  gap: 8px 16px;
  padding: 16px 0 8px 0px;
  flex: 0 0 auto;
  flex-wrap: wrap;
}
.da-bar-section {
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.da-bar-label {
  gap: 4px;
  flex: none;
}
.da-bar-icon {
  display: block;
  object-fit: contain;
  flex: none;
}
.da-bar-clear-icon {
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
  margin-right: 3px;
}
.da-chip-dir-icon {
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
  flex: none;
}
.da-bar-label-text {
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #444444;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.da-status-chip.v-chip {
  height: 24px !important;
  border-radius: 12px !important;
  background: #F4F4F4 !important;
  border: 1px solid #CCCCCC !important;
  padding: 0 4px 0 8px !important;
}
.da-status-chip.v-chip .v-chip__content {
  font-family: 'Segoe UI', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  letter-spacing: 0.5px;
}
.da-status-chip.v-chip .v-chip__close {
  color: #666666 !important;
  font-size: 16px !important;
  padding-left: 4px;
  padding-right: 8px;
}
.da-bar-clear-btn.v-btn {
  width: 80px;
  min-width: 80px !important;
  height: 28px !important;
  border-radius: 4px !important;
  padding: 2px 8px !important;
  background: transparent !important;
  box-shadow: none !important;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.5px;
  text-transform: none;
}
.da-bar-clear-btn.v-btn:hover {
  background: #F5F5F5 !important;
}
.da-bar-separator {
  width: 0;
  height: 24px;
  border-left: 1px solid #CCCCCC;
  flex: none;
}
.da-clear-all-btn {
  font-size: 12px !important;
  color: #999 !important;
  letter-spacing: 0;
  text-transform: none;
  padding: 0 6px !important;
  min-width: 0 !important;
  height: 22px !important;
}
.da-clear-all-btn:hover {
  color: #666 !important;
}
.da-bar-separator {
  width: 1px;
  height: 16px;
  background: #DDD;
  margin: 0 2px;
  align-self: center;
}
</style>
